/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SkillsAssessmentRouteRouteImport } from './routes/skills-assessment/route'
import { Route as SignupRouteRouteImport } from './routes/signup/route'
import { Route as CoreSkillsAssessmentRouteRouteImport } from './routes/core-skills-assessment/route'
import { Route as CompanyRouteRouteImport } from './routes/company/route'
import { Route as LearningRouteRouteImport } from './routes/_learning/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SkillsAssessmentIndexRouteImport } from './routes/skills-assessment/index'
import { Route as LoginIndexRouteImport } from './routes/login.index'
import { Route as SkillsAssessmentWelcomeRouteImport } from './routes/skills-assessment/welcome'
import { Route as SkillsAssessmentResultsInitialRouteImport } from './routes/skills-assessment/results-initial'
import { Route as SkillsAssessmentResultsFinalRouteImport } from './routes/skills-assessment/results-final'
import { Route as SkillsAssessmentPollStaticRouteImport } from './routes/skills-assessment/poll-static'
import { Route as SkillsAssessmentPollDynamicRouteImport } from './routes/skills-assessment/poll-dynamic'
import { Route as SignupProfileRouteImport } from './routes/signup/profile'
import { Route as SignupPollRouteImport } from './routes/signup/poll'
import { Route as SignupEmailRouteImport } from './routes/signup/email'
import { Route as SignupSlugRouteImport } from './routes/signup/$slug'
import { Route as RegistrationSsoSourceIdRouteImport } from './routes/registration.$ssoSourceId'
import { Route as LoginSsoSourceIdRouteImport } from './routes/login.$ssoSourceId'
import { Route as ConsentsConsentKeyRouteImport } from './routes/consents.$consentKey'
import { Route as UserSettingsRouteRouteImport } from './routes/user.settings/route'
import { Route as CompanyManagementRouteRouteImport } from './routes/company/_management/route'
import { Route as LearningGrowthMapRouteRouteImport } from './routes/_learning/growth-map/route'
import { Route as LearningDiscoverRouteRouteImport } from './routes/_learning/discover/route'
import { Route as LearningMyLearningRouteRouteImport } from './routes/_learning/_my-learning/route'
import { Route as LearningCompanyRouteRouteImport } from './routes/_learning/_company/route'
import { Route as LearningGrowthMapIndexRouteImport } from './routes/_learning/growth-map/index'
import { Route as UserSettingsSecurityRouteImport } from './routes/user.settings/security'
import { Route as UserSettingsPersonalDataRouteImport } from './routes/user.settings/personal-data'
import { Route as UserSettingsGeneralSettingsRouteImport } from './routes/user.settings/general-settings'
import { Route as SignupWelcomeChar123UuidChar125RouteImport } from './routes/signup/welcome.{-$uuid}'
import { Route as SignupCredentialsChar123UuidChar125RouteImport } from './routes/signup/credentials.{-$uuid}'
import { Route as CompanyLearnpathsAddRouteImport } from './routes/company/learnpaths/add'
import { Route as LearningHomeActivitiesRouteImport } from './routes/_learning/home.activities'
import { Route as LearningHomeOverviewRouteImport } from './routes/_learning/home/_overview'
import { Route as LearningGrowthMapSkillSlugRouteImport } from './routes/_learning/growth-map/$skillSlug'
import { Route as LearningGlossaryChar123LetterChar125RouteImport } from './routes/_learning/glossary.{-$letter}'
import { Route as LearningDiscoverCourseGenericRouteImport } from './routes/_learning/discover/course-generic'
import { Route as LearningDiscoverChannelsRouteImport } from './routes/_learning/discover/channels'
import { Route as LearningCoursesTopicRouteImport } from './routes/_learning/courses.$topic'
import { Route as LearningMyLearningCertificatesRouteImport } from './routes/_learning/_my-learning/certificates'
import { Route as LearningMyLearningAchievementsRouteImport } from './routes/_learning/_my-learning/achievements'
import { Route as LearningCompanyLearngroupRouteImport } from './routes/_learning/_company/learngroup'
import { Route as LearningCompanyExclusiveContentRouteImport } from './routes/_learning/_company/exclusive-content'
import { Route as CompanyMembersGroupsRouteRouteImport } from './routes/company/members.groups/route'
import { Route as CompanyManagementUsersRouteRouteImport } from './routes/company/_management/users/route'
import { Route as CompanyManagementSettingsRouteRouteImport } from './routes/company/_management/settings/route'
import { Route as CompanyManagementLicensesStructureRouteRouteImport } from './routes/company/_management/licenses-structure/route'
import { Route as CompanyManagementGroupsRouteRouteImport } from './routes/company/_management/groups/route'
import { Route as CompanyManagementEventsRouteRouteImport } from './routes/company/_management/events/route'
import { Route as CompanyManagementBatchOperationsRouteRouteImport } from './routes/company/_management/batch-operations/route'
import { Route as CompanyManagementAuditLogRouteRouteImport } from './routes/company/_management/audit-log/route'
import { Route as CompanyManagementAnalyticsRouteRouteImport } from './routes/company/_management/analytics/route'
import { Route as CompanyManagementAiAssistantDebugRouteRouteImport } from './routes/company/_management/ai-assistant-debug/route'
import { Route as CompanyManagementAiAssistantRouteRouteImport } from './routes/company/_management/ai-assistant/route'
import { Route as CompanyManagementActivitiesRouteRouteImport } from './routes/company/_management/activities/route'
import { Route as LearningCompanyListRouteRouteImport } from './routes/_learning/_company/_list/route'
import { Route as CompanyManagementIndexRouteRouteImport } from './routes/company/_management/index/route'
import { Route as CompanyManagementSettingsIndexRouteImport } from './routes/company/_management/settings/index'
import { Route as CompanyManagementAnalyticsIndexRouteImport } from './routes/company/_management/analytics/index'
import { Route as LearningHomeOverviewIndexRouteImport } from './routes/_learning/home/_overview.index'
import { Route as LearningDiscoverdeprecatedIndexRouteImport } from './routes/_learning/discover/(deprecated)/index'
import { Route as CompanyMembersGroupsAddGroupRouteImport } from './routes/company/members.groups/add-group'
import { Route as CompanyLearnpathsAddGeneralInformationCourseRouteImport } from './routes/company/learnpaths/add/general-information-course'
import { Route as CompanyManagementUsersUserIdRouteImport } from './routes/company/_management/users/$userId'
import { Route as CompanyManagementSettingsRolesRouteImport } from './routes/company/_management/settings/roles'
import { Route as CompanyManagementLicensesStructureNodeIdRouteImport } from './routes/company/_management/licenses-structure/$nodeId'
import { Route as CompanyManagementLearnpathsOverviewRouteImport } from './routes/company/_management/learnpaths/overview'
import { Route as CompanyManagementInviteRoleRouteImport } from './routes/company/_management/invite/$role'
import { Route as CompanyManagementGroupsAddRouteImport } from './routes/company/_management/groups/add'
import { Route as CompanyManagementEventsOverviewRouteImport } from './routes/company/_management/events/overview'
import { Route as CompanyManagementEventsAddRouteImport } from './routes/company/_management/events/add'
import { Route as CompanyManagementCoursesOverviewRouteImport } from './routes/company/_management/courses/overview'
import { Route as CompanyManagementAnalyticsPowerSkillsRouteImport } from './routes/company/_management/analytics/power-skills'
import { Route as CompanyManagementAnalyticsPerformanceRouteImport } from './routes/company/_management/analytics/performance'
import { Route as CompanyManagementAnalyticsLearningPathsRouteImport } from './routes/company/_management/analytics/learning-paths'
import { Route as CompanyManagementAnalyticsContentRouteImport } from './routes/company/_management/analytics/content'
import { Route as CompanyManagementAnalyticsCompanyOverviewRouteImport } from './routes/company/_management/analytics/company-overview'
import { Route as LearningLearnpathsLearnpathIdChar123ElementIdChar125RouteImport } from './routes/_learning/learnpaths.$learnpathId.{-$elementId}'
import { Route as LearningDiscoverSearchQueryRouteImport } from './routes/_learning/discover/search.$query'
import { Route as LearningDiscoverCourseGenericCourseSlugRouteImport } from './routes/_learning/discover/course-generic.$courseSlug'
import { Route as LearningDiscoverChannelsViewRouteImport } from './routes/_learning/discover/channels.view'
import { Route as LearningDiscoverChannelsOverviewRouteImport } from './routes/_learning/discover/channels._overview'
import { Route as LearningDiscoverChannelsChannelRouteImport } from './routes/_learning/discover/channels.$channel'
import { Route as LearningDiscoverdeprecatedGrundlagenkursDigitalisierungRouteImport } from './routes/_learning/discover/(deprecated)/grundlagenkurs-digitalisierung'
import { Route as LearningDiscoverdeprecatedChannelSlugRouteImport } from './routes/_learning/discover/(deprecated)/$channelSlug'
import { Route as LearningMyLearningUserProgressRouteImport } from './routes/_learning/_my-learning/user.progress'
import { Route as LearningMyLearningHomeNotesRouteImport } from './routes/_learning/_my-learning/home.notes'
import { Route as LearningMyLearningHomeBookmarkedRouteImport } from './routes/_learning/_my-learning/home.bookmarked'
import { Route as LearningCompanyListLearnpathsRouteImport } from './routes/_learning/_company/_list/learnpaths'
import { Route as LearningCompanyListCompanyCoursesRouteImport } from './routes/_learning/_company/_list/company-courses'
import { Route as LearningdeprecatedDashboardCertificatesRouteImport } from './routes/_learning/(deprecated)/dashboard.certificates'
import { Route as LearningdeprecatedDashboardCertificateRouteImport } from './routes/_learning/(deprecated)/dashboard.certificate'
import { Route as CompanyManagementGroupsGroupIdRouteRouteImport } from './routes/company/_management/groups/$groupId/route'
import { Route as CompanyManagementBatchOperationsUploadRouteRouteImport } from './routes/company/_management/batch-operations/upload/route'
import { Route as CompanyLearnpathsAddGeneralInformationIndexRouteImport } from './routes/company/learnpaths/add/general-information/index'
import { Route as CompanyManagementUsersUserIdIndexRouteImport } from './routes/company/_management/users/$userId.index'
import { Route as CompanyManagementEventsAddIndexRouteImport } from './routes/company/_management/events/add.index'
import { Route as LearningSkillSkillTopicIndexRouteImport } from './routes/_learning/skill/$skill.$topic.index'
import { Route as LearningDiscoverCourseGenericCourseSlugIndexRouteImport } from './routes/_learning/discover/course-generic.$courseSlug.index'
import { Route as LearningDiscoverChannelsOverviewIndexRouteImport } from './routes/_learning/discover/channels._overview.index'
import { Route as LearningCourseGenericCourseTopicIndexRouteImport } from './routes/_learning/course-generic/$course.$topic.index'
import { Route as LearningChannelChannelTopicIndexRouteImport } from './routes/_learning/channel/$channel.$topic.index'
import { Route as CompanyLearnpathsAddLearnersLearnpathIdRouteImport } from './routes/company/learnpaths/add/learners/$learnpathId'
import { Route as CompanyLearnpathsAddGeneralInformationLearnpathIdRouteImport } from './routes/company/learnpaths/add/general-information/$learnpathId'
import { Route as CompanyLearnpathsAddCompletionTimeLearnpathIdRouteImport } from './routes/company/learnpaths/add/completion-time/$learnpathId'
import { Route as CompanyManagementUsersUserIdUserGroupsRouteImport } from './routes/company/_management/users/$userId.user-groups'
import { Route as CompanyManagementUsersUserIdLicensesRouteImport } from './routes/company/_management/users/$userId.licenses'
import { Route as CompanyManagementUsersUserIdLearningPathsRouteImport } from './routes/company/_management/users/$userId.learning-paths'
import { Route as CompanyManagementLicensesStructureNodeIdPanelRouteImport } from './routes/company/_management/licenses-structure/$nodeId._panel'
import { Route as CompanyManagementLearnpathsOverviewLearnpathIdRouteImport } from './routes/company/_management/learnpaths/overview.$learnpathId'
import { Route as CompanyManagementEventsAddMediaIdRouteImport } from './routes/company/_management/events/add.$mediaId'
import { Route as LearningPollPollIdSourceSourceIdRouteImport } from './routes/_learning/poll.$pollId.$source.$sourceId'
import { Route as LearningLearnpathsLearnpathIdElementIdSuffixRouteImport } from './routes/_learning/learnpaths.$learnpathId.$elementId.$suffix'
import { Route as LearningDiscoverCourseGenericCourseSlugThemeSlugRouteImport } from './routes/_learning/discover/course-generic.$courseSlug.$themeSlug'
import { Route as LearningMyLearningCertificateCertificateIdPollRouteImport } from './routes/_learning/_my-learning/certificate.$certificateId.poll'
import { Route as LearningMyLearningCertificateCertificateIdPersonalizeRouteImport } from './routes/_learning/_my-learning/certificate.$certificateId.personalize'
import { Route as LearningCompanyExclusiveContentViewTopicRouteImport } from './routes/_learning/_company/exclusive-content.view.$topic'
import { Route as CompanyLearnpathsAddElementsLearnpathIdRouteRouteImport } from './routes/company/learnpaths/add/elements/$learnpathId/route'
import { Route as CompanyManagementGroupsGroupIdMembersRouteRouteImport } from './routes/company/_management/groups/$groupId/members/route'
import { Route as CompanyManagementGroupsGroupIdLearnpathsRouteRouteImport } from './routes/company/_management/groups/$groupId/learnpaths/route'
import { Route as CompanyManagementGroupsGroupIdDetailsRouteRouteImport } from './routes/company/_management/groups/$groupId/details/route'
import { Route as CompanyManagementLicensesStructureNodeIdPanelIndexRouteImport } from './routes/company/_management/licenses-structure/$nodeId._panel.index'
import { Route as CompanyManagementLearnpathsOverviewLearnpathIdIndexRouteImport } from './routes/company/_management/learnpaths/overview.$learnpathId.index'
import { Route as CompanyManagementLicensesStructureNodeIdLearnerLearnerIdRouteImport } from './routes/company/_management/licenses-structure/$nodeId.learner.$learnerId'
import { Route as CompanyManagementLicensesStructureNodeIdPanelLearnersRouteImport } from './routes/company/_management/licenses-structure/$nodeId._panel.learners'
import { Route as CompanyManagementLearnpathsOverviewLearnpathIdTranslationsRouteImport } from './routes/company/_management/learnpaths/overview.$learnpathId.translations'
import { Route as CompanyManagementLearnpathsOverviewLearnpathIdReportsRouteImport } from './routes/company/_management/learnpaths/overview.$learnpathId.reports'
import { Route as CompanyManagementLearnpathsOverviewLearnpathIdReleasesRouteImport } from './routes/company/_management/learnpaths/overview.$learnpathId.releases'
import { Route as CompanyManagementLearnpathsOverviewLearnpathIdProgressUserGroupsRouteImport } from './routes/company/_management/learnpaths/overview.$learnpathId.progress-user-groups'
import { Route as CompanyManagementLearnpathsOverviewLearnpathIdProgressRouteImport } from './routes/company/_management/learnpaths/overview.$learnpathId.progress'
import { Route as CompanyManagementLearnpathsOverviewLearnpathIdDetailsRouteImport } from './routes/company/_management/learnpaths/overview.$learnpathId.details'
import { Route as CompanyManagementGroupsGroupIdMembersAddRouteImport } from './routes/company/_management/groups/$groupId/members/add'
import { Route as CompanyManagementEventsOverviewMediaIdTabRouteImport } from './routes/company/_management/events/overview.$mediaId.$tab'
import { Route as CompanyManagementCoursesOverviewMediaIdTabRouteImport } from './routes/company/_management/courses/overview.$mediaId.$tab'
import { Route as LearningLecturesTopicChar123LectureChar125Char123SuffixChar125Char123IdChar125RouteImport } from './routes/_learning/lectures.$topic.{-$lecture}.{-$suffix}.{-$id}'
import { Route as LearningHomeOverviewViewChannelTopicRouteImport } from './routes/_learning/home/_overview.view.$channel.$topic'
import { Route as LearningDiscoverSearchQueryViewTopicRouteImport } from './routes/_learning/discover/search.$query.view.$topic'
import { Route as LearningDiscoverChannelsChannelViewTopicRouteImport } from './routes/_learning/discover/channels.$channel.view.$topic'
import { Route as LearningMyLearningUserProgressViewTopicRouteImport } from './routes/_learning/_my-learning/user.progress.view.$topic'
import { Route as LearningCompanyListLearnpathsViewLearnpathIdRouteImport } from './routes/_learning/_company/_list/learnpaths.view.$learnpathId'
import { Route as LearningCompanyListCompanyCoursesViewLearnpathIdRouteImport } from './routes/_learning/_company/_list/company-courses.view.$learnpathId'
import { Route as LearningSkillSkillTopicLectureChar123SuffixChar125Char123IdChar125RouteImport } from './routes/_learning/skill/$skill.$topic.$lecture.{-$suffix}.{-$id}'
import { Route as LearningLearnpathsLearnpathIdElementIdTopicLectureChar123SuffixChar125RouteImport } from './routes/_learning/learnpaths.$learnpathId.$elementId.$topic.$lecture.{-$suffix}'
import { Route as LearningDiscoverChannelsOverviewViewChannelTopicRouteImport } from './routes/_learning/discover/channels._overview.view.$channel.$topic'
import { Route as LearningCourseCourseThemeTopicLectureChar123SuffixChar125RouteImport } from './routes/_learning/course.$course.$theme.$topic.$lecture.{-$suffix}'
import { Route as LearningCourseGenericCourseTopicLectureChar123SuffixChar125Char123IdChar125RouteImport } from './routes/_learning/course-generic/$course.$topic.$lecture.{-$suffix}.{-$id}'
import { Route as LearningChannelChannelTopicLectureChar123SuffixChar125Char123IdChar125RouteImport } from './routes/_learning/channel/$channel.$topic.$lecture.{-$suffix}.{-$id}'
import { Route as CompanyLearnpathsAddElementsLearnpathIdvideoCreateVideoRouteImport } from './routes/company/learnpaths/add/elements/$learnpathId/(video)/create.video'
import { Route as CompanyLearnpathsAddElementsLearnpathIdtextCreateTextRouteImport } from './routes/company/learnpaths/add/elements/$learnpathId/(text)/create.text'
import { Route as CompanyLearnpathsAddElementsLearnpathIdscormCreateScormRouteImport } from './routes/company/learnpaths/add/elements/$learnpathId/(scorm)/create.scorm'
import { Route as CompanyLearnpathsAddElementsLearnpathIdquizCreateQuizRouteImport } from './routes/company/learnpaths/add/elements/$learnpathId/(quiz)/create.quiz'
import { Route as CompanyLearnpathsAddElementsLearnpathIdplatformTopicCreatePlatformTopicRouteImport } from './routes/company/learnpaths/add/elements/$learnpathId/(platform-topic)/create.platform-topic'
import { Route as CompanyLearnpathsAddElementsLearnpathIdlinkCreateLinkRouteImport } from './routes/company/learnpaths/add/elements/$learnpathId/(link)/create.link'
import { Route as CompanyLearnpathsAddElementsLearnpathIdfileCreateFileRouteImport } from './routes/company/learnpaths/add/elements/$learnpathId/(file)/create.file'
import { Route as CompanyLearnpathsAddElementsLearnpathIdeventCreateEventRouteImport } from './routes/company/learnpaths/add/elements/$learnpathId/(event)/create.event'
import { Route as CompanyLearnpathsAddElementsLearnpathIdembeddedVideoCreateEmbeddedVideoRouteImport } from './routes/company/learnpaths/add/elements/$learnpathId/(embedded-video)/create.embedded-video'
import { Route as LearningCompanyListLearnpathsViewLearnpathIdChar123ElementIdChar125Char123TopicChar125RouteImport } from './routes/_learning/_company/_list/learnpaths.view.$learnpathId.{-$elementId}.{-$topic}'
import { Route as LearningCompanyListCompanyCoursesViewLearnpathIdChar123ElementIdChar125Char123TopicChar125RouteImport } from './routes/_learning/_company/_list/company-courses.view.$learnpathId.{-$elementId}.{-$topic}'
import { Route as CompanyLearnpathsAddElementsLearnpathIdvideoUpdateVideoElementIdRouteImport } from './routes/company/learnpaths/add/elements/$learnpathId/(video)/update.video.$elementId'
import { Route as CompanyLearnpathsAddElementsLearnpathIdvideoDeleteVideoElementIdRouteImport } from './routes/company/learnpaths/add/elements/$learnpathId/(video)/delete.video.$elementId'
import { Route as CompanyLearnpathsAddElementsLearnpathIdtextUpdateTextElementIdRouteImport } from './routes/company/learnpaths/add/elements/$learnpathId/(text)/update.text.$elementId'
import { Route as CompanyLearnpathsAddElementsLearnpathIdtextDeleteTextElementIdRouteImport } from './routes/company/learnpaths/add/elements/$learnpathId/(text)/delete.text.$elementId'
import { Route as CompanyLearnpathsAddElementsLearnpathIdscormUpdateScormElementIdRouteImport } from './routes/company/learnpaths/add/elements/$learnpathId/(scorm)/update.scorm.$elementId'
import { Route as CompanyLearnpathsAddElementsLearnpathIdscormDeleteScormElementIdRouteImport } from './routes/company/learnpaths/add/elements/$learnpathId/(scorm)/delete.scorm.$elementId'
import { Route as CompanyLearnpathsAddElementsLearnpathIdquizUpdateQuizElementIdRouteImport } from './routes/company/learnpaths/add/elements/$learnpathId/(quiz)/update.quiz.$elementId'
import { Route as CompanyLearnpathsAddElementsLearnpathIdquizDeleteQuizElementIdRouteImport } from './routes/company/learnpaths/add/elements/$learnpathId/(quiz)/delete.quiz.$elementId'
import { Route as CompanyLearnpathsAddElementsLearnpathIdplatformTopicUpdatePlatformTopicElementIdRouteImport } from './routes/company/learnpaths/add/elements/$learnpathId/(platform-topic)/update.platform-topic.$elementId'
import { Route as CompanyLearnpathsAddElementsLearnpathIdplatformTopicDeletePlatformTopicElementIdRouteImport } from './routes/company/learnpaths/add/elements/$learnpathId/(platform-topic)/delete.platform-topic.$elementId'
import { Route as CompanyLearnpathsAddElementsLearnpathIdlinkUpdateLinkElementIdRouteImport } from './routes/company/learnpaths/add/elements/$learnpathId/(link)/update.link.$elementId'
import { Route as CompanyLearnpathsAddElementsLearnpathIdlinkDeleteLinkElementIdRouteImport } from './routes/company/learnpaths/add/elements/$learnpathId/(link)/delete.link.$elementId'
import { Route as CompanyLearnpathsAddElementsLearnpathIdfileUpdateFileElementIdRouteImport } from './routes/company/learnpaths/add/elements/$learnpathId/(file)/update.file.$elementId'
import { Route as CompanyLearnpathsAddElementsLearnpathIdfileDeleteFileElementIdRouteImport } from './routes/company/learnpaths/add/elements/$learnpathId/(file)/delete.file.$elementId'
import { Route as CompanyLearnpathsAddElementsLearnpathIdeventUpdateEventElementIdRouteImport } from './routes/company/learnpaths/add/elements/$learnpathId/(event)/update.event.$elementId'
import { Route as CompanyLearnpathsAddElementsLearnpathIdeventDeleteEventElementIdRouteImport } from './routes/company/learnpaths/add/elements/$learnpathId/(event)/delete.event.$elementId'
import { Route as CompanyLearnpathsAddElementsLearnpathIdembeddedVideoUpdateEmbeddedVideoElementIdRouteImport } from './routes/company/learnpaths/add/elements/$learnpathId/(embedded-video)/update.embedded-video.$elementId'
import { Route as CompanyLearnpathsAddElementsLearnpathIdembeddedVideoDeleteEmbeddedVideoElementIdRouteImport } from './routes/company/learnpaths/add/elements/$learnpathId/(embedded-video)/delete.embedded-video.$elementId'
import { Route as CompanyLearnpathsAddElementsLearnpathIdvideoUpdateVideoElementIdAssetIdRouteImport } from './routes/company/learnpaths/add/elements/$learnpathId/(video)/update.video.$elementId.$assetId'
import { Route as CompanyLearnpathsAddElementsLearnpathIdvideoCreateVideoElementIdAssetIdRouteImport } from './routes/company/learnpaths/add/elements/$learnpathId/(video)/create.video.$elementId.$assetId'
import { Route as CompanyLearnpathsAddElementsLearnpathIdfileUpdateFileElementIdAssetIdRouteImport } from './routes/company/learnpaths/add/elements/$learnpathId/(file)/update.file.$elementId.$assetId'
import { Route as CompanyLearnpathsAddElementsLearnpathIdfileCreateFileElementIdAssetIdRouteImport } from './routes/company/learnpaths/add/elements/$learnpathId/(file)/create.file.$elementId.$assetId'
import { Route as CompanyLearnpathsAddElementsLearnpathIdplatformTopicUpdatePlatformTopicElementIdPreviewTopicIdLectureIdRouteImport } from './routes/company/learnpaths/add/elements/$learnpathId/(platform-topic)/update.platform-topic.$elementId.preview.$topicId.$lectureId'
import { Route as CompanyLearnpathsAddElementsLearnpathIdplatformTopicCreatePlatformTopicElementIdPreviewTopicIdLectureIdRouteImport } from './routes/company/learnpaths/add/elements/$learnpathId/(platform-topic)/create.platform-topic.$elementId.preview.$topicId.$lectureId'

const SkillsAssessmentRouteRoute = SkillsAssessmentRouteRouteImport.update({
  id: '/skills-assessment',
  path: '/skills-assessment',
  getParentRoute: () => rootRouteImport,
} as any)
const SignupRouteRoute = SignupRouteRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const CoreSkillsAssessmentRouteRoute =
  CoreSkillsAssessmentRouteRouteImport.update({
    id: '/core-skills-assessment',
    path: '/core-skills-assessment',
    getParentRoute: () => rootRouteImport,
  } as any)
const CompanyRouteRoute = CompanyRouteRouteImport.update({
  id: '/company',
  path: '/company',
  getParentRoute: () => rootRouteImport,
} as any)
const LearningRouteRoute = LearningRouteRouteImport.update({
  id: '/_learning',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const SkillsAssessmentIndexRoute = SkillsAssessmentIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SkillsAssessmentRouteRoute,
} as any)
const LoginIndexRoute = LoginIndexRouteImport.update({
  id: '/login/',
  path: '/login/',
  getParentRoute: () => rootRouteImport,
} as any)
const SkillsAssessmentWelcomeRoute = SkillsAssessmentWelcomeRouteImport.update({
  id: '/welcome',
  path: '/welcome',
  getParentRoute: () => SkillsAssessmentRouteRoute,
} as any)
const SkillsAssessmentResultsInitialRoute =
  SkillsAssessmentResultsInitialRouteImport.update({
    id: '/results-initial',
    path: '/results-initial',
    getParentRoute: () => SkillsAssessmentRouteRoute,
  } as any)
const SkillsAssessmentResultsFinalRoute =
  SkillsAssessmentResultsFinalRouteImport.update({
    id: '/results-final',
    path: '/results-final',
    getParentRoute: () => SkillsAssessmentRouteRoute,
  } as any)
const SkillsAssessmentPollStaticRoute =
  SkillsAssessmentPollStaticRouteImport.update({
    id: '/poll-static',
    path: '/poll-static',
    getParentRoute: () => SkillsAssessmentRouteRoute,
  } as any)
const SkillsAssessmentPollDynamicRoute =
  SkillsAssessmentPollDynamicRouteImport.update({
    id: '/poll-dynamic',
    path: '/poll-dynamic',
    getParentRoute: () => SkillsAssessmentRouteRoute,
  } as any)
const SignupProfileRoute = SignupProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => SignupRouteRoute,
} as any)
const SignupPollRoute = SignupPollRouteImport.update({
  id: '/poll',
  path: '/poll',
  getParentRoute: () => SignupRouteRoute,
} as any)
const SignupEmailRoute = SignupEmailRouteImport.update({
  id: '/email',
  path: '/email',
  getParentRoute: () => SignupRouteRoute,
} as any)
const SignupSlugRoute = SignupSlugRouteImport.update({
  id: '/$slug',
  path: '/$slug',
  getParentRoute: () => SignupRouteRoute,
} as any)
const RegistrationSsoSourceIdRoute = RegistrationSsoSourceIdRouteImport.update({
  id: '/registration/$ssoSourceId',
  path: '/registration/$ssoSourceId',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginSsoSourceIdRoute = LoginSsoSourceIdRouteImport.update({
  id: '/login/$ssoSourceId',
  path: '/login/$ssoSourceId',
  getParentRoute: () => rootRouteImport,
} as any)
const ConsentsConsentKeyRoute = ConsentsConsentKeyRouteImport.update({
  id: '/consents/$consentKey',
  path: '/consents/$consentKey',
  getParentRoute: () => rootRouteImport,
} as any)
const UserSettingsRouteRoute = UserSettingsRouteRouteImport.update({
  id: '/user/settings',
  path: '/user/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const CompanyManagementRouteRoute = CompanyManagementRouteRouteImport.update({
  id: '/_management',
  getParentRoute: () => CompanyRouteRoute,
} as any)
const LearningGrowthMapRouteRoute = LearningGrowthMapRouteRouteImport.update({
  id: '/growth-map',
  path: '/growth-map',
  getParentRoute: () => LearningRouteRoute,
} as any)
const LearningDiscoverRouteRoute = LearningDiscoverRouteRouteImport.update({
  id: '/discover',
  path: '/discover',
  getParentRoute: () => LearningRouteRoute,
} as any)
const LearningMyLearningRouteRoute = LearningMyLearningRouteRouteImport.update({
  id: '/_my-learning',
  getParentRoute: () => LearningRouteRoute,
} as any)
const LearningCompanyRouteRoute = LearningCompanyRouteRouteImport.update({
  id: '/_company',
  getParentRoute: () => LearningRouteRoute,
} as any)
const LearningGrowthMapIndexRoute = LearningGrowthMapIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => LearningGrowthMapRouteRoute,
} as any)
const UserSettingsSecurityRoute = UserSettingsSecurityRouteImport.update({
  id: '/security',
  path: '/security',
  getParentRoute: () => UserSettingsRouteRoute,
} as any)
const UserSettingsPersonalDataRoute =
  UserSettingsPersonalDataRouteImport.update({
    id: '/personal-data',
    path: '/personal-data',
    getParentRoute: () => UserSettingsRouteRoute,
  } as any)
const UserSettingsGeneralSettingsRoute =
  UserSettingsGeneralSettingsRouteImport.update({
    id: '/general-settings',
    path: '/general-settings',
    getParentRoute: () => UserSettingsRouteRoute,
  } as any)
const SignupWelcomeChar123UuidChar125Route =
  SignupWelcomeChar123UuidChar125RouteImport.update({
    id: '/welcome/{-$uuid}',
    path: '/welcome/{-$uuid}',
    getParentRoute: () => SignupRouteRoute,
  } as any)
const SignupCredentialsChar123UuidChar125Route =
  SignupCredentialsChar123UuidChar125RouteImport.update({
    id: '/credentials/{-$uuid}',
    path: '/credentials/{-$uuid}',
    getParentRoute: () => SignupRouteRoute,
  } as any)
const CompanyLearnpathsAddRoute = CompanyLearnpathsAddRouteImport.update({
  id: '/learnpaths/add',
  path: '/learnpaths/add',
  getParentRoute: () => CompanyRouteRoute,
} as any)
const LearningHomeActivitiesRoute = LearningHomeActivitiesRouteImport.update({
  id: '/home/activities',
  path: '/home/activities',
  getParentRoute: () => LearningRouteRoute,
} as any)
const LearningHomeOverviewRoute = LearningHomeOverviewRouteImport.update({
  id: '/home/_overview',
  path: '/home',
  getParentRoute: () => LearningRouteRoute,
} as any)
const LearningGrowthMapSkillSlugRoute =
  LearningGrowthMapSkillSlugRouteImport.update({
    id: '/$skillSlug',
    path: '/$skillSlug',
    getParentRoute: () => LearningGrowthMapRouteRoute,
  } as any)
const LearningGlossaryChar123LetterChar125Route =
  LearningGlossaryChar123LetterChar125RouteImport.update({
    id: '/glossary/{-$letter}',
    path: '/glossary/{-$letter}',
    getParentRoute: () => LearningRouteRoute,
  } as any)
const LearningDiscoverCourseGenericRoute =
  LearningDiscoverCourseGenericRouteImport.update({
    id: '/course-generic',
    path: '/course-generic',
    getParentRoute: () => LearningDiscoverRouteRoute,
  } as any)
const LearningDiscoverChannelsRoute =
  LearningDiscoverChannelsRouteImport.update({
    id: '/channels',
    path: '/channels',
    getParentRoute: () => LearningDiscoverRouteRoute,
  } as any)
const LearningCoursesTopicRoute = LearningCoursesTopicRouteImport.update({
  id: '/courses/$topic',
  path: '/courses/$topic',
  getParentRoute: () => LearningRouteRoute,
} as any)
const LearningMyLearningCertificatesRoute =
  LearningMyLearningCertificatesRouteImport.update({
    id: '/certificates',
    path: '/certificates',
    getParentRoute: () => LearningMyLearningRouteRoute,
  } as any)
const LearningMyLearningAchievementsRoute =
  LearningMyLearningAchievementsRouteImport.update({
    id: '/achievements',
    path: '/achievements',
    getParentRoute: () => LearningMyLearningRouteRoute,
  } as any)
const LearningCompanyLearngroupRoute =
  LearningCompanyLearngroupRouteImport.update({
    id: '/learngroup',
    path: '/learngroup',
    getParentRoute: () => LearningCompanyRouteRoute,
  } as any)
const LearningCompanyExclusiveContentRoute =
  LearningCompanyExclusiveContentRouteImport.update({
    id: '/exclusive-content',
    path: '/exclusive-content',
    getParentRoute: () => LearningCompanyRouteRoute,
  } as any)
const CompanyMembersGroupsRouteRoute =
  CompanyMembersGroupsRouteRouteImport.update({
    id: '/members/groups',
    path: '/members/groups',
    getParentRoute: () => CompanyRouteRoute,
  } as any)
const CompanyManagementUsersRouteRoute =
  CompanyManagementUsersRouteRouteImport.update({
    id: '/users',
    path: '/users',
    getParentRoute: () => CompanyManagementRouteRoute,
  } as any)
const CompanyManagementSettingsRouteRoute =
  CompanyManagementSettingsRouteRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => CompanyManagementRouteRoute,
  } as any)
const CompanyManagementLicensesStructureRouteRoute =
  CompanyManagementLicensesStructureRouteRouteImport.update({
    id: '/licenses-structure',
    path: '/licenses-structure',
    getParentRoute: () => CompanyManagementRouteRoute,
  } as any)
const CompanyManagementGroupsRouteRoute =
  CompanyManagementGroupsRouteRouteImport.update({
    id: '/groups',
    path: '/groups',
    getParentRoute: () => CompanyManagementRouteRoute,
  } as any)
const CompanyManagementEventsRouteRoute =
  CompanyManagementEventsRouteRouteImport.update({
    id: '/events',
    path: '/events',
    getParentRoute: () => CompanyManagementRouteRoute,
  } as any)
const CompanyManagementBatchOperationsRouteRoute =
  CompanyManagementBatchOperationsRouteRouteImport.update({
    id: '/batch-operations',
    path: '/batch-operations',
    getParentRoute: () => CompanyManagementRouteRoute,
  } as any)
const CompanyManagementAuditLogRouteRoute =
  CompanyManagementAuditLogRouteRouteImport.update({
    id: '/audit-log',
    path: '/audit-log',
    getParentRoute: () => CompanyManagementRouteRoute,
  } as any)
const CompanyManagementAnalyticsRouteRoute =
  CompanyManagementAnalyticsRouteRouteImport.update({
    id: '/analytics',
    path: '/analytics',
    getParentRoute: () => CompanyManagementRouteRoute,
  } as any)
const CompanyManagementAiAssistantDebugRouteRoute =
  CompanyManagementAiAssistantDebugRouteRouteImport.update({
    id: '/ai-assistant-debug',
    path: '/ai-assistant-debug',
    getParentRoute: () => CompanyManagementRouteRoute,
  } as any)
const CompanyManagementAiAssistantRouteRoute =
  CompanyManagementAiAssistantRouteRouteImport.update({
    id: '/ai-assistant',
    path: '/ai-assistant',
    getParentRoute: () => CompanyManagementRouteRoute,
  } as any)
const CompanyManagementActivitiesRouteRoute =
  CompanyManagementActivitiesRouteRouteImport.update({
    id: '/activities',
    path: '/activities',
    getParentRoute: () => CompanyManagementRouteRoute,
  } as any)
const LearningCompanyListRouteRoute =
  LearningCompanyListRouteRouteImport.update({
    id: '/_list',
    getParentRoute: () => LearningCompanyRouteRoute,
  } as any)
const CompanyManagementIndexRouteRoute =
  CompanyManagementIndexRouteRouteImport.update({
    id: '/',
    path: '',
    getParentRoute: () => CompanyManagementRouteRoute,
  } as any)
const CompanyManagementSettingsIndexRoute =
  CompanyManagementSettingsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => CompanyManagementSettingsRouteRoute,
  } as any)
const CompanyManagementAnalyticsIndexRoute =
  CompanyManagementAnalyticsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => CompanyManagementAnalyticsRouteRoute,
  } as any)
const LearningHomeOverviewIndexRoute =
  LearningHomeOverviewIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => LearningHomeOverviewRoute,
  } as any)
const LearningDiscoverdeprecatedIndexRoute =
  LearningDiscoverdeprecatedIndexRouteImport.update({
    id: '/(deprecated)/',
    path: '/',
    getParentRoute: () => LearningDiscoverRouteRoute,
  } as any)
const CompanyMembersGroupsAddGroupRoute =
  CompanyMembersGroupsAddGroupRouteImport.update({
    id: '/add-group',
    path: '/add-group',
    getParentRoute: () => CompanyMembersGroupsRouteRoute,
  } as any)
const CompanyLearnpathsAddGeneralInformationCourseRoute =
  CompanyLearnpathsAddGeneralInformationCourseRouteImport.update({
    id: '/general-information-course',
    path: '/general-information-course',
    getParentRoute: () => CompanyLearnpathsAddRoute,
  } as any)
const CompanyManagementUsersUserIdRoute =
  CompanyManagementUsersUserIdRouteImport.update({
    id: '/$userId',
    path: '/$userId',
    getParentRoute: () => CompanyManagementUsersRouteRoute,
  } as any)
const CompanyManagementSettingsRolesRoute =
  CompanyManagementSettingsRolesRouteImport.update({
    id: '/roles',
    path: '/roles',
    getParentRoute: () => CompanyManagementSettingsRouteRoute,
  } as any)
const CompanyManagementLicensesStructureNodeIdRoute =
  CompanyManagementLicensesStructureNodeIdRouteImport.update({
    id: '/$nodeId',
    path: '/$nodeId',
    getParentRoute: () => CompanyManagementLicensesStructureRouteRoute,
  } as any)
const CompanyManagementLearnpathsOverviewRoute =
  CompanyManagementLearnpathsOverviewRouteImport.update({
    id: '/learnpaths/overview',
    path: '/learnpaths/overview',
    getParentRoute: () => CompanyManagementRouteRoute,
  } as any)
const CompanyManagementInviteRoleRoute =
  CompanyManagementInviteRoleRouteImport.update({
    id: '/invite/$role',
    path: '/invite/$role',
    getParentRoute: () => CompanyManagementRouteRoute,
  } as any)
const CompanyManagementGroupsAddRoute =
  CompanyManagementGroupsAddRouteImport.update({
    id: '/add',
    path: '/add',
    getParentRoute: () => CompanyManagementGroupsRouteRoute,
  } as any)
const CompanyManagementEventsOverviewRoute =
  CompanyManagementEventsOverviewRouteImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () => CompanyManagementEventsRouteRoute,
  } as any)
const CompanyManagementEventsAddRoute =
  CompanyManagementEventsAddRouteImport.update({
    id: '/add',
    path: '/add',
    getParentRoute: () => CompanyManagementEventsRouteRoute,
  } as any)
const CompanyManagementCoursesOverviewRoute =
  CompanyManagementCoursesOverviewRouteImport.update({
    id: '/courses/overview',
    path: '/courses/overview',
    getParentRoute: () => CompanyManagementRouteRoute,
  } as any)
const CompanyManagementAnalyticsPowerSkillsRoute =
  CompanyManagementAnalyticsPowerSkillsRouteImport.update({
    id: '/power-skills',
    path: '/power-skills',
    getParentRoute: () => CompanyManagementAnalyticsRouteRoute,
  } as any)
const CompanyManagementAnalyticsPerformanceRoute =
  CompanyManagementAnalyticsPerformanceRouteImport.update({
    id: '/performance',
    path: '/performance',
    getParentRoute: () => CompanyManagementAnalyticsRouteRoute,
  } as any)
const CompanyManagementAnalyticsLearningPathsRoute =
  CompanyManagementAnalyticsLearningPathsRouteImport.update({
    id: '/learning-paths',
    path: '/learning-paths',
    getParentRoute: () => CompanyManagementAnalyticsRouteRoute,
  } as any)
const CompanyManagementAnalyticsContentRoute =
  CompanyManagementAnalyticsContentRouteImport.update({
    id: '/content',
    path: '/content',
    getParentRoute: () => CompanyManagementAnalyticsRouteRoute,
  } as any)
const CompanyManagementAnalyticsCompanyOverviewRoute =
  CompanyManagementAnalyticsCompanyOverviewRouteImport.update({
    id: '/company-overview',
    path: '/company-overview',
    getParentRoute: () => CompanyManagementAnalyticsRouteRoute,
  } as any)
const LearningLearnpathsLearnpathIdChar123ElementIdChar125Route =
  LearningLearnpathsLearnpathIdChar123ElementIdChar125RouteImport.update({
    id: '/learnpaths/$learnpathId/{-$elementId}',
    path: '/learnpaths/$learnpathId/{-$elementId}',
    getParentRoute: () => LearningRouteRoute,
  } as any)
const LearningDiscoverSearchQueryRoute =
  LearningDiscoverSearchQueryRouteImport.update({
    id: '/search/$query',
    path: '/search/$query',
    getParentRoute: () => LearningDiscoverRouteRoute,
  } as any)
const LearningDiscoverCourseGenericCourseSlugRoute =
  LearningDiscoverCourseGenericCourseSlugRouteImport.update({
    id: '/$courseSlug',
    path: '/$courseSlug',
    getParentRoute: () => LearningDiscoverCourseGenericRoute,
  } as any)
const LearningDiscoverChannelsViewRoute =
  LearningDiscoverChannelsViewRouteImport.update({
    id: '/view',
    path: '/view',
    getParentRoute: () => LearningDiscoverChannelsRoute,
  } as any)
const LearningDiscoverChannelsOverviewRoute =
  LearningDiscoverChannelsOverviewRouteImport.update({
    id: '/_overview',
    getParentRoute: () => LearningDiscoverChannelsRoute,
  } as any)
const LearningDiscoverChannelsChannelRoute =
  LearningDiscoverChannelsChannelRouteImport.update({
    id: '/$channel',
    path: '/$channel',
    getParentRoute: () => LearningDiscoverChannelsRoute,
  } as any)
const LearningDiscoverdeprecatedGrundlagenkursDigitalisierungRoute =
  LearningDiscoverdeprecatedGrundlagenkursDigitalisierungRouteImport.update({
    id: '/(deprecated)/grundlagenkurs-digitalisierung',
    path: '/grundlagenkurs-digitalisierung',
    getParentRoute: () => LearningDiscoverRouteRoute,
  } as any)
const LearningDiscoverdeprecatedChannelSlugRoute =
  LearningDiscoverdeprecatedChannelSlugRouteImport.update({
    id: '/(deprecated)/$channelSlug',
    path: '/$channelSlug',
    getParentRoute: () => LearningDiscoverRouteRoute,
  } as any)
const LearningMyLearningUserProgressRoute =
  LearningMyLearningUserProgressRouteImport.update({
    id: '/user/progress',
    path: '/user/progress',
    getParentRoute: () => LearningMyLearningRouteRoute,
  } as any)
const LearningMyLearningHomeNotesRoute =
  LearningMyLearningHomeNotesRouteImport.update({
    id: '/home/notes',
    path: '/home/notes',
    getParentRoute: () => LearningMyLearningRouteRoute,
  } as any)
const LearningMyLearningHomeBookmarkedRoute =
  LearningMyLearningHomeBookmarkedRouteImport.update({
    id: '/home/bookmarked',
    path: '/home/bookmarked',
    getParentRoute: () => LearningMyLearningRouteRoute,
  } as any)
const LearningCompanyListLearnpathsRoute =
  LearningCompanyListLearnpathsRouteImport.update({
    id: '/learnpaths',
    path: '/learnpaths',
    getParentRoute: () => LearningCompanyListRouteRoute,
  } as any)
const LearningCompanyListCompanyCoursesRoute =
  LearningCompanyListCompanyCoursesRouteImport.update({
    id: '/company-courses',
    path: '/company-courses',
    getParentRoute: () => LearningCompanyListRouteRoute,
  } as any)
const LearningdeprecatedDashboardCertificatesRoute =
  LearningdeprecatedDashboardCertificatesRouteImport.update({
    id: '/(deprecated)/dashboard/certificates',
    path: '/dashboard/certificates',
    getParentRoute: () => LearningRouteRoute,
  } as any)
const LearningdeprecatedDashboardCertificateRoute =
  LearningdeprecatedDashboardCertificateRouteImport.update({
    id: '/(deprecated)/dashboard/certificate',
    path: '/dashboard/certificate',
    getParentRoute: () => LearningRouteRoute,
  } as any)
const CompanyManagementGroupsGroupIdRouteRoute =
  CompanyManagementGroupsGroupIdRouteRouteImport.update({
    id: '/$groupId',
    path: '/$groupId',
    getParentRoute: () => CompanyManagementGroupsRouteRoute,
  } as any)
const CompanyManagementBatchOperationsUploadRouteRoute =
  CompanyManagementBatchOperationsUploadRouteRouteImport.update({
    id: '/upload',
    path: '/upload',
    getParentRoute: () => CompanyManagementBatchOperationsRouteRoute,
  } as any)
const CompanyLearnpathsAddGeneralInformationIndexRoute =
  CompanyLearnpathsAddGeneralInformationIndexRouteImport.update({
    id: '/general-information/',
    path: '/general-information/',
    getParentRoute: () => CompanyLearnpathsAddRoute,
  } as any)
const CompanyManagementUsersUserIdIndexRoute =
  CompanyManagementUsersUserIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => CompanyManagementUsersUserIdRoute,
  } as any)
const CompanyManagementEventsAddIndexRoute =
  CompanyManagementEventsAddIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => CompanyManagementEventsAddRoute,
  } as any)
const LearningSkillSkillTopicIndexRoute =
  LearningSkillSkillTopicIndexRouteImport.update({
    id: '/skill/$skill/$topic/',
    path: '/skill/$skill/$topic/',
    getParentRoute: () => LearningRouteRoute,
  } as any)
const LearningDiscoverCourseGenericCourseSlugIndexRoute =
  LearningDiscoverCourseGenericCourseSlugIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => LearningDiscoverCourseGenericCourseSlugRoute,
  } as any)
const LearningDiscoverChannelsOverviewIndexRoute =
  LearningDiscoverChannelsOverviewIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => LearningDiscoverChannelsOverviewRoute,
  } as any)
const LearningCourseGenericCourseTopicIndexRoute =
  LearningCourseGenericCourseTopicIndexRouteImport.update({
    id: '/course-generic/$course/$topic/',
    path: '/course-generic/$course/$topic/',
    getParentRoute: () => LearningRouteRoute,
  } as any)
const LearningChannelChannelTopicIndexRoute =
  LearningChannelChannelTopicIndexRouteImport.update({
    id: '/channel/$channel/$topic/',
    path: '/channel/$channel/$topic/',
    getParentRoute: () => LearningRouteRoute,
  } as any)
const CompanyLearnpathsAddLearnersLearnpathIdRoute =
  CompanyLearnpathsAddLearnersLearnpathIdRouteImport.update({
    id: '/learners/$learnpathId',
    path: '/learners/$learnpathId',
    getParentRoute: () => CompanyLearnpathsAddRoute,
  } as any)
const CompanyLearnpathsAddGeneralInformationLearnpathIdRoute =
  CompanyLearnpathsAddGeneralInformationLearnpathIdRouteImport.update({
    id: '/general-information/$learnpathId',
    path: '/general-information/$learnpathId',
    getParentRoute: () => CompanyLearnpathsAddRoute,
  } as any)
const CompanyLearnpathsAddCompletionTimeLearnpathIdRoute =
  CompanyLearnpathsAddCompletionTimeLearnpathIdRouteImport.update({
    id: '/completion-time/$learnpathId',
    path: '/completion-time/$learnpathId',
    getParentRoute: () => CompanyLearnpathsAddRoute,
  } as any)
const CompanyManagementUsersUserIdUserGroupsRoute =
  CompanyManagementUsersUserIdUserGroupsRouteImport.update({
    id: '/user-groups',
    path: '/user-groups',
    getParentRoute: () => CompanyManagementUsersUserIdRoute,
  } as any)
const CompanyManagementUsersUserIdLicensesRoute =
  CompanyManagementUsersUserIdLicensesRouteImport.update({
    id: '/licenses',
    path: '/licenses',
    getParentRoute: () => CompanyManagementUsersUserIdRoute,
  } as any)
const CompanyManagementUsersUserIdLearningPathsRoute =
  CompanyManagementUsersUserIdLearningPathsRouteImport.update({
    id: '/learning-paths',
    path: '/learning-paths',
    getParentRoute: () => CompanyManagementUsersUserIdRoute,
  } as any)
const CompanyManagementLicensesStructureNodeIdPanelRoute =
  CompanyManagementLicensesStructureNodeIdPanelRouteImport.update({
    id: '/_panel',
    getParentRoute: () => CompanyManagementLicensesStructureNodeIdRoute,
  } as any)
const CompanyManagementLearnpathsOverviewLearnpathIdRoute =
  CompanyManagementLearnpathsOverviewLearnpathIdRouteImport.update({
    id: '/$learnpathId',
    path: '/$learnpathId',
    getParentRoute: () => CompanyManagementLearnpathsOverviewRoute,
  } as any)
const CompanyManagementEventsAddMediaIdRoute =
  CompanyManagementEventsAddMediaIdRouteImport.update({
    id: '/$mediaId',
    path: '/$mediaId',
    getParentRoute: () => CompanyManagementEventsAddRoute,
  } as any)
const LearningPollPollIdSourceSourceIdRoute =
  LearningPollPollIdSourceSourceIdRouteImport.update({
    id: '/poll/$pollId/$source/$sourceId',
    path: '/poll/$pollId/$source/$sourceId',
    getParentRoute: () => LearningRouteRoute,
  } as any)
const LearningLearnpathsLearnpathIdElementIdSuffixRoute =
  LearningLearnpathsLearnpathIdElementIdSuffixRouteImport.update({
    id: '/learnpaths/$learnpathId/$elementId/$suffix',
    path: '/learnpaths/$learnpathId/$elementId/$suffix',
    getParentRoute: () => LearningRouteRoute,
  } as any)
const LearningDiscoverCourseGenericCourseSlugThemeSlugRoute =
  LearningDiscoverCourseGenericCourseSlugThemeSlugRouteImport.update({
    id: '/$themeSlug',
    path: '/$themeSlug',
    getParentRoute: () => LearningDiscoverCourseGenericCourseSlugRoute,
  } as any)
const LearningMyLearningCertificateCertificateIdPollRoute =
  LearningMyLearningCertificateCertificateIdPollRouteImport.update({
    id: '/certificate/$certificateId/poll',
    path: '/certificate/$certificateId/poll',
    getParentRoute: () => LearningMyLearningRouteRoute,
  } as any)
const LearningMyLearningCertificateCertificateIdPersonalizeRoute =
  LearningMyLearningCertificateCertificateIdPersonalizeRouteImport.update({
    id: '/certificate/$certificateId/personalize',
    path: '/certificate/$certificateId/personalize',
    getParentRoute: () => LearningMyLearningRouteRoute,
  } as any)
const LearningCompanyExclusiveContentViewTopicRoute =
  LearningCompanyExclusiveContentViewTopicRouteImport.update({
    id: '/view/$topic',
    path: '/view/$topic',
    getParentRoute: () => LearningCompanyExclusiveContentRoute,
  } as any)
const CompanyLearnpathsAddElementsLearnpathIdRouteRoute =
  CompanyLearnpathsAddElementsLearnpathIdRouteRouteImport.update({
    id: '/elements/$learnpathId',
    path: '/elements/$learnpathId',
    getParentRoute: () => CompanyLearnpathsAddRoute,
  } as any)
const CompanyManagementGroupsGroupIdMembersRouteRoute =
  CompanyManagementGroupsGroupIdMembersRouteRouteImport.update({
    id: '/members',
    path: '/members',
    getParentRoute: () => CompanyManagementGroupsGroupIdRouteRoute,
  } as any)
const CompanyManagementGroupsGroupIdLearnpathsRouteRoute =
  CompanyManagementGroupsGroupIdLearnpathsRouteRouteImport.update({
    id: '/learnpaths',
    path: '/learnpaths',
    getParentRoute: () => CompanyManagementGroupsGroupIdRouteRoute,
  } as any)
const CompanyManagementGroupsGroupIdDetailsRouteRoute =
  CompanyManagementGroupsGroupIdDetailsRouteRouteImport.update({
    id: '/details',
    path: '/details',
    getParentRoute: () => CompanyManagementGroupsGroupIdRouteRoute,
  } as any)
const CompanyManagementLicensesStructureNodeIdPanelIndexRoute =
  CompanyManagementLicensesStructureNodeIdPanelIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => CompanyManagementLicensesStructureNodeIdPanelRoute,
  } as any)
const CompanyManagementLearnpathsOverviewLearnpathIdIndexRoute =
  CompanyManagementLearnpathsOverviewLearnpathIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => CompanyManagementLearnpathsOverviewLearnpathIdRoute,
  } as any)
const CompanyManagementLicensesStructureNodeIdLearnerLearnerIdRoute =
  CompanyManagementLicensesStructureNodeIdLearnerLearnerIdRouteImport.update({
    id: '/learner/$learnerId',
    path: '/learner/$learnerId',
    getParentRoute: () => CompanyManagementLicensesStructureNodeIdRoute,
  } as any)
const CompanyManagementLicensesStructureNodeIdPanelLearnersRoute =
  CompanyManagementLicensesStructureNodeIdPanelLearnersRouteImport.update({
    id: '/learners',
    path: '/learners',
    getParentRoute: () => CompanyManagementLicensesStructureNodeIdPanelRoute,
  } as any)
const CompanyManagementLearnpathsOverviewLearnpathIdTranslationsRoute =
  CompanyManagementLearnpathsOverviewLearnpathIdTranslationsRouteImport.update({
    id: '/translations',
    path: '/translations',
    getParentRoute: () => CompanyManagementLearnpathsOverviewLearnpathIdRoute,
  } as any)
const CompanyManagementLearnpathsOverviewLearnpathIdReportsRoute =
  CompanyManagementLearnpathsOverviewLearnpathIdReportsRouteImport.update({
    id: '/reports',
    path: '/reports',
    getParentRoute: () => CompanyManagementLearnpathsOverviewLearnpathIdRoute,
  } as any)
const CompanyManagementLearnpathsOverviewLearnpathIdReleasesRoute =
  CompanyManagementLearnpathsOverviewLearnpathIdReleasesRouteImport.update({
    id: '/releases',
    path: '/releases',
    getParentRoute: () => CompanyManagementLearnpathsOverviewLearnpathIdRoute,
  } as any)
const CompanyManagementLearnpathsOverviewLearnpathIdProgressUserGroupsRoute =
  CompanyManagementLearnpathsOverviewLearnpathIdProgressUserGroupsRouteImport.update(
    {
      id: '/progress-user-groups',
      path: '/progress-user-groups',
      getParentRoute: () => CompanyManagementLearnpathsOverviewLearnpathIdRoute,
    } as any,
  )
const CompanyManagementLearnpathsOverviewLearnpathIdProgressRoute =
  CompanyManagementLearnpathsOverviewLearnpathIdProgressRouteImport.update({
    id: '/progress',
    path: '/progress',
    getParentRoute: () => CompanyManagementLearnpathsOverviewLearnpathIdRoute,
  } as any)
const CompanyManagementLearnpathsOverviewLearnpathIdDetailsRoute =
  CompanyManagementLearnpathsOverviewLearnpathIdDetailsRouteImport.update({
    id: '/details',
    path: '/details',
    getParentRoute: () => CompanyManagementLearnpathsOverviewLearnpathIdRoute,
  } as any)
const CompanyManagementGroupsGroupIdMembersAddRoute =
  CompanyManagementGroupsGroupIdMembersAddRouteImport.update({
    id: '/add',
    path: '/add',
    getParentRoute: () => CompanyManagementGroupsGroupIdMembersRouteRoute,
  } as any)
const CompanyManagementEventsOverviewMediaIdTabRoute =
  CompanyManagementEventsOverviewMediaIdTabRouteImport.update({
    id: '/$mediaId/$tab',
    path: '/$mediaId/$tab',
    getParentRoute: () => CompanyManagementEventsOverviewRoute,
  } as any)
const CompanyManagementCoursesOverviewMediaIdTabRoute =
  CompanyManagementCoursesOverviewMediaIdTabRouteImport.update({
    id: '/$mediaId/$tab',
    path: '/$mediaId/$tab',
    getParentRoute: () => CompanyManagementCoursesOverviewRoute,
  } as any)
const LearningLecturesTopicChar123LectureChar125Char123SuffixChar125Char123IdChar125Route =
  LearningLecturesTopicChar123LectureChar125Char123SuffixChar125Char123IdChar125RouteImport.update(
    {
      id: '/lectures/$topic/{-$lecture}/{-$suffix}/{-$id}',
      path: '/lectures/$topic/{-$lecture}/{-$suffix}/{-$id}',
      getParentRoute: () => LearningRouteRoute,
    } as any,
  )
const LearningHomeOverviewViewChannelTopicRoute =
  LearningHomeOverviewViewChannelTopicRouteImport.update({
    id: '/view/$channel/$topic',
    path: '/view/$channel/$topic',
    getParentRoute: () => LearningHomeOverviewRoute,
  } as any)
const LearningDiscoverSearchQueryViewTopicRoute =
  LearningDiscoverSearchQueryViewTopicRouteImport.update({
    id: '/view/$topic',
    path: '/view/$topic',
    getParentRoute: () => LearningDiscoverSearchQueryRoute,
  } as any)
const LearningDiscoverChannelsChannelViewTopicRoute =
  LearningDiscoverChannelsChannelViewTopicRouteImport.update({
    id: '/view/$topic',
    path: '/view/$topic',
    getParentRoute: () => LearningDiscoverChannelsChannelRoute,
  } as any)
const LearningMyLearningUserProgressViewTopicRoute =
  LearningMyLearningUserProgressViewTopicRouteImport.update({
    id: '/view/$topic',
    path: '/view/$topic',
    getParentRoute: () => LearningMyLearningUserProgressRoute,
  } as any)
const LearningCompanyListLearnpathsViewLearnpathIdRoute =
  LearningCompanyListLearnpathsViewLearnpathIdRouteImport.update({
    id: '/view/$learnpathId',
    path: '/view/$learnpathId',
    getParentRoute: () => LearningCompanyListLearnpathsRoute,
  } as any)
const LearningCompanyListCompanyCoursesViewLearnpathIdRoute =
  LearningCompanyListCompanyCoursesViewLearnpathIdRouteImport.update({
    id: '/view/$learnpathId',
    path: '/view/$learnpathId',
    getParentRoute: () => LearningCompanyListCompanyCoursesRoute,
  } as any)
const LearningSkillSkillTopicLectureChar123SuffixChar125Char123IdChar125Route =
  LearningSkillSkillTopicLectureChar123SuffixChar125Char123IdChar125RouteImport.update(
    {
      id: '/skill/$skill/$topic/$lecture/{-$suffix}/{-$id}',
      path: '/skill/$skill/$topic/$lecture/{-$suffix}/{-$id}',
      getParentRoute: () => LearningRouteRoute,
    } as any,
  )
const LearningLearnpathsLearnpathIdElementIdTopicLectureChar123SuffixChar125Route =
  LearningLearnpathsLearnpathIdElementIdTopicLectureChar123SuffixChar125RouteImport.update(
    {
      id: '/learnpaths/$learnpathId/$elementId/$topic/$lecture/{-$suffix}',
      path: '/learnpaths/$learnpathId/$elementId/$topic/$lecture/{-$suffix}',
      getParentRoute: () => LearningRouteRoute,
    } as any,
  )
const LearningDiscoverChannelsOverviewViewChannelTopicRoute =
  LearningDiscoverChannelsOverviewViewChannelTopicRouteImport.update({
    id: '/view/$channel/$topic',
    path: '/view/$channel/$topic',
    getParentRoute: () => LearningDiscoverChannelsOverviewRoute,
  } as any)
const LearningCourseCourseThemeTopicLectureChar123SuffixChar125Route =
  LearningCourseCourseThemeTopicLectureChar123SuffixChar125RouteImport.update({
    id: '/course/$course/$theme/$topic/$lecture/{-$suffix}',
    path: '/course/$course/$theme/$topic/$lecture/{-$suffix}',
    getParentRoute: () => LearningRouteRoute,
  } as any)
const LearningCourseGenericCourseTopicLectureChar123SuffixChar125Char123IdChar125Route =
  LearningCourseGenericCourseTopicLectureChar123SuffixChar125Char123IdChar125RouteImport.update(
    {
      id: '/course-generic/$course/$topic/$lecture/{-$suffix}/{-$id}',
      path: '/course-generic/$course/$topic/$lecture/{-$suffix}/{-$id}',
      getParentRoute: () => LearningRouteRoute,
    } as any,
  )
const LearningChannelChannelTopicLectureChar123SuffixChar125Char123IdChar125Route =
  LearningChannelChannelTopicLectureChar123SuffixChar125Char123IdChar125RouteImport.update(
    {
      id: '/channel/$channel/$topic/$lecture/{-$suffix}/{-$id}',
      path: '/channel/$channel/$topic/$lecture/{-$suffix}/{-$id}',
      getParentRoute: () => LearningRouteRoute,
    } as any,
  )
const CompanyLearnpathsAddElementsLearnpathIdvideoCreateVideoRoute =
  CompanyLearnpathsAddElementsLearnpathIdvideoCreateVideoRouteImport.update({
    id: '/(video)/create/video',
    path: '/create/video',
    getParentRoute: () => CompanyLearnpathsAddElementsLearnpathIdRouteRoute,
  } as any)
const CompanyLearnpathsAddElementsLearnpathIdtextCreateTextRoute =
  CompanyLearnpathsAddElementsLearnpathIdtextCreateTextRouteImport.update({
    id: '/(text)/create/text',
    path: '/create/text',
    getParentRoute: () => CompanyLearnpathsAddElementsLearnpathIdRouteRoute,
  } as any)
const CompanyLearnpathsAddElementsLearnpathIdscormCreateScormRoute =
  CompanyLearnpathsAddElementsLearnpathIdscormCreateScormRouteImport.update({
    id: '/(scorm)/create/scorm',
    path: '/create/scorm',
    getParentRoute: () => CompanyLearnpathsAddElementsLearnpathIdRouteRoute,
  } as any)
const CompanyLearnpathsAddElementsLearnpathIdquizCreateQuizRoute =
  CompanyLearnpathsAddElementsLearnpathIdquizCreateQuizRouteImport.update({
    id: '/(quiz)/create/quiz',
    path: '/create/quiz',
    getParentRoute: () => CompanyLearnpathsAddElementsLearnpathIdRouteRoute,
  } as any)
const CompanyLearnpathsAddElementsLearnpathIdplatformTopicCreatePlatformTopicRoute =
  CompanyLearnpathsAddElementsLearnpathIdplatformTopicCreatePlatformTopicRouteImport.update(
    {
      id: '/(platform-topic)/create/platform-topic',
      path: '/create/platform-topic',
      getParentRoute: () => CompanyLearnpathsAddElementsLearnpathIdRouteRoute,
    } as any,
  )
const CompanyLearnpathsAddElementsLearnpathIdlinkCreateLinkRoute =
  CompanyLearnpathsAddElementsLearnpathIdlinkCreateLinkRouteImport.update({
    id: '/(link)/create/link',
    path: '/create/link',
    getParentRoute: () => CompanyLearnpathsAddElementsLearnpathIdRouteRoute,
  } as any)
const CompanyLearnpathsAddElementsLearnpathIdfileCreateFileRoute =
  CompanyLearnpathsAddElementsLearnpathIdfileCreateFileRouteImport.update({
    id: '/(file)/create/file',
    path: '/create/file',
    getParentRoute: () => CompanyLearnpathsAddElementsLearnpathIdRouteRoute,
  } as any)
const CompanyLearnpathsAddElementsLearnpathIdeventCreateEventRoute =
  CompanyLearnpathsAddElementsLearnpathIdeventCreateEventRouteImport.update({
    id: '/(event)/create/event',
    path: '/create/event',
    getParentRoute: () => CompanyLearnpathsAddElementsLearnpathIdRouteRoute,
  } as any)
const CompanyLearnpathsAddElementsLearnpathIdembeddedVideoCreateEmbeddedVideoRoute =
  CompanyLearnpathsAddElementsLearnpathIdembeddedVideoCreateEmbeddedVideoRouteImport.update(
    {
      id: '/(embedded-video)/create/embedded-video',
      path: '/create/embedded-video',
      getParentRoute: () => CompanyLearnpathsAddElementsLearnpathIdRouteRoute,
    } as any,
  )
const LearningCompanyListLearnpathsViewLearnpathIdChar123ElementIdChar125Char123TopicChar125Route =
  LearningCompanyListLearnpathsViewLearnpathIdChar123ElementIdChar125Char123TopicChar125RouteImport.update(
    {
      id: '/{-$elementId}/{-$topic}',
      path: '/{-$elementId}/{-$topic}',
      getParentRoute: () => LearningCompanyListLearnpathsViewLearnpathIdRoute,
    } as any,
  )
const LearningCompanyListCompanyCoursesViewLearnpathIdChar123ElementIdChar125Char123TopicChar125Route =
  LearningCompanyListCompanyCoursesViewLearnpathIdChar123ElementIdChar125Char123TopicChar125RouteImport.update(
    {
      id: '/{-$elementId}/{-$topic}',
      path: '/{-$elementId}/{-$topic}',
      getParentRoute: () =>
        LearningCompanyListCompanyCoursesViewLearnpathIdRoute,
    } as any,
  )
const CompanyLearnpathsAddElementsLearnpathIdvideoUpdateVideoElementIdRoute =
  CompanyLearnpathsAddElementsLearnpathIdvideoUpdateVideoElementIdRouteImport.update(
    {
      id: '/(video)/update/video/$elementId',
      path: '/update/video/$elementId',
      getParentRoute: () => CompanyLearnpathsAddElementsLearnpathIdRouteRoute,
    } as any,
  )
const CompanyLearnpathsAddElementsLearnpathIdvideoDeleteVideoElementIdRoute =
  CompanyLearnpathsAddElementsLearnpathIdvideoDeleteVideoElementIdRouteImport.update(
    {
      id: '/(video)/delete/video/$elementId',
      path: '/delete/video/$elementId',
      getParentRoute: () => CompanyLearnpathsAddElementsLearnpathIdRouteRoute,
    } as any,
  )
const CompanyLearnpathsAddElementsLearnpathIdtextUpdateTextElementIdRoute =
  CompanyLearnpathsAddElementsLearnpathIdtextUpdateTextElementIdRouteImport.update(
    {
      id: '/(text)/update/text/$elementId',
      path: '/update/text/$elementId',
      getParentRoute: () => CompanyLearnpathsAddElementsLearnpathIdRouteRoute,
    } as any,
  )
const CompanyLearnpathsAddElementsLearnpathIdtextDeleteTextElementIdRoute =
  CompanyLearnpathsAddElementsLearnpathIdtextDeleteTextElementIdRouteImport.update(
    {
      id: '/(text)/delete/text/$elementId',
      path: '/delete/text/$elementId',
      getParentRoute: () => CompanyLearnpathsAddElementsLearnpathIdRouteRoute,
    } as any,
  )
const CompanyLearnpathsAddElementsLearnpathIdscormUpdateScormElementIdRoute =
  CompanyLearnpathsAddElementsLearnpathIdscormUpdateScormElementIdRouteImport.update(
    {
      id: '/(scorm)/update/scorm/$elementId',
      path: '/update/scorm/$elementId',
      getParentRoute: () => CompanyLearnpathsAddElementsLearnpathIdRouteRoute,
    } as any,
  )
const CompanyLearnpathsAddElementsLearnpathIdscormDeleteScormElementIdRoute =
  CompanyLearnpathsAddElementsLearnpathIdscormDeleteScormElementIdRouteImport.update(
    {
      id: '/(scorm)/delete/scorm/$elementId',
      path: '/delete/scorm/$elementId',
      getParentRoute: () => CompanyLearnpathsAddElementsLearnpathIdRouteRoute,
    } as any,
  )
const CompanyLearnpathsAddElementsLearnpathIdquizUpdateQuizElementIdRoute =
  CompanyLearnpathsAddElementsLearnpathIdquizUpdateQuizElementIdRouteImport.update(
    {
      id: '/(quiz)/update/quiz/$elementId',
      path: '/update/quiz/$elementId',
      getParentRoute: () => CompanyLearnpathsAddElementsLearnpathIdRouteRoute,
    } as any,
  )
const CompanyLearnpathsAddElementsLearnpathIdquizDeleteQuizElementIdRoute =
  CompanyLearnpathsAddElementsLearnpathIdquizDeleteQuizElementIdRouteImport.update(
    {
      id: '/(quiz)/delete/quiz/$elementId',
      path: '/delete/quiz/$elementId',
      getParentRoute: () => CompanyLearnpathsAddElementsLearnpathIdRouteRoute,
    } as any,
  )
const CompanyLearnpathsAddElementsLearnpathIdplatformTopicUpdatePlatformTopicElementIdRoute =
  CompanyLearnpathsAddElementsLearnpathIdplatformTopicUpdatePlatformTopicElementIdRouteImport.update(
    {
      id: '/(platform-topic)/update/platform-topic/$elementId',
      path: '/update/platform-topic/$elementId',
      getParentRoute: () => CompanyLearnpathsAddElementsLearnpathIdRouteRoute,
    } as any,
  )
const CompanyLearnpathsAddElementsLearnpathIdplatformTopicDeletePlatformTopicElementIdRoute =
  CompanyLearnpathsAddElementsLearnpathIdplatformTopicDeletePlatformTopicElementIdRouteImport.update(
    {
      id: '/(platform-topic)/delete/platform-topic/$elementId',
      path: '/delete/platform-topic/$elementId',
      getParentRoute: () => CompanyLearnpathsAddElementsLearnpathIdRouteRoute,
    } as any,
  )
const CompanyLearnpathsAddElementsLearnpathIdlinkUpdateLinkElementIdRoute =
  CompanyLearnpathsAddElementsLearnpathIdlinkUpdateLinkElementIdRouteImport.update(
    {
      id: '/(link)/update/link/$elementId',
      path: '/update/link/$elementId',
      getParentRoute: () => CompanyLearnpathsAddElementsLearnpathIdRouteRoute,
    } as any,
  )
const CompanyLearnpathsAddElementsLearnpathIdlinkDeleteLinkElementIdRoute =
  CompanyLearnpathsAddElementsLearnpathIdlinkDeleteLinkElementIdRouteImport.update(
    {
      id: '/(link)/delete/link/$elementId',
      path: '/delete/link/$elementId',
      getParentRoute: () => CompanyLearnpathsAddElementsLearnpathIdRouteRoute,
    } as any,
  )
const CompanyLearnpathsAddElementsLearnpathIdfileUpdateFileElementIdRoute =
  CompanyLearnpathsAddElementsLearnpathIdfileUpdateFileElementIdRouteImport.update(
    {
      id: '/(file)/update/file/$elementId',
      path: '/update/file/$elementId',
      getParentRoute: () => CompanyLearnpathsAddElementsLearnpathIdRouteRoute,
    } as any,
  )
const CompanyLearnpathsAddElementsLearnpathIdfileDeleteFileElementIdRoute =
  CompanyLearnpathsAddElementsLearnpathIdfileDeleteFileElementIdRouteImport.update(
    {
      id: '/(file)/delete/file/$elementId',
      path: '/delete/file/$elementId',
      getParentRoute: () => CompanyLearnpathsAddElementsLearnpathIdRouteRoute,
    } as any,
  )
const CompanyLearnpathsAddElementsLearnpathIdeventUpdateEventElementIdRoute =
  CompanyLearnpathsAddElementsLearnpathIdeventUpdateEventElementIdRouteImport.update(
    {
      id: '/(event)/update/event/$elementId',
      path: '/update/event/$elementId',
      getParentRoute: () => CompanyLearnpathsAddElementsLearnpathIdRouteRoute,
    } as any,
  )
const CompanyLearnpathsAddElementsLearnpathIdeventDeleteEventElementIdRoute =
  CompanyLearnpathsAddElementsLearnpathIdeventDeleteEventElementIdRouteImport.update(
    {
      id: '/(event)/delete/event/$elementId',
      path: '/delete/event/$elementId',
      getParentRoute: () => CompanyLearnpathsAddElementsLearnpathIdRouteRoute,
    } as any,
  )
const CompanyLearnpathsAddElementsLearnpathIdembeddedVideoUpdateEmbeddedVideoElementIdRoute =
  CompanyLearnpathsAddElementsLearnpathIdembeddedVideoUpdateEmbeddedVideoElementIdRouteImport.update(
    {
      id: '/(embedded-video)/update/embedded-video/$elementId',
      path: '/update/embedded-video/$elementId',
      getParentRoute: () => CompanyLearnpathsAddElementsLearnpathIdRouteRoute,
    } as any,
  )
const CompanyLearnpathsAddElementsLearnpathIdembeddedVideoDeleteEmbeddedVideoElementIdRoute =
  CompanyLearnpathsAddElementsLearnpathIdembeddedVideoDeleteEmbeddedVideoElementIdRouteImport.update(
    {
      id: '/(embedded-video)/delete/embedded-video/$elementId',
      path: '/delete/embedded-video/$elementId',
      getParentRoute: () => CompanyLearnpathsAddElementsLearnpathIdRouteRoute,
    } as any,
  )
const CompanyLearnpathsAddElementsLearnpathIdvideoUpdateVideoElementIdAssetIdRoute =
  CompanyLearnpathsAddElementsLearnpathIdvideoUpdateVideoElementIdAssetIdRouteImport.update(
    {
      id: '/$assetId',
      path: '/$assetId',
      getParentRoute: () =>
        CompanyLearnpathsAddElementsLearnpathIdvideoUpdateVideoElementIdRoute,
    } as any,
  )
const CompanyLearnpathsAddElementsLearnpathIdvideoCreateVideoElementIdAssetIdRoute =
  CompanyLearnpathsAddElementsLearnpathIdvideoCreateVideoElementIdAssetIdRouteImport.update(
    {
      id: '/$elementId/$assetId',
      path: '/$elementId/$assetId',
      getParentRoute: () =>
        CompanyLearnpathsAddElementsLearnpathIdvideoCreateVideoRoute,
    } as any,
  )
const CompanyLearnpathsAddElementsLearnpathIdfileUpdateFileElementIdAssetIdRoute =
  CompanyLearnpathsAddElementsLearnpathIdfileUpdateFileElementIdAssetIdRouteImport.update(
    {
      id: '/$assetId',
      path: '/$assetId',
      getParentRoute: () =>
        CompanyLearnpathsAddElementsLearnpathIdfileUpdateFileElementIdRoute,
    } as any,
  )
const CompanyLearnpathsAddElementsLearnpathIdfileCreateFileElementIdAssetIdRoute =
  CompanyLearnpathsAddElementsLearnpathIdfileCreateFileElementIdAssetIdRouteImport.update(
    {
      id: '/$elementId/$assetId',
      path: '/$elementId/$assetId',
      getParentRoute: () =>
        CompanyLearnpathsAddElementsLearnpathIdfileCreateFileRoute,
    } as any,
  )
const CompanyLearnpathsAddElementsLearnpathIdplatformTopicUpdatePlatformTopicElementIdPreviewTopicIdLectureIdRoute =
  CompanyLearnpathsAddElementsLearnpathIdplatformTopicUpdatePlatformTopicElementIdPreviewTopicIdLectureIdRouteImport.update(
    {
      id: '/preview/$topicId/$lectureId',
      path: '/preview/$topicId/$lectureId',
      getParentRoute: () =>
        CompanyLearnpathsAddElementsLearnpathIdplatformTopicUpdatePlatformTopicElementIdRoute,
    } as any,
  )
const CompanyLearnpathsAddElementsLearnpathIdplatformTopicCreatePlatformTopicElementIdPreviewTopicIdLectureIdRoute =
  CompanyLearnpathsAddElementsLearnpathIdplatformTopicCreatePlatformTopicElementIdPreviewTopicIdLectureIdRouteImport.update(
    {
      id: '/$elementId/preview/$topicId/$lectureId',
      path: '/$elementId/preview/$topicId/$lectureId',
      getParentRoute: () =>
        CompanyLearnpathsAddElementsLearnpathIdplatformTopicCreatePlatformTopicRoute,
    } as any,
  )

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/company': typeof CompanyManagementRouteRouteWithChildren
  '/core-skills-assessment': typeof CoreSkillsAssessmentRouteRoute
  '/signup': typeof SignupRouteRouteWithChildren
  '/skills-assessment': typeof SkillsAssessmentRouteRouteWithChildren
  '/discover': typeof LearningDiscoverRouteRouteWithChildren
  '/growth-map': typeof LearningGrowthMapRouteRouteWithChildren
  '/user/settings': typeof UserSettingsRouteRouteWithChildren
  '/consents/$consentKey': typeof ConsentsConsentKeyRoute
  '/login/$ssoSourceId': typeof LoginSsoSourceIdRoute
  '/registration/$ssoSourceId': typeof RegistrationSsoSourceIdRoute
  '/signup/$slug': typeof SignupSlugRoute
  '/signup/email': typeof SignupEmailRoute
  '/signup/poll': typeof SignupPollRoute
  '/signup/profile': typeof SignupProfileRoute
  '/skills-assessment/poll-dynamic': typeof SkillsAssessmentPollDynamicRoute
  '/skills-assessment/poll-static': typeof SkillsAssessmentPollStaticRoute
  '/skills-assessment/results-final': typeof SkillsAssessmentResultsFinalRoute
  '/skills-assessment/results-initial': typeof SkillsAssessmentResultsInitialRoute
  '/skills-assessment/welcome': typeof SkillsAssessmentWelcomeRoute
  '/login/': typeof LoginIndexRoute
  '/skills-assessment/': typeof SkillsAssessmentIndexRoute
  '/company/': typeof CompanyManagementIndexRouteRoute
  '/company/activities': typeof CompanyManagementActivitiesRouteRoute
  '/company/ai-assistant': typeof CompanyManagementAiAssistantRouteRoute
  '/company/ai-assistant-debug': typeof CompanyManagementAiAssistantDebugRouteRoute
  '/company/analytics': typeof CompanyManagementAnalyticsRouteRouteWithChildren
  '/company/audit-log': typeof CompanyManagementAuditLogRouteRoute
  '/company/batch-operations': typeof CompanyManagementBatchOperationsRouteRouteWithChildren
  '/company/events': typeof CompanyManagementEventsRouteRouteWithChildren
  '/company/groups': typeof CompanyManagementGroupsRouteRouteWithChildren
  '/company/licenses-structure': typeof CompanyManagementLicensesStructureRouteRouteWithChildren
  '/company/settings': typeof CompanyManagementSettingsRouteRouteWithChildren
  '/company/users': typeof CompanyManagementUsersRouteRouteWithChildren
  '/company/members/groups': typeof CompanyMembersGroupsRouteRouteWithChildren
  '/exclusive-content': typeof LearningCompanyExclusiveContentRouteWithChildren
  '/learngroup': typeof LearningCompanyLearngroupRoute
  '/achievements': typeof LearningMyLearningAchievementsRoute
  '/certificates': typeof LearningMyLearningCertificatesRoute
  '/courses/$topic': typeof LearningCoursesTopicRoute
  '/discover/channels': typeof LearningDiscoverChannelsOverviewRouteWithChildren
  '/discover/course-generic': typeof LearningDiscoverCourseGenericRouteWithChildren
  '/glossary/{-$letter}': typeof LearningGlossaryChar123LetterChar125Route
  '/growth-map/$skillSlug': typeof LearningGrowthMapSkillSlugRoute
  '/home': typeof LearningHomeOverviewRouteWithChildren
  '/home/activities': typeof LearningHomeActivitiesRoute
  '/company/learnpaths/add': typeof CompanyLearnpathsAddRouteWithChildren
  '/signup/credentials/{-$uuid}': typeof SignupCredentialsChar123UuidChar125Route
  '/signup/welcome/{-$uuid}': typeof SignupWelcomeChar123UuidChar125Route
  '/user/settings/general-settings': typeof UserSettingsGeneralSettingsRoute
  '/user/settings/personal-data': typeof UserSettingsPersonalDataRoute
  '/user/settings/security': typeof UserSettingsSecurityRoute
  '/growth-map/': typeof LearningGrowthMapIndexRoute
  '/company/batch-operations/upload': typeof CompanyManagementBatchOperationsUploadRouteRoute
  '/company/groups/$groupId': typeof CompanyManagementGroupsGroupIdRouteRouteWithChildren
  '/dashboard/certificate': typeof LearningdeprecatedDashboardCertificateRoute
  '/dashboard/certificates': typeof LearningdeprecatedDashboardCertificatesRoute
  '/company-courses': typeof LearningCompanyListCompanyCoursesRouteWithChildren
  '/learnpaths': typeof LearningCompanyListLearnpathsRouteWithChildren
  '/home/bookmarked': typeof LearningMyLearningHomeBookmarkedRoute
  '/home/notes': typeof LearningMyLearningHomeNotesRoute
  '/user/progress': typeof LearningMyLearningUserProgressRouteWithChildren
  '/discover/$channelSlug': typeof LearningDiscoverdeprecatedChannelSlugRoute
  '/discover/grundlagenkurs-digitalisierung': typeof LearningDiscoverdeprecatedGrundlagenkursDigitalisierungRoute
  '/discover/channels/$channel': typeof LearningDiscoverChannelsChannelRouteWithChildren
  '/discover/channels/view': typeof LearningDiscoverChannelsViewRoute
  '/discover/course-generic/$courseSlug': typeof LearningDiscoverCourseGenericCourseSlugRouteWithChildren
  '/discover/search/$query': typeof LearningDiscoverSearchQueryRouteWithChildren
  '/learnpaths/$learnpathId/{-$elementId}': typeof LearningLearnpathsLearnpathIdChar123ElementIdChar125Route
  '/company/analytics/company-overview': typeof CompanyManagementAnalyticsCompanyOverviewRoute
  '/company/analytics/content': typeof CompanyManagementAnalyticsContentRoute
  '/company/analytics/learning-paths': typeof CompanyManagementAnalyticsLearningPathsRoute
  '/company/analytics/performance': typeof CompanyManagementAnalyticsPerformanceRoute
  '/company/analytics/power-skills': typeof CompanyManagementAnalyticsPowerSkillsRoute
  '/company/courses/overview': typeof CompanyManagementCoursesOverviewRouteWithChildren
  '/company/events/add': typeof CompanyManagementEventsAddRouteWithChildren
  '/company/events/overview': typeof CompanyManagementEventsOverviewRouteWithChildren
  '/company/groups/add': typeof CompanyManagementGroupsAddRoute
  '/company/invite/$role': typeof CompanyManagementInviteRoleRoute
  '/company/learnpaths/overview': typeof CompanyManagementLearnpathsOverviewRouteWithChildren
  '/company/licenses-structure/$nodeId': typeof CompanyManagementLicensesStructureNodeIdPanelRouteWithChildren
  '/company/settings/roles': typeof CompanyManagementSettingsRolesRoute
  '/company/users/$userId': typeof CompanyManagementUsersUserIdRouteWithChildren
  '/company/learnpaths/add/general-information-course': typeof CompanyLearnpathsAddGeneralInformationCourseRoute
  '/company/members/groups/add-group': typeof CompanyMembersGroupsAddGroupRoute
  '/discover/': typeof LearningDiscoverdeprecatedIndexRoute
  '/home/': typeof LearningHomeOverviewIndexRoute
  '/company/analytics/': typeof CompanyManagementAnalyticsIndexRoute
  '/company/settings/': typeof CompanyManagementSettingsIndexRoute
  '/company/groups/$groupId/details': typeof CompanyManagementGroupsGroupIdDetailsRouteRoute
  '/company/groups/$groupId/learnpaths': typeof CompanyManagementGroupsGroupIdLearnpathsRouteRoute
  '/company/groups/$groupId/members': typeof CompanyManagementGroupsGroupIdMembersRouteRouteWithChildren
  '/company/learnpaths/add/elements/$learnpathId': typeof CompanyLearnpathsAddElementsLearnpathIdRouteRouteWithChildren
  '/exclusive-content/view/$topic': typeof LearningCompanyExclusiveContentViewTopicRoute
  '/certificate/$certificateId/personalize': typeof LearningMyLearningCertificateCertificateIdPersonalizeRoute
  '/certificate/$certificateId/poll': typeof LearningMyLearningCertificateCertificateIdPollRoute
  '/discover/course-generic/$courseSlug/$themeSlug': typeof LearningDiscoverCourseGenericCourseSlugThemeSlugRoute
  '/learnpaths/$learnpathId/$elementId/$suffix': typeof LearningLearnpathsLearnpathIdElementIdSuffixRoute
  '/poll/$pollId/$source/$sourceId': typeof LearningPollPollIdSourceSourceIdRoute
  '/company/events/add/$mediaId': typeof CompanyManagementEventsAddMediaIdRoute
  '/company/learnpaths/overview/$learnpathId': typeof CompanyManagementLearnpathsOverviewLearnpathIdRouteWithChildren
  '/company/users/$userId/learning-paths': typeof CompanyManagementUsersUserIdLearningPathsRoute
  '/company/users/$userId/licenses': typeof CompanyManagementUsersUserIdLicensesRoute
  '/company/users/$userId/user-groups': typeof CompanyManagementUsersUserIdUserGroupsRoute
  '/company/learnpaths/add/completion-time/$learnpathId': typeof CompanyLearnpathsAddCompletionTimeLearnpathIdRoute
  '/company/learnpaths/add/general-information/$learnpathId': typeof CompanyLearnpathsAddGeneralInformationLearnpathIdRoute
  '/company/learnpaths/add/learners/$learnpathId': typeof CompanyLearnpathsAddLearnersLearnpathIdRoute
  '/channel/$channel/$topic/': typeof LearningChannelChannelTopicIndexRoute
  '/course-generic/$course/$topic/': typeof LearningCourseGenericCourseTopicIndexRoute
  '/discover/channels/': typeof LearningDiscoverChannelsOverviewIndexRoute
  '/discover/course-generic/$courseSlug/': typeof LearningDiscoverCourseGenericCourseSlugIndexRoute
  '/skill/$skill/$topic/': typeof LearningSkillSkillTopicIndexRoute
  '/company/events/add/': typeof CompanyManagementEventsAddIndexRoute
  '/company/users/$userId/': typeof CompanyManagementUsersUserIdIndexRoute
  '/company/learnpaths/add/general-information/': typeof CompanyLearnpathsAddGeneralInformationIndexRoute
  '/company-courses/view/$learnpathId': typeof LearningCompanyListCompanyCoursesViewLearnpathIdRouteWithChildren
  '/learnpaths/view/$learnpathId': typeof LearningCompanyListLearnpathsViewLearnpathIdRouteWithChildren
  '/user/progress/view/$topic': typeof LearningMyLearningUserProgressViewTopicRoute
  '/discover/channels/$channel/view/$topic': typeof LearningDiscoverChannelsChannelViewTopicRoute
  '/discover/search/$query/view/$topic': typeof LearningDiscoverSearchQueryViewTopicRoute
  '/home/view/$channel/$topic': typeof LearningHomeOverviewViewChannelTopicRoute
  '/lectures/$topic/{-$lecture}/{-$suffix}/{-$id}': typeof LearningLecturesTopicChar123LectureChar125Char123SuffixChar125Char123IdChar125Route
  '/company/courses/overview/$mediaId/$tab': typeof CompanyManagementCoursesOverviewMediaIdTabRoute
  '/company/events/overview/$mediaId/$tab': typeof CompanyManagementEventsOverviewMediaIdTabRoute
  '/company/groups/$groupId/members/add': typeof CompanyManagementGroupsGroupIdMembersAddRoute
  '/company/learnpaths/overview/$learnpathId/details': typeof CompanyManagementLearnpathsOverviewLearnpathIdDetailsRoute
  '/company/learnpaths/overview/$learnpathId/progress': typeof CompanyManagementLearnpathsOverviewLearnpathIdProgressRoute
  '/company/learnpaths/overview/$learnpathId/progress-user-groups': typeof CompanyManagementLearnpathsOverviewLearnpathIdProgressUserGroupsRoute
  '/company/learnpaths/overview/$learnpathId/releases': typeof CompanyManagementLearnpathsOverviewLearnpathIdReleasesRoute
  '/company/learnpaths/overview/$learnpathId/reports': typeof CompanyManagementLearnpathsOverviewLearnpathIdReportsRoute
  '/company/learnpaths/overview/$learnpathId/translations': typeof CompanyManagementLearnpathsOverviewLearnpathIdTranslationsRoute
  '/company/licenses-structure/$nodeId/learners': typeof CompanyManagementLicensesStructureNodeIdPanelLearnersRoute
  '/company/licenses-structure/$nodeId/learner/$learnerId': typeof CompanyManagementLicensesStructureNodeIdLearnerLearnerIdRoute
  '/company/learnpaths/overview/$learnpathId/': typeof CompanyManagementLearnpathsOverviewLearnpathIdIndexRoute
  '/company/licenses-structure/$nodeId/': typeof CompanyManagementLicensesStructureNodeIdPanelIndexRoute
  '/channel/$channel/$topic/$lecture/{-$suffix}/{-$id}': typeof LearningChannelChannelTopicLectureChar123SuffixChar125Char123IdChar125Route
  '/course-generic/$course/$topic/$lecture/{-$suffix}/{-$id}': typeof LearningCourseGenericCourseTopicLectureChar123SuffixChar125Char123IdChar125Route
  '/course/$course/$theme/$topic/$lecture/{-$suffix}': typeof LearningCourseCourseThemeTopicLectureChar123SuffixChar125Route
  '/discover/channels/view/$channel/$topic': typeof LearningDiscoverChannelsOverviewViewChannelTopicRoute
  '/learnpaths/$learnpathId/$elementId/$topic/$lecture/{-$suffix}': typeof LearningLearnpathsLearnpathIdElementIdTopicLectureChar123SuffixChar125Route
  '/skill/$skill/$topic/$lecture/{-$suffix}/{-$id}': typeof LearningSkillSkillTopicLectureChar123SuffixChar125Char123IdChar125Route
  '/company-courses/view/$learnpathId/{-$elementId}/{-$topic}': typeof LearningCompanyListCompanyCoursesViewLearnpathIdChar123ElementIdChar125Char123TopicChar125Route
  '/learnpaths/view/$learnpathId/{-$elementId}/{-$topic}': typeof LearningCompanyListLearnpathsViewLearnpathIdChar123ElementIdChar125Char123TopicChar125Route
  '/company/learnpaths/add/elements/$learnpathId/create/embedded-video': typeof CompanyLearnpathsAddElementsLearnpathIdembeddedVideoCreateEmbeddedVideoRoute
  '/company/learnpaths/add/elements/$learnpathId/create/event': typeof CompanyLearnpathsAddElementsLearnpathIdeventCreateEventRoute
  '/company/learnpaths/add/elements/$learnpathId/create/file': typeof CompanyLearnpathsAddElementsLearnpathIdfileCreateFileRouteWithChildren
  '/company/learnpaths/add/elements/$learnpathId/create/link': typeof CompanyLearnpathsAddElementsLearnpathIdlinkCreateLinkRoute
  '/company/learnpaths/add/elements/$learnpathId/create/platform-topic': typeof CompanyLearnpathsAddElementsLearnpathIdplatformTopicCreatePlatformTopicRouteWithChildren
  '/company/learnpaths/add/elements/$learnpathId/create/quiz': typeof CompanyLearnpathsAddElementsLearnpathIdquizCreateQuizRoute
  '/company/learnpaths/add/elements/$learnpathId/create/scorm': typeof CompanyLearnpathsAddElementsLearnpathIdscormCreateScormRoute
  '/company/learnpaths/add/elements/$learnpathId/create/text': typeof CompanyLearnpathsAddElementsLearnpathIdtextCreateTextRoute
  '/company/learnpaths/add/elements/$learnpathId/create/video': typeof CompanyLearnpathsAddElementsLearnpathIdvideoCreateVideoRouteWithChildren
  '/company/learnpaths/add/elements/$learnpathId/delete/embedded-video/$elementId': typeof CompanyLearnpathsAddElementsLearnpathIdembeddedVideoDeleteEmbeddedVideoElementIdRoute
  '/company/learnpaths/add/elements/$learnpathId/update/embedded-video/$elementId': typeof CompanyLearnpathsAddElementsLearnpathIdembeddedVideoUpdateEmbeddedVideoElementIdRoute
  '/company/learnpaths/add/elements/$learnpathId/delete/event/$elementId': typeof CompanyLearnpathsAddElementsLearnpathIdeventDeleteEventElementIdRoute
  '/company/learnpaths/add/elements/$learnpathId/update/event/$elementId': typeof CompanyLearnpathsAddElementsLearnpathIdeventUpdateEventElementIdRoute
  '/company/learnpaths/add/elements/$learnpathId/delete/file/$elementId': typeof CompanyLearnpathsAddElementsLearnpathIdfileDeleteFileElementIdRoute
  '/company/learnpaths/add/elements/$learnpathId/update/file/$elementId': typeof CompanyLearnpathsAddElementsLearnpathIdfileUpdateFileElementIdRouteWithChildren
  '/company/learnpaths/add/elements/$learnpathId/delete/link/$elementId': typeof CompanyLearnpathsAddElementsLearnpathIdlinkDeleteLinkElementIdRoute
  '/company/learnpaths/add/elements/$learnpathId/update/link/$elementId': typeof CompanyLearnpathsAddElementsLearnpathIdlinkUpdateLinkElementIdRoute
  '/company/learnpaths/add/elements/$learnpathId/delete/platform-topic/$elementId': typeof CompanyLearnpathsAddElementsLearnpathIdplatformTopicDeletePlatformTopicElementIdRoute
  '/company/learnpaths/add/elements/$learnpathId/update/platform-topic/$elementId': typeof CompanyLearnpathsAddElementsLearnpathIdplatformTopicUpdatePlatformTopicElementIdRouteWithChildren
  '/company/learnpaths/add/elements/$learnpathId/delete/quiz/$elementId': typeof CompanyLearnpathsAddElementsLearnpathIdquizDeleteQuizElementIdRoute
  '/company/learnpaths/add/elements/$learnpathId/update/quiz/$elementId': typeof CompanyLearnpathsAddElementsLearnpathIdquizUpdateQuizElementIdRoute
  '/company/learnpaths/add/elements/$learnpathId/delete/scorm/$elementId': typeof CompanyLearnpathsAddElementsLearnpathIdscormDeleteScormElementIdRoute
  '/company/learnpaths/add/elements/$learnpathId/update/scorm/$elementId': typeof CompanyLearnpathsAddElementsLearnpathIdscormUpdateScormElementIdRoute
  '/company/learnpaths/add/elements/$learnpathId/delete/text/$elementId': typeof CompanyLearnpathsAddElementsLearnpathIdtextDeleteTextElementIdRoute
  '/company/learnpaths/add/elements/$learnpathId/update/text/$elementId': typeof CompanyLearnpathsAddElementsLearnpathIdtextUpdateTextElementIdRoute
  '/company/learnpaths/add/elements/$learnpathId/delete/video/$elementId': typeof CompanyLearnpathsAddElementsLearnpathIdvideoDeleteVideoElementIdRoute
  '/company/learnpaths/add/elements/$learnpathId/update/video/$elementId': typeof CompanyLearnpathsAddElementsLearnpathIdvideoUpdateVideoElementIdRouteWithChildren
  '/company/learnpaths/add/elements/$learnpathId/create/file/$elementId/$assetId': typeof CompanyLearnpathsAddElementsLearnpathIdfileCreateFileElementIdAssetIdRoute
  '/company/learnpaths/add/elements/$learnpathId/update/file/$elementId/$assetId': typeof CompanyLearnpathsAddElementsLearnpathIdfileUpdateFileElementIdAssetIdRoute
  '/company/learnpaths/add/elements/$learnpathId/create/video/$elementId/$assetId': typeof CompanyLearnpathsAddElementsLearnpathIdvideoCreateVideoElementIdAssetIdRoute
  '/company/learnpaths/add/elements/$learnpathId/update/video/$elementId/$assetId': typeof CompanyLearnpathsAddElementsLearnpathIdvideoUpdateVideoElementIdAssetIdRoute
  '/company/learnpaths/add/elements/$learnpathId/create/platform-topic/$elementId/preview/$topicId/$lectureId': typeof CompanyLearnpathsAddElementsLearnpathIdplatformTopicCreatePlatformTopicElementIdPreviewTopicIdLectureIdRoute
  '/company/learnpaths/add/elements/$learnpathId/update/platform-topic/$elementId/preview/$topicId/$lectureId': typeof CompanyLearnpathsAddElementsLearnpathIdplatformTopicUpdatePlatformTopicElementIdPreviewTopicIdLectureIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/company': typeof CompanyManagementIndexRouteRoute
  '/core-skills-assessment': typeof CoreSkillsAssessmentRouteRoute
  '/signup': typeof SignupRouteRouteWithChildren
  '/user/settings': typeof UserSettingsRouteRouteWithChildren
  '/consents/$consentKey': typeof ConsentsConsentKeyRoute
  '/login/$ssoSourceId': typeof LoginSsoSourceIdRoute
  '/registration/$ssoSourceId': typeof RegistrationSsoSourceIdRoute
  '/signup/$slug': typeof SignupSlugRoute
  '/signup/email': typeof SignupEmailRoute
  '/signup/poll': typeof SignupPollRoute
  '/signup/profile': typeof SignupProfileRoute
  '/skills-assessment/poll-dynamic': typeof SkillsAssessmentPollDynamicRoute
  '/skills-assessment/poll-static': typeof SkillsAssessmentPollStaticRoute
  '/skills-assessment/results-final': typeof SkillsAssessmentResultsFinalRoute
  '/skills-assessment/results-initial': typeof SkillsAssessmentResultsInitialRoute
  '/skills-assessment/welcome': typeof SkillsAssessmentWelcomeRoute
  '/login': typeof LoginIndexRoute
  '/skills-assessment': typeof SkillsAssessmentIndexRoute
  '/company/activities': typeof CompanyManagementActivitiesRouteRoute
  '/company/ai-assistant': typeof CompanyManagementAiAssistantRouteRoute
  '/company/ai-assistant-debug': typeof CompanyManagementAiAssistantDebugRouteRoute
  '/company/audit-log': typeof CompanyManagementAuditLogRouteRoute
  '/company/batch-operations': typeof CompanyManagementBatchOperationsRouteRouteWithChildren
  '/company/events': typeof CompanyManagementEventsRouteRouteWithChildren
  '/company/groups': typeof CompanyManagementGroupsRouteRouteWithChildren
  '/company/licenses-structure': typeof CompanyManagementLicensesStructureRouteRouteWithChildren
  '/company/users': typeof CompanyManagementUsersRouteRouteWithChildren
  '/company/members/groups': typeof CompanyMembersGroupsRouteRouteWithChildren
  '/exclusive-content': typeof LearningCompanyExclusiveContentRouteWithChildren
  '/learngroup': typeof LearningCompanyLearngroupRoute
  '/achievements': typeof LearningMyLearningAchievementsRoute
  '/certificates': typeof LearningMyLearningCertificatesRoute
  '/courses/$topic': typeof LearningCoursesTopicRoute
  '/discover/channels': typeof LearningDiscoverChannelsOverviewIndexRoute
  '/discover/course-generic': typeof LearningDiscoverCourseGenericRouteWithChildren
  '/glossary/{-$letter}': typeof LearningGlossaryChar123LetterChar125Route
  '/growth-map/$skillSlug': typeof LearningGrowthMapSkillSlugRoute
  '/home/activities': typeof LearningHomeActivitiesRoute
  '/company/learnpaths/add': typeof CompanyLearnpathsAddRouteWithChildren
  '/signup/credentials/{-$uuid}': typeof SignupCredentialsChar123UuidChar125Route
  '/signup/welcome/{-$uuid}': typeof SignupWelcomeChar123UuidChar125Route
  '/user/settings/general-settings': typeof UserSettingsGeneralSettingsRoute
  '/user/settings/personal-data': typeof UserSettingsPersonalDataRoute
  '/user/settings/security': typeof UserSettingsSecurityRoute
  '/growth-map': typeof LearningGrowthMapIndexRoute
  '/company/batch-operations/upload': typeof CompanyManagementBatchOperationsUploadRouteRoute
  '/company/groups/$groupId': typeof CompanyManagementGroupsGroupIdRouteRouteWithChildren
  '/dashboard/certificate': typeof LearningdeprecatedDashboardCertificateRoute
  '/dashboard/certificates': typeof LearningdeprecatedDashboardCertificatesRoute
  '/company-courses': typeof LearningCompanyListCompanyCoursesRouteWithChildren
  '/learnpaths': typeof LearningCompanyListLearnpathsRouteWithChildren
  '/home/bookmarked': typeof LearningMyLearningHomeBookmarkedRoute
  '/home/notes': typeof LearningMyLearningHomeNotesRoute
  '/user/progress': typeof LearningMyLearningUserProgressRouteWithChildren
  '/discover/$channelSlug': typeof LearningDiscoverdeprecatedChannelSlugRoute
  '/discover/grundlagenkurs-digitalisierung': typeof LearningDiscoverdeprecatedGrundlagenkursDigitalisierungRoute
  '/discover/channels/$channel': typeof LearningDiscoverChannelsChannelRouteWithChildren
  '/discover/channels/view': typeof LearningDiscoverChannelsViewRoute
  '/discover/search/$query': typeof LearningDiscoverSearchQueryRouteWithChildren
  '/learnpaths/$learnpathId/{-$elementId}': typeof LearningLearnpathsLearnpathIdChar123ElementIdChar125Route
  '/company/analytics/company-overview': typeof CompanyManagementAnalyticsCompanyOverviewRoute
  '/company/analytics/content': typeof CompanyManagementAnalyticsContentRoute
  '/company/analytics/learning-paths': typeof CompanyManagementAnalyticsLearningPathsRoute
  '/company/analytics/performance': typeof CompanyManagementAnalyticsPerformanceRoute
  '/company/analytics/power-skills': typeof CompanyManagementAnalyticsPowerSkillsRoute
  '/company/courses/overview': typeof CompanyManagementCoursesOverviewRouteWithChildren
  '/company/events/overview': typeof CompanyManagementEventsOverviewRouteWithChildren
  '/company/groups/add': typeof CompanyManagementGroupsAddRoute
  '/company/invite/$role': typeof CompanyManagementInviteRoleRoute
  '/company/learnpaths/overview': typeof CompanyManagementLearnpathsOverviewRouteWithChildren
  '/company/licenses-structure/$nodeId': typeof CompanyManagementLicensesStructureNodeIdPanelIndexRoute
  '/company/settings/roles': typeof CompanyManagementSettingsRolesRoute
  '/company/learnpaths/add/general-information-course': typeof CompanyLearnpathsAddGeneralInformationCourseRoute
  '/company/members/groups/add-group': typeof CompanyMembersGroupsAddGroupRoute
  '/discover': typeof LearningDiscoverdeprecatedIndexRoute
  '/home': typeof LearningHomeOverviewIndexRoute
  '/company/analytics': typeof CompanyManagementAnalyticsIndexRoute
  '/company/settings': typeof CompanyManagementSettingsIndexRoute
  '/company/groups/$groupId/details': typeof CompanyManagementGroupsGroupIdDetailsRouteRoute
  '/company/groups/$groupId/learnpaths': typeof CompanyManagementGroupsGroupIdLearnpathsRouteRoute
  '/company/groups/$groupId/members': typeof CompanyManagementGroupsGroupIdMembersRouteRouteWithChildren
  '/company/learnpaths/add/elements/$learnpathId': typeof CompanyLearnpathsAddElementsLearnpathIdRouteRouteWithChildren
  '/exclusive-content/view/$topic': typeof LearningCompanyExclusiveContentViewTopicRoute
  '/certificate/$certificateId/personalize': typeof LearningMyLearningCertificateCertificateIdPersonalizeRoute
  '/certificate/$certificateId/poll': typeof LearningMyLearningCertificateCertificateIdPollRoute
  '/discover/course-generic/$courseSlug/$themeSlug': typeof LearningDiscoverCourseGenericCourseSlugThemeSlugRoute
  '/learnpaths/$learnpathId/$elementId/$suffix': typeof LearningLearnpathsLearnpathIdElementIdSuffixRoute
  '/poll/$pollId/$source/$sourceId': typeof LearningPollPollIdSourceSourceIdRoute
  '/company/events/add/$mediaId': typeof CompanyManagementEventsAddMediaIdRoute
  '/company/users/$userId/learning-paths': typeof CompanyManagementUsersUserIdLearningPathsRoute
  '/company/users/$userId/licenses': typeof CompanyManagementUsersUserIdLicensesRoute
  '/company/users/$userId/user-groups': typeof CompanyManagementUsersUserIdUserGroupsRoute
  '/company/learnpaths/add/completion-time/$learnpathId': typeof CompanyLearnpathsAddCompletionTimeLearnpathIdRoute
  '/company/learnpaths/add/general-information/$learnpathId': typeof CompanyLearnpathsAddGeneralInformationLearnpathIdRoute
  '/company/learnpaths/add/learners/$learnpathId': typeof CompanyLearnpathsAddLearnersLearnpathIdRoute
  '/channel/$channel/$topic': typeof LearningChannelChannelTopicIndexRoute
  '/course-generic/$course/$topic': typeof LearningCourseGenericCourseTopicIndexRoute
  '/discover/course-generic/$courseSlug': typeof LearningDiscoverCourseGenericCourseSlugIndexRoute
  '/skill/$skill/$topic': typeof LearningSkillSkillTopicIndexRoute
  '/company/events/add': typeof CompanyManagementEventsAddIndexRoute
  '/company/users/$userId': typeof CompanyManagementUsersUserIdIndexRoute
  '/company/learnpaths/add/general-information': typeof CompanyLearnpathsAddGeneralInformationIndexRoute
  '/company-courses/view/$learnpathId': typeof LearningCompanyListCompanyCoursesViewLearnpathIdRouteWithChildren
  '/learnpaths/view/$learnpathId': typeof LearningCompanyListLearnpathsViewLearnpathIdRouteWithChildren
  '/user/progress/view/$topic': typeof LearningMyLearningUserProgressViewTopicRoute
  '/discover/channels/$channel/view/$topic': typeof LearningDiscoverChannelsChannelViewTopicRoute
  '/discover/search/$query/view/$topic': typeof LearningDiscoverSearchQueryViewTopicRoute
  '/home/view/$channel/$topic': typeof LearningHomeOverviewViewChannelTopicRoute
  '/lectures/$topic/{-$lecture}/{-$suffix}/{-$id}': typeof LearningLecturesTopicChar123LectureChar125Char123SuffixChar125Char123IdChar125Route
  '/company/courses/overview/$mediaId/$tab': typeof CompanyManagementCoursesOverviewMediaIdTabRoute
  '/company/events/overview/$mediaId/$tab': typeof CompanyManagementEventsOverviewMediaIdTabRoute
  '/company/groups/$groupId/members/add': typeof CompanyManagementGroupsGroupIdMembersAddRoute
  '/company/learnpaths/overview/$learnpathId/details': typeof CompanyManagementLearnpathsOverviewLearnpathIdDetailsRoute
  '/company/learnpaths/overview/$learnpathId/progress': typeof CompanyManagementLearnpathsOverviewLearnpathIdProgressRoute
  '/company/learnpaths/overview/$learnpathId/progress-user-groups': typeof CompanyManagementLearnpathsOverviewLearnpathIdProgressUserGroupsRoute
  '/company/learnpaths/overview/$learnpathId/releases': typeof CompanyManagementLearnpathsOverviewLearnpathIdReleasesRoute
  '/company/learnpaths/overview/$learnpathId/reports': typeof CompanyManagementLearnpathsOverviewLearnpathIdReportsRoute
  '/company/learnpaths/overview/$learnpathId/translations': typeof CompanyManagementLearnpathsOverviewLearnpathIdTranslationsRoute
  '/company/licenses-structure/$nodeId/learners': typeof CompanyManagementLicensesStructureNodeIdPanelLearnersRoute
  '/company/licenses-structure/$nodeId/learner/$learnerId': typeof CompanyManagementLicensesStructureNodeIdLearnerLearnerIdRoute
  '/company/learnpaths/overview/$learnpathId': typeof CompanyManagementLearnpathsOverviewLearnpathIdIndexRoute
  '/channel/$channel/$topic/$lecture/{-$suffix}/{-$id}': typeof LearningChannelChannelTopicLectureChar123SuffixChar125Char123IdChar125Route
  '/course-generic/$course/$topic/$lecture/{-$suffix}/{-$id}': typeof LearningCourseGenericCourseTopicLectureChar123SuffixChar125Char123IdChar125Route
  '/course/$course/$theme/$topic/$lecture/{-$suffix}': typeof LearningCourseCourseThemeTopicLectureChar123SuffixChar125Route
  '/discover/channels/view/$channel/$topic': typeof LearningDiscoverChannelsOverviewViewChannelTopicRoute
  '/learnpaths/$learnpathId/$elementId/$topic/$lecture/{-$suffix}': typeof LearningLearnpathsLearnpathIdElementIdTopicLectureChar123SuffixChar125Route
  '/skill/$skill/$topic/$lecture/{-$suffix}/{-$id}': typeof LearningSkillSkillTopicLectureChar123SuffixChar125Char123IdChar125Route
  '/company-courses/view/$learnpathId/{-$elementId}/{-$topic}': typeof LearningCompanyListCompanyCoursesViewLearnpathIdChar123ElementIdChar125Char123TopicChar125Route
  '/learnpaths/view/$learnpathId/{-$elementId}/{-$topic}': typeof LearningCompanyListLearnpathsViewLearnpathIdChar123ElementIdChar125Char123TopicChar125Route
  '/company/learnpaths/add/elements/$learnpathId/create/embedded-video': typeof CompanyLearnpathsAddElementsLearnpathIdembeddedVideoCreateEmbeddedVideoRoute
  '/company/learnpaths/add/elements/$learnpathId/create/event': typeof CompanyLearnpathsAddElementsLearnpathIdeventCreateEventRoute
  '/company/learnpaths/add/elements/$learnpathId/create/file': typeof CompanyLearnpathsAddElementsLearnpathIdfileCreateFileRouteWithChildren
  '/company/learnpaths/add/elements/$learnpathId/create/link': typeof CompanyLearnpathsAddElementsLearnpathIdlinkCreateLinkRoute
  '/company/learnpaths/add/elements/$learnpathId/create/platform-topic': typeof CompanyLearnpathsAddElementsLearnpathIdplatformTopicCreatePlatformTopicRouteWithChildren
  '/company/learnpaths/add/elements/$learnpathId/create/quiz': typeof CompanyLearnpathsAddElementsLearnpathIdquizCreateQuizRoute
  '/company/learnpaths/add/elements/$learnpathId/create/scorm': typeof CompanyLearnpathsAddElementsLearnpathIdscormCreateScormRoute
  '/company/learnpaths/add/elements/$learnpathId/create/text': typeof CompanyLearnpathsAddElementsLearnpathIdtextCreateTextRoute
  '/company/learnpaths/add/elements/$learnpathId/create/video': typeof CompanyLearnpathsAddElementsLearnpathIdvideoCreateVideoRouteWithChildren
  '/company/learnpaths/add/elements/$learnpathId/delete/embedded-video/$elementId': typeof CompanyLearnpathsAddElementsLearnpathIdembeddedVideoDeleteEmbeddedVideoElementIdRoute
  '/company/learnpaths/add/elements/$learnpathId/update/embedded-video/$elementId': typeof CompanyLearnpathsAddElementsLearnpathIdembeddedVideoUpdateEmbeddedVideoElementIdRoute
  '/company/learnpaths/add/elements/$learnpathId/delete/event/$elementId': typeof CompanyLearnpathsAddElementsLearnpathIdeventDeleteEventElementIdRoute
  '/company/learnpaths/add/elements/$learnpathId/update/event/$elementId': typeof CompanyLearnpathsAddElementsLearnpathIdeventUpdateEventElementIdRoute
  '/company/learnpaths/add/elements/$learnpathId/delete/file/$elementId': typeof CompanyLearnpathsAddElementsLearnpathIdfileDeleteFileElementIdRoute
  '/company/learnpaths/add/elements/$learnpathId/update/file/$elementId': typeof CompanyLearnpathsAddElementsLearnpathIdfileUpdateFileElementIdRouteWithChildren
  '/company/learnpaths/add/elements/$learnpathId/delete/link/$elementId': typeof CompanyLearnpathsAddElementsLearnpathIdlinkDeleteLinkElementIdRoute
  '/company/learnpaths/add/elements/$learnpathId/update/link/$elementId': typeof CompanyLearnpathsAddElementsLearnpathIdlinkUpdateLinkElementIdRoute
  '/company/learnpaths/add/elements/$learnpathId/delete/platform-topic/$elementId': typeof CompanyLearnpathsAddElementsLearnpathIdplatformTopicDeletePlatformTopicElementIdRoute
  '/company/learnpaths/add/elements/$learnpathId/update/platform-topic/$elementId': typeof CompanyLearnpathsAddElementsLearnpathIdplatformTopicUpdatePlatformTopicElementIdRouteWithChildren
  '/company/learnpaths/add/elements/$learnpathId/delete/quiz/$elementId': typeof CompanyLearnpathsAddElementsLearnpathIdquizDeleteQuizElementIdRoute
  '/company/learnpaths/add/elements/$learnpathId/update/quiz/$elementId': typeof CompanyLearnpathsAddElementsLearnpathIdquizUpdateQuizElementIdRoute
  '/company/learnpaths/add/elements/$learnpathId/delete/scorm/$elementId': typeof CompanyLearnpathsAddElementsLearnpathIdscormDeleteScormElementIdRoute
  '/company/learnpaths/add/elements/$learnpathId/update/scorm/$elementId': typeof CompanyLearnpathsAddElementsLearnpathIdscormUpdateScormElementIdRoute
  '/company/learnpaths/add/elements/$learnpathId/delete/text/$elementId': typeof CompanyLearnpathsAddElementsLearnpathIdtextDeleteTextElementIdRoute
  '/company/learnpaths/add/elements/$learnpathId/update/text/$elementId': typeof CompanyLearnpathsAddElementsLearnpathIdtextUpdateTextElementIdRoute
  '/company/learnpaths/add/elements/$learnpathId/delete/video/$elementId': typeof CompanyLearnpathsAddElementsLearnpathIdvideoDeleteVideoElementIdRoute
  '/company/learnpaths/add/elements/$learnpathId/update/video/$elementId': typeof CompanyLearnpathsAddElementsLearnpathIdvideoUpdateVideoElementIdRouteWithChildren
  '/company/learnpaths/add/elements/$learnpathId/create/file/$elementId/$assetId': typeof CompanyLearnpathsAddElementsLearnpathIdfileCreateFileElementIdAssetIdRoute
  '/company/learnpaths/add/elements/$learnpathId/update/file/$elementId/$assetId': typeof CompanyLearnpathsAddElementsLearnpathIdfileUpdateFileElementIdAssetIdRoute
  '/company/learnpaths/add/elements/$learnpathId/create/video/$elementId/$assetId': typeof CompanyLearnpathsAddElementsLearnpathIdvideoCreateVideoElementIdAssetIdRoute
  '/company/learnpaths/add/elements/$learnpathId/update/video/$elementId/$assetId': typeof CompanyLearnpathsAddElementsLearnpathIdvideoUpdateVideoElementIdAssetIdRoute
  '/company/learnpaths/add/elements/$learnpathId/create/platform-topic/$elementId/preview/$topicId/$lectureId': typeof CompanyLearnpathsAddElementsLearnpathIdplatformTopicCreatePlatformTopicElementIdPreviewTopicIdLectureIdRoute
  '/company/learnpaths/add/elements/$learnpathId/update/platform-topic/$elementId/preview/$topicId/$lectureId': typeof CompanyLearnpathsAddElementsLearnpathIdplatformTopicUpdatePlatformTopicElementIdPreviewTopicIdLectureIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_learning': typeof LearningRouteRouteWithChildren
  '/company': typeof CompanyRouteRouteWithChildren
  '/core-skills-assessment': typeof CoreSkillsAssessmentRouteRoute
  '/signup': typeof SignupRouteRouteWithChildren
  '/skills-assessment': typeof SkillsAssessmentRouteRouteWithChildren
  '/_learning/_company': typeof LearningCompanyRouteRouteWithChildren
  '/_learning/_my-learning': typeof LearningMyLearningRouteRouteWithChildren
  '/_learning/discover': typeof LearningDiscoverRouteRouteWithChildren
  '/_learning/growth-map': typeof LearningGrowthMapRouteRouteWithChildren
  '/company/_management': typeof CompanyManagementRouteRouteWithChildren
  '/user/settings': typeof UserSettingsRouteRouteWithChildren
  '/consents/$consentKey': typeof ConsentsConsentKeyRoute
  '/login/$ssoSourceId': typeof LoginSsoSourceIdRoute
  '/registration/$ssoSourceId': typeof RegistrationSsoSourceIdRoute
  '/signup/$slug': typeof SignupSlugRoute
  '/signup/email': typeof SignupEmailRoute
  '/signup/poll': typeof SignupPollRoute
  '/signup/profile': typeof SignupProfileRoute
  '/skills-assessment/poll-dynamic': typeof SkillsAssessmentPollDynamicRoute
  '/skills-assessment/poll-static': typeof SkillsAssessmentPollStaticRoute
  '/skills-assessment/results-final': typeof SkillsAssessmentResultsFinalRoute
  '/skills-assessment/results-initial': typeof SkillsAssessmentResultsInitialRoute
  '/skills-assessment/welcome': typeof SkillsAssessmentWelcomeRoute
  '/login/': typeof LoginIndexRoute
  '/skills-assessment/': typeof SkillsAssessmentIndexRoute
  '/company/_management/': typeof CompanyManagementIndexRouteRoute
  '/_learning/_company/_list': typeof LearningCompanyListRouteRouteWithChildren
  '/company/_management/activities': typeof CompanyManagementActivitiesRouteRoute
  '/company/_management/ai-assistant': typeof CompanyManagementAiAssistantRouteRoute
  '/company/_management/ai-assistant-debug': typeof CompanyManagementAiAssistantDebugRouteRoute
  '/company/_management/analytics': typeof CompanyManagementAnalyticsRouteRouteWithChildren
  '/company/_management/audit-log': typeof CompanyManagementAuditLogRouteRoute
  '/company/_management/batch-operations': typeof CompanyManagementBatchOperationsRouteRouteWithChildren
  '/company/_management/events': typeof CompanyManagementEventsRouteRouteWithChildren
  '/company/_management/groups': typeof CompanyManagementGroupsRouteRouteWithChildren
  '/company/_management/licenses-structure': typeof CompanyManagementLicensesStructureRouteRouteWithChildren
  '/company/_management/settings': typeof CompanyManagementSettingsRouteRouteWithChildren
  '/company/_management/users': typeof CompanyManagementUsersRouteRouteWithChildren
  '/company/members/groups': typeof CompanyMembersGroupsRouteRouteWithChildren
  '/_learning/_company/exclusive-content': typeof LearningCompanyExclusiveContentRouteWithChildren
  '/_learning/_company/learngroup': typeof LearningCompanyLearngroupRoute
  '/_learning/_my-learning/achievements': typeof LearningMyLearningAchievementsRoute
  '/_learning/_my-learning/certificates': typeof LearningMyLearningCertificatesRoute
  '/_learning/courses/$topic': typeof LearningCoursesTopicRoute
  '/_learning/discover/channels': typeof LearningDiscoverChannelsRouteWithChildren
  '/_learning/discover/course-generic': typeof LearningDiscoverCourseGenericRouteWithChildren
  '/_learning/glossary/{-$letter}': typeof LearningGlossaryChar123LetterChar125Route
  '/_learning/growth-map/$skillSlug': typeof LearningGrowthMapSkillSlugRoute
  '/_learning/home/_overview': typeof LearningHomeOverviewRouteWithChildren
  '/_learning/home/activities': typeof LearningHomeActivitiesRoute
  '/company/learnpaths/add': typeof CompanyLearnpathsAddRouteWithChildren
  '/signup/credentials/{-$uuid}': typeof SignupCredentialsChar123UuidChar125Route
  '/signup/welcome/{-$uuid}': typeof SignupWelcomeChar123UuidChar125Route
  '/user/settings/general-settings': typeof UserSettingsGeneralSettingsRoute
  '/user/settings/personal-data': typeof UserSettingsPersonalDataRoute
  '/user/settings/security': typeof UserSettingsSecurityRoute
  '/_learning/growth-map/': typeof LearningGrowthMapIndexRoute
  '/company/_management/batch-operations/upload': typeof CompanyManagementBatchOperationsUploadRouteRoute
  '/company/_management/groups/$groupId': typeof CompanyManagementGroupsGroupIdRouteRouteWithChildren
  '/_learning/(deprecated)/dashboard/certificate': typeof LearningdeprecatedDashboardCertificateRoute
  '/_learning/(deprecated)/dashboard/certificates': typeof LearningdeprecatedDashboardCertificatesRoute
  '/_learning/_company/_list/company-courses': typeof LearningCompanyListCompanyCoursesRouteWithChildren
  '/_learning/_company/_list/learnpaths': typeof LearningCompanyListLearnpathsRouteWithChildren
  '/_learning/_my-learning/home/bookmarked': typeof LearningMyLearningHomeBookmarkedRoute
  '/_learning/_my-learning/home/notes': typeof LearningMyLearningHomeNotesRoute
  '/_learning/_my-learning/user/progress': typeof LearningMyLearningUserProgressRouteWithChildren
  '/_learning/discover/(deprecated)/$channelSlug': typeof LearningDiscoverdeprecatedChannelSlugRoute
  '/_learning/discover/(deprecated)/grundlagenkurs-digitalisierung': typeof LearningDiscoverdeprecatedGrundlagenkursDigitalisierungRoute
  '/_learning/discover/channels/$channel': typeof LearningDiscoverChannelsChannelRouteWithChildren
  '/_learning/discover/channels/_overview': typeof LearningDiscoverChannelsOverviewRouteWithChildren
  '/_learning/discover/channels/view': typeof LearningDiscoverChannelsViewRoute
  '/_learning/discover/course-generic/$courseSlug': typeof LearningDiscoverCourseGenericCourseSlugRouteWithChildren
  '/_learning/discover/search/$query': typeof LearningDiscoverSearchQueryRouteWithChildren
  '/_learning/learnpaths/$learnpathId/{-$elementId}': typeof LearningLearnpathsLearnpathIdChar123ElementIdChar125Route
  '/company/_management/analytics/company-overview': typeof CompanyManagementAnalyticsCompanyOverviewRoute
  '/company/_management/analytics/content': typeof CompanyManagementAnalyticsContentRoute
  '/company/_management/analytics/learning-paths': typeof CompanyManagementAnalyticsLearningPathsRoute
  '/company/_management/analytics/performance': typeof CompanyManagementAnalyticsPerformanceRoute
  '/company/_management/analytics/power-skills': typeof CompanyManagementAnalyticsPowerSkillsRoute
  '/company/_management/courses/overview': typeof CompanyManagementCoursesOverviewRouteWithChildren
  '/company/_management/events/add': typeof CompanyManagementEventsAddRouteWithChildren
  '/company/_management/events/overview': typeof CompanyManagementEventsOverviewRouteWithChildren
  '/company/_management/groups/add': typeof CompanyManagementGroupsAddRoute
  '/company/_management/invite/$role': typeof CompanyManagementInviteRoleRoute
  '/company/_management/learnpaths/overview': typeof CompanyManagementLearnpathsOverviewRouteWithChildren
  '/company/_management/licenses-structure/$nodeId': typeof CompanyManagementLicensesStructureNodeIdRouteWithChildren
  '/company/_management/settings/roles': typeof CompanyManagementSettingsRolesRoute
  '/company/_management/users/$userId': typeof CompanyManagementUsersUserIdRouteWithChildren
  '/company/learnpaths/add/general-information-course': typeof CompanyLearnpathsAddGeneralInformationCourseRoute
  '/company/members/groups/add-group': typeof CompanyMembersGroupsAddGroupRoute
  '/_learning/discover/(deprecated)/': typeof LearningDiscoverdeprecatedIndexRoute
  '/_learning/home/_overview/': typeof LearningHomeOverviewIndexRoute
  '/company/_management/analytics/': typeof CompanyManagementAnalyticsIndexRoute
  '/company/_management/settings/': typeof CompanyManagementSettingsIndexRoute
  '/company/_management/groups/$groupId/details': typeof CompanyManagementGroupsGroupIdDetailsRouteRoute
  '/company/_management/groups/$groupId/learnpaths': typeof CompanyManagementGroupsGroupIdLearnpathsRouteRoute
  '/company/_management/groups/$groupId/members': typeof CompanyManagementGroupsGroupIdMembersRouteRouteWithChildren
  '/company/learnpaths/add/elements/$learnpathId': typeof CompanyLearnpathsAddElementsLearnpathIdRouteRouteWithChildren
  '/_learning/_company/exclusive-content/view/$topic': typeof LearningCompanyExclusiveContentViewTopicRoute
  '/_learning/_my-learning/certificate/$certificateId/personalize': typeof LearningMyLearningCertificateCertificateIdPersonalizeRoute
  '/_learning/_my-learning/certificate/$certificateId/poll': typeof LearningMyLearningCertificateCertificateIdPollRoute
  '/_learning/discover/course-generic/$courseSlug/$themeSlug': typeof LearningDiscoverCourseGenericCourseSlugThemeSlugRoute
  '/_learning/learnpaths/$learnpathId/$elementId/$suffix': typeof LearningLearnpathsLearnpathIdElementIdSuffixRoute
  '/_learning/poll/$pollId/$source/$sourceId': typeof LearningPollPollIdSourceSourceIdRoute
  '/company/_management/events/add/$mediaId': typeof CompanyManagementEventsAddMediaIdRoute
  '/company/_management/learnpaths/overview/$learnpathId': typeof CompanyManagementLearnpathsOverviewLearnpathIdRouteWithChildren
  '/company/_management/licenses-structure/$nodeId/_panel': typeof CompanyManagementLicensesStructureNodeIdPanelRouteWithChildren
  '/company/_management/users/$userId/learning-paths': typeof CompanyManagementUsersUserIdLearningPathsRoute
  '/company/_management/users/$userId/licenses': typeof CompanyManagementUsersUserIdLicensesRoute
  '/company/_management/users/$userId/user-groups': typeof CompanyManagementUsersUserIdUserGroupsRoute
  '/company/learnpaths/add/completion-time/$learnpathId': typeof CompanyLearnpathsAddCompletionTimeLearnpathIdRoute
  '/company/learnpaths/add/general-information/$learnpathId': typeof CompanyLearnpathsAddGeneralInformationLearnpathIdRoute
  '/company/learnpaths/add/learners/$learnpathId': typeof CompanyLearnpathsAddLearnersLearnpathIdRoute
  '/_learning/channel/$channel/$topic/': typeof LearningChannelChannelTopicIndexRoute
  '/_learning/course-generic/$course/$topic/': typeof LearningCourseGenericCourseTopicIndexRoute
  '/_learning/discover/channels/_overview/': typeof LearningDiscoverChannelsOverviewIndexRoute
  '/_learning/discover/course-generic/$courseSlug/': typeof LearningDiscoverCourseGenericCourseSlugIndexRoute
  '/_learning/skill/$skill/$topic/': typeof LearningSkillSkillTopicIndexRoute
  '/company/_management/events/add/': typeof CompanyManagementEventsAddIndexRoute
  '/company/_management/users/$userId/': typeof CompanyManagementUsersUserIdIndexRoute
  '/company/learnpaths/add/general-information/': typeof CompanyLearnpathsAddGeneralInformationIndexRoute
  '/_learning/_company/_list/company-courses/view/$learnpathId': typeof LearningCompanyListCompanyCoursesViewLearnpathIdRouteWithChildren
  '/_learning/_company/_list/learnpaths/view/$learnpathId': typeof LearningCompanyListLearnpathsViewLearnpathIdRouteWithChildren
  '/_learning/_my-learning/user/progress/view/$topic': typeof LearningMyLearningUserProgressViewTopicRoute
  '/_learning/discover/channels/$channel/view/$topic': typeof LearningDiscoverChannelsChannelViewTopicRoute
  '/_learning/discover/search/$query/view/$topic': typeof LearningDiscoverSearchQueryViewTopicRoute
  '/_learning/home/_overview/view/$channel/$topic': typeof LearningHomeOverviewViewChannelTopicRoute
  '/_learning/lectures/$topic/{-$lecture}/{-$suffix}/{-$id}': typeof LearningLecturesTopicChar123LectureChar125Char123SuffixChar125Char123IdChar125Route
  '/company/_management/courses/overview/$mediaId/$tab': typeof CompanyManagementCoursesOverviewMediaIdTabRoute
  '/company/_management/events/overview/$mediaId/$tab': typeof CompanyManagementEventsOverviewMediaIdTabRoute
  '/company/_management/groups/$groupId/members/add': typeof CompanyManagementGroupsGroupIdMembersAddRoute
  '/company/_management/learnpaths/overview/$learnpathId/details': typeof CompanyManagementLearnpathsOverviewLearnpathIdDetailsRoute
  '/company/_management/learnpaths/overview/$learnpathId/progress': typeof CompanyManagementLearnpathsOverviewLearnpathIdProgressRoute
  '/company/_management/learnpaths/overview/$learnpathId/progress-user-groups': typeof CompanyManagementLearnpathsOverviewLearnpathIdProgressUserGroupsRoute
  '/company/_management/learnpaths/overview/$learnpathId/releases': typeof CompanyManagementLearnpathsOverviewLearnpathIdReleasesRoute
  '/company/_management/learnpaths/overview/$learnpathId/reports': typeof CompanyManagementLearnpathsOverviewLearnpathIdReportsRoute
  '/company/_management/learnpaths/overview/$learnpathId/translations': typeof CompanyManagementLearnpathsOverviewLearnpathIdTranslationsRoute
  '/company/_management/licenses-structure/$nodeId/_panel/learners': typeof CompanyManagementLicensesStructureNodeIdPanelLearnersRoute
  '/company/_management/licenses-structure/$nodeId/learner/$learnerId': typeof CompanyManagementLicensesStructureNodeIdLearnerLearnerIdRoute
  '/company/_management/learnpaths/overview/$learnpathId/': typeof CompanyManagementLearnpathsOverviewLearnpathIdIndexRoute
  '/company/_management/licenses-structure/$nodeId/_panel/': typeof CompanyManagementLicensesStructureNodeIdPanelIndexRoute
  '/_learning/channel/$channel/$topic/$lecture/{-$suffix}/{-$id}': typeof LearningChannelChannelTopicLectureChar123SuffixChar125Char123IdChar125Route
  '/_learning/course-generic/$course/$topic/$lecture/{-$suffix}/{-$id}': typeof LearningCourseGenericCourseTopicLectureChar123SuffixChar125Char123IdChar125Route
  '/_learning/course/$course/$theme/$topic/$lecture/{-$suffix}': typeof LearningCourseCourseThemeTopicLectureChar123SuffixChar125Route
  '/_learning/discover/channels/_overview/view/$channel/$topic': typeof LearningDiscoverChannelsOverviewViewChannelTopicRoute
  '/_learning/learnpaths/$learnpathId/$elementId/$topic/$lecture/{-$suffix}': typeof LearningLearnpathsLearnpathIdElementIdTopicLectureChar123SuffixChar125Route
  '/_learning/skill/$skill/$topic/$lecture/{-$suffix}/{-$id}': typeof LearningSkillSkillTopicLectureChar123SuffixChar125Char123IdChar125Route
  '/_learning/_company/_list/company-courses/view/$learnpathId/{-$elementId}/{-$topic}': typeof LearningCompanyListCompanyCoursesViewLearnpathIdChar123ElementIdChar125Char123TopicChar125Route
  '/_learning/_company/_list/learnpaths/view/$learnpathId/{-$elementId}/{-$topic}': typeof LearningCompanyListLearnpathsViewLearnpathIdChar123ElementIdChar125Char123TopicChar125Route
  '/company/learnpaths/add/elements/$learnpathId/(embedded-video)/create/embedded-video': typeof CompanyLearnpathsAddElementsLearnpathIdembeddedVideoCreateEmbeddedVideoRoute
  '/company/learnpaths/add/elements/$learnpathId/(event)/create/event': typeof CompanyLearnpathsAddElementsLearnpathIdeventCreateEventRoute
  '/company/learnpaths/add/elements/$learnpathId/(file)/create/file': typeof CompanyLearnpathsAddElementsLearnpathIdfileCreateFileRouteWithChildren
  '/company/learnpaths/add/elements/$learnpathId/(link)/create/link': typeof CompanyLearnpathsAddElementsLearnpathIdlinkCreateLinkRoute
  '/company/learnpaths/add/elements/$learnpathId/(platform-topic)/create/platform-topic': typeof CompanyLearnpathsAddElementsLearnpathIdplatformTopicCreatePlatformTopicRouteWithChildren
  '/company/learnpaths/add/elements/$learnpathId/(quiz)/create/quiz': typeof CompanyLearnpathsAddElementsLearnpathIdquizCreateQuizRoute
  '/company/learnpaths/add/elements/$learnpathId/(scorm)/create/scorm': typeof CompanyLearnpathsAddElementsLearnpathIdscormCreateScormRoute
  '/company/learnpaths/add/elements/$learnpathId/(text)/create/text': typeof CompanyLearnpathsAddElementsLearnpathIdtextCreateTextRoute
  '/company/learnpaths/add/elements/$learnpathId/(video)/create/video': typeof CompanyLearnpathsAddElementsLearnpathIdvideoCreateVideoRouteWithChildren
  '/company/learnpaths/add/elements/$learnpathId/(embedded-video)/delete/embedded-video/$elementId': typeof CompanyLearnpathsAddElementsLearnpathIdembeddedVideoDeleteEmbeddedVideoElementIdRoute
  '/company/learnpaths/add/elements/$learnpathId/(embedded-video)/update/embedded-video/$elementId': typeof CompanyLearnpathsAddElementsLearnpathIdembeddedVideoUpdateEmbeddedVideoElementIdRoute
  '/company/learnpaths/add/elements/$learnpathId/(event)/delete/event/$elementId': typeof CompanyLearnpathsAddElementsLearnpathIdeventDeleteEventElementIdRoute
  '/company/learnpaths/add/elements/$learnpathId/(event)/update/event/$elementId': typeof CompanyLearnpathsAddElementsLearnpathIdeventUpdateEventElementIdRoute
  '/company/learnpaths/add/elements/$learnpathId/(file)/delete/file/$elementId': typeof CompanyLearnpathsAddElementsLearnpathIdfileDeleteFileElementIdRoute
  '/company/learnpaths/add/elements/$learnpathId/(file)/update/file/$elementId': typeof CompanyLearnpathsAddElementsLearnpathIdfileUpdateFileElementIdRouteWithChildren
  '/company/learnpaths/add/elements/$learnpathId/(link)/delete/link/$elementId': typeof CompanyLearnpathsAddElementsLearnpathIdlinkDeleteLinkElementIdRoute
  '/company/learnpaths/add/elements/$learnpathId/(link)/update/link/$elementId': typeof CompanyLearnpathsAddElementsLearnpathIdlinkUpdateLinkElementIdRoute
  '/company/learnpaths/add/elements/$learnpathId/(platform-topic)/delete/platform-topic/$elementId': typeof CompanyLearnpathsAddElementsLearnpathIdplatformTopicDeletePlatformTopicElementIdRoute
  '/company/learnpaths/add/elements/$learnpathId/(platform-topic)/update/platform-topic/$elementId': typeof CompanyLearnpathsAddElementsLearnpathIdplatformTopicUpdatePlatformTopicElementIdRouteWithChildren
  '/company/learnpaths/add/elements/$learnpathId/(quiz)/delete/quiz/$elementId': typeof CompanyLearnpathsAddElementsLearnpathIdquizDeleteQuizElementIdRoute
  '/company/learnpaths/add/elements/$learnpathId/(quiz)/update/quiz/$elementId': typeof CompanyLearnpathsAddElementsLearnpathIdquizUpdateQuizElementIdRoute
  '/company/learnpaths/add/elements/$learnpathId/(scorm)/delete/scorm/$elementId': typeof CompanyLearnpathsAddElementsLearnpathIdscormDeleteScormElementIdRoute
  '/company/learnpaths/add/elements/$learnpathId/(scorm)/update/scorm/$elementId': typeof CompanyLearnpathsAddElementsLearnpathIdscormUpdateScormElementIdRoute
  '/company/learnpaths/add/elements/$learnpathId/(text)/delete/text/$elementId': typeof CompanyLearnpathsAddElementsLearnpathIdtextDeleteTextElementIdRoute
  '/company/learnpaths/add/elements/$learnpathId/(text)/update/text/$elementId': typeof CompanyLearnpathsAddElementsLearnpathIdtextUpdateTextElementIdRoute
  '/company/learnpaths/add/elements/$learnpathId/(video)/delete/video/$elementId': typeof CompanyLearnpathsAddElementsLearnpathIdvideoDeleteVideoElementIdRoute
  '/company/learnpaths/add/elements/$learnpathId/(video)/update/video/$elementId': typeof CompanyLearnpathsAddElementsLearnpathIdvideoUpdateVideoElementIdRouteWithChildren
  '/company/learnpaths/add/elements/$learnpathId/(file)/create/file/$elementId/$assetId': typeof CompanyLearnpathsAddElementsLearnpathIdfileCreateFileElementIdAssetIdRoute
  '/company/learnpaths/add/elements/$learnpathId/(file)/update/file/$elementId/$assetId': typeof CompanyLearnpathsAddElementsLearnpathIdfileUpdateFileElementIdAssetIdRoute
  '/company/learnpaths/add/elements/$learnpathId/(video)/create/video/$elementId/$assetId': typeof CompanyLearnpathsAddElementsLearnpathIdvideoCreateVideoElementIdAssetIdRoute
  '/company/learnpaths/add/elements/$learnpathId/(video)/update/video/$elementId/$assetId': typeof CompanyLearnpathsAddElementsLearnpathIdvideoUpdateVideoElementIdAssetIdRoute
  '/company/learnpaths/add/elements/$learnpathId/(platform-topic)/create/platform-topic/$elementId/preview/$topicId/$lectureId': typeof CompanyLearnpathsAddElementsLearnpathIdplatformTopicCreatePlatformTopicElementIdPreviewTopicIdLectureIdRoute
  '/company/learnpaths/add/elements/$learnpathId/(platform-topic)/update/platform-topic/$elementId/preview/$topicId/$lectureId': typeof CompanyLearnpathsAddElementsLearnpathIdplatformTopicUpdatePlatformTopicElementIdPreviewTopicIdLectureIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/company'
    | '/core-skills-assessment'
    | '/signup'
    | '/skills-assessment'
    | '/discover'
    | '/growth-map'
    | '/user/settings'
    | '/consents/$consentKey'
    | '/login/$ssoSourceId'
    | '/registration/$ssoSourceId'
    | '/signup/$slug'
    | '/signup/email'
    | '/signup/poll'
    | '/signup/profile'
    | '/skills-assessment/poll-dynamic'
    | '/skills-assessment/poll-static'
    | '/skills-assessment/results-final'
    | '/skills-assessment/results-initial'
    | '/skills-assessment/welcome'
    | '/login/'
    | '/skills-assessment/'
    | '/company/'
    | '/company/activities'
    | '/company/ai-assistant'
    | '/company/ai-assistant-debug'
    | '/company/analytics'
    | '/company/audit-log'
    | '/company/batch-operations'
    | '/company/events'
    | '/company/groups'
    | '/company/licenses-structure'
    | '/company/settings'
    | '/company/users'
    | '/company/members/groups'
    | '/exclusive-content'
    | '/learngroup'
    | '/achievements'
    | '/certificates'
    | '/courses/$topic'
    | '/discover/channels'
    | '/discover/course-generic'
    | '/glossary/{-$letter}'
    | '/growth-map/$skillSlug'
    | '/home'
    | '/home/activities'
    | '/company/learnpaths/add'
    | '/signup/credentials/{-$uuid}'
    | '/signup/welcome/{-$uuid}'
    | '/user/settings/general-settings'
    | '/user/settings/personal-data'
    | '/user/settings/security'
    | '/growth-map/'
    | '/company/batch-operations/upload'
    | '/company/groups/$groupId'
    | '/dashboard/certificate'
    | '/dashboard/certificates'
    | '/company-courses'
    | '/learnpaths'
    | '/home/bookmarked'
    | '/home/notes'
    | '/user/progress'
    | '/discover/$channelSlug'
    | '/discover/grundlagenkurs-digitalisierung'
    | '/discover/channels/$channel'
    | '/discover/channels/view'
    | '/discover/course-generic/$courseSlug'
    | '/discover/search/$query'
    | '/learnpaths/$learnpathId/{-$elementId}'
    | '/company/analytics/company-overview'
    | '/company/analytics/content'
    | '/company/analytics/learning-paths'
    | '/company/analytics/performance'
    | '/company/analytics/power-skills'
    | '/company/courses/overview'
    | '/company/events/add'
    | '/company/events/overview'
    | '/company/groups/add'
    | '/company/invite/$role'
    | '/company/learnpaths/overview'
    | '/company/licenses-structure/$nodeId'
    | '/company/settings/roles'
    | '/company/users/$userId'
    | '/company/learnpaths/add/general-information-course'
    | '/company/members/groups/add-group'
    | '/discover/'
    | '/home/'
    | '/company/analytics/'
    | '/company/settings/'
    | '/company/groups/$groupId/details'
    | '/company/groups/$groupId/learnpaths'
    | '/company/groups/$groupId/members'
    | '/company/learnpaths/add/elements/$learnpathId'
    | '/exclusive-content/view/$topic'
    | '/certificate/$certificateId/personalize'
    | '/certificate/$certificateId/poll'
    | '/discover/course-generic/$courseSlug/$themeSlug'
    | '/learnpaths/$learnpathId/$elementId/$suffix'
    | '/poll/$pollId/$source/$sourceId'
    | '/company/events/add/$mediaId'
    | '/company/learnpaths/overview/$learnpathId'
    | '/company/users/$userId/learning-paths'
    | '/company/users/$userId/licenses'
    | '/company/users/$userId/user-groups'
    | '/company/learnpaths/add/completion-time/$learnpathId'
    | '/company/learnpaths/add/general-information/$learnpathId'
    | '/company/learnpaths/add/learners/$learnpathId'
    | '/channel/$channel/$topic/'
    | '/course-generic/$course/$topic/'
    | '/discover/channels/'
    | '/discover/course-generic/$courseSlug/'
    | '/skill/$skill/$topic/'
    | '/company/events/add/'
    | '/company/users/$userId/'
    | '/company/learnpaths/add/general-information/'
    | '/company-courses/view/$learnpathId'
    | '/learnpaths/view/$learnpathId'
    | '/user/progress/view/$topic'
    | '/discover/channels/$channel/view/$topic'
    | '/discover/search/$query/view/$topic'
    | '/home/view/$channel/$topic'
    | '/lectures/$topic/{-$lecture}/{-$suffix}/{-$id}'
    | '/company/courses/overview/$mediaId/$tab'
    | '/company/events/overview/$mediaId/$tab'
    | '/company/groups/$groupId/members/add'
    | '/company/learnpaths/overview/$learnpathId/details'
    | '/company/learnpaths/overview/$learnpathId/progress'
    | '/company/learnpaths/overview/$learnpathId/progress-user-groups'
    | '/company/learnpaths/overview/$learnpathId/releases'
    | '/company/learnpaths/overview/$learnpathId/reports'
    | '/company/learnpaths/overview/$learnpathId/translations'
    | '/company/licenses-structure/$nodeId/learners'
    | '/company/licenses-structure/$nodeId/learner/$learnerId'
    | '/company/learnpaths/overview/$learnpathId/'
    | '/company/licenses-structure/$nodeId/'
    | '/channel/$channel/$topic/$lecture/{-$suffix}/{-$id}'
    | '/course-generic/$course/$topic/$lecture/{-$suffix}/{-$id}'
    | '/course/$course/$theme/$topic/$lecture/{-$suffix}'
    | '/discover/channels/view/$channel/$topic'
    | '/learnpaths/$learnpathId/$elementId/$topic/$lecture/{-$suffix}'
    | '/skill/$skill/$topic/$lecture/{-$suffix}/{-$id}'
    | '/company-courses/view/$learnpathId/{-$elementId}/{-$topic}'
    | '/learnpaths/view/$learnpathId/{-$elementId}/{-$topic}'
    | '/company/learnpaths/add/elements/$learnpathId/create/embedded-video'
    | '/company/learnpaths/add/elements/$learnpathId/create/event'
    | '/company/learnpaths/add/elements/$learnpathId/create/file'
    | '/company/learnpaths/add/elements/$learnpathId/create/link'
    | '/company/learnpaths/add/elements/$learnpathId/create/platform-topic'
    | '/company/learnpaths/add/elements/$learnpathId/create/quiz'
    | '/company/learnpaths/add/elements/$learnpathId/create/scorm'
    | '/company/learnpaths/add/elements/$learnpathId/create/text'
    | '/company/learnpaths/add/elements/$learnpathId/create/video'
    | '/company/learnpaths/add/elements/$learnpathId/delete/embedded-video/$elementId'
    | '/company/learnpaths/add/elements/$learnpathId/update/embedded-video/$elementId'
    | '/company/learnpaths/add/elements/$learnpathId/delete/event/$elementId'
    | '/company/learnpaths/add/elements/$learnpathId/update/event/$elementId'
    | '/company/learnpaths/add/elements/$learnpathId/delete/file/$elementId'
    | '/company/learnpaths/add/elements/$learnpathId/update/file/$elementId'
    | '/company/learnpaths/add/elements/$learnpathId/delete/link/$elementId'
    | '/company/learnpaths/add/elements/$learnpathId/update/link/$elementId'
    | '/company/learnpaths/add/elements/$learnpathId/delete/platform-topic/$elementId'
    | '/company/learnpaths/add/elements/$learnpathId/update/platform-topic/$elementId'
    | '/company/learnpaths/add/elements/$learnpathId/delete/quiz/$elementId'
    | '/company/learnpaths/add/elements/$learnpathId/update/quiz/$elementId'
    | '/company/learnpaths/add/elements/$learnpathId/delete/scorm/$elementId'
    | '/company/learnpaths/add/elements/$learnpathId/update/scorm/$elementId'
    | '/company/learnpaths/add/elements/$learnpathId/delete/text/$elementId'
    | '/company/learnpaths/add/elements/$learnpathId/update/text/$elementId'
    | '/company/learnpaths/add/elements/$learnpathId/delete/video/$elementId'
    | '/company/learnpaths/add/elements/$learnpathId/update/video/$elementId'
    | '/company/learnpaths/add/elements/$learnpathId/create/file/$elementId/$assetId'
    | '/company/learnpaths/add/elements/$learnpathId/update/file/$elementId/$assetId'
    | '/company/learnpaths/add/elements/$learnpathId/create/video/$elementId/$assetId'
    | '/company/learnpaths/add/elements/$learnpathId/update/video/$elementId/$assetId'
    | '/company/learnpaths/add/elements/$learnpathId/create/platform-topic/$elementId/preview/$topicId/$lectureId'
    | '/company/learnpaths/add/elements/$learnpathId/update/platform-topic/$elementId/preview/$topicId/$lectureId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/company'
    | '/core-skills-assessment'
    | '/signup'
    | '/user/settings'
    | '/consents/$consentKey'
    | '/login/$ssoSourceId'
    | '/registration/$ssoSourceId'
    | '/signup/$slug'
    | '/signup/email'
    | '/signup/poll'
    | '/signup/profile'
    | '/skills-assessment/poll-dynamic'
    | '/skills-assessment/poll-static'
    | '/skills-assessment/results-final'
    | '/skills-assessment/results-initial'
    | '/skills-assessment/welcome'
    | '/login'
    | '/skills-assessment'
    | '/company/activities'
    | '/company/ai-assistant'
    | '/company/ai-assistant-debug'
    | '/company/audit-log'
    | '/company/batch-operations'
    | '/company/events'
    | '/company/groups'
    | '/company/licenses-structure'
    | '/company/users'
    | '/company/members/groups'
    | '/exclusive-content'
    | '/learngroup'
    | '/achievements'
    | '/certificates'
    | '/courses/$topic'
    | '/discover/channels'
    | '/discover/course-generic'
    | '/glossary/{-$letter}'
    | '/growth-map/$skillSlug'
    | '/home/activities'
    | '/company/learnpaths/add'
    | '/signup/credentials/{-$uuid}'
    | '/signup/welcome/{-$uuid}'
    | '/user/settings/general-settings'
    | '/user/settings/personal-data'
    | '/user/settings/security'
    | '/growth-map'
    | '/company/batch-operations/upload'
    | '/company/groups/$groupId'
    | '/dashboard/certificate'
    | '/dashboard/certificates'
    | '/company-courses'
    | '/learnpaths'
    | '/home/bookmarked'
    | '/home/notes'
    | '/user/progress'
    | '/discover/$channelSlug'
    | '/discover/grundlagenkurs-digitalisierung'
    | '/discover/channels/$channel'
    | '/discover/channels/view'
    | '/discover/search/$query'
    | '/learnpaths/$learnpathId/{-$elementId}'
    | '/company/analytics/company-overview'
    | '/company/analytics/content'
    | '/company/analytics/learning-paths'
    | '/company/analytics/performance'
    | '/company/analytics/power-skills'
    | '/company/courses/overview'
    | '/company/events/overview'
    | '/company/groups/add'
    | '/company/invite/$role'
    | '/company/learnpaths/overview'
    | '/company/licenses-structure/$nodeId'
    | '/company/settings/roles'
    | '/company/learnpaths/add/general-information-course'
    | '/company/members/groups/add-group'
    | '/discover'
    | '/home'
    | '/company/analytics'
    | '/company/settings'
    | '/company/groups/$groupId/details'
    | '/company/groups/$groupId/learnpaths'
    | '/company/groups/$groupId/members'
    | '/company/learnpaths/add/elements/$learnpathId'
    | '/exclusive-content/view/$topic'
    | '/certificate/$certificateId/personalize'
    | '/certificate/$certificateId/poll'
    | '/discover/course-generic/$courseSlug/$themeSlug'
    | '/learnpaths/$learnpathId/$elementId/$suffix'
    | '/poll/$pollId/$source/$sourceId'
    | '/company/events/add/$mediaId'
    | '/company/users/$userId/learning-paths'
    | '/company/users/$userId/licenses'
    | '/company/users/$userId/user-groups'
    | '/company/learnpaths/add/completion-time/$learnpathId'
    | '/company/learnpaths/add/general-information/$learnpathId'
    | '/company/learnpaths/add/learners/$learnpathId'
    | '/channel/$channel/$topic'
    | '/course-generic/$course/$topic'
    | '/discover/course-generic/$courseSlug'
    | '/skill/$skill/$topic'
    | '/company/events/add'
    | '/company/users/$userId'
    | '/company/learnpaths/add/general-information'
    | '/company-courses/view/$learnpathId'
    | '/learnpaths/view/$learnpathId'
    | '/user/progress/view/$topic'
    | '/discover/channels/$channel/view/$topic'
    | '/discover/search/$query/view/$topic'
    | '/home/view/$channel/$topic'
    | '/lectures/$topic/{-$lecture}/{-$suffix}/{-$id}'
    | '/company/courses/overview/$mediaId/$tab'
    | '/company/events/overview/$mediaId/$tab'
    | '/company/groups/$groupId/members/add'
    | '/company/learnpaths/overview/$learnpathId/details'
    | '/company/learnpaths/overview/$learnpathId/progress'
    | '/company/learnpaths/overview/$learnpathId/progress-user-groups'
    | '/company/learnpaths/overview/$learnpathId/releases'
    | '/company/learnpaths/overview/$learnpathId/reports'
    | '/company/learnpaths/overview/$learnpathId/translations'
    | '/company/licenses-structure/$nodeId/learners'
    | '/company/licenses-structure/$nodeId/learner/$learnerId'
    | '/company/learnpaths/overview/$learnpathId'
    | '/channel/$channel/$topic/$lecture/{-$suffix}/{-$id}'
    | '/course-generic/$course/$topic/$lecture/{-$suffix}/{-$id}'
    | '/course/$course/$theme/$topic/$lecture/{-$suffix}'
    | '/discover/channels/view/$channel/$topic'
    | '/learnpaths/$learnpathId/$elementId/$topic/$lecture/{-$suffix}'
    | '/skill/$skill/$topic/$lecture/{-$suffix}/{-$id}'
    | '/company-courses/view/$learnpathId/{-$elementId}/{-$topic}'
    | '/learnpaths/view/$learnpathId/{-$elementId}/{-$topic}'
    | '/company/learnpaths/add/elements/$learnpathId/create/embedded-video'
    | '/company/learnpaths/add/elements/$learnpathId/create/event'
    | '/company/learnpaths/add/elements/$learnpathId/create/file'
    | '/company/learnpaths/add/elements/$learnpathId/create/link'
    | '/company/learnpaths/add/elements/$learnpathId/create/platform-topic'
    | '/company/learnpaths/add/elements/$learnpathId/create/quiz'
    | '/company/learnpaths/add/elements/$learnpathId/create/scorm'
    | '/company/learnpaths/add/elements/$learnpathId/create/text'
    | '/company/learnpaths/add/elements/$learnpathId/create/video'
    | '/company/learnpaths/add/elements/$learnpathId/delete/embedded-video/$elementId'
    | '/company/learnpaths/add/elements/$learnpathId/update/embedded-video/$elementId'
    | '/company/learnpaths/add/elements/$learnpathId/delete/event/$elementId'
    | '/company/learnpaths/add/elements/$learnpathId/update/event/$elementId'
    | '/company/learnpaths/add/elements/$learnpathId/delete/file/$elementId'
    | '/company/learnpaths/add/elements/$learnpathId/update/file/$elementId'
    | '/company/learnpaths/add/elements/$learnpathId/delete/link/$elementId'
    | '/company/learnpaths/add/elements/$learnpathId/update/link/$elementId'
    | '/company/learnpaths/add/elements/$learnpathId/delete/platform-topic/$elementId'
    | '/company/learnpaths/add/elements/$learnpathId/update/platform-topic/$elementId'
    | '/company/learnpaths/add/elements/$learnpathId/delete/quiz/$elementId'
    | '/company/learnpaths/add/elements/$learnpathId/update/quiz/$elementId'
    | '/company/learnpaths/add/elements/$learnpathId/delete/scorm/$elementId'
    | '/company/learnpaths/add/elements/$learnpathId/update/scorm/$elementId'
    | '/company/learnpaths/add/elements/$learnpathId/delete/text/$elementId'
    | '/company/learnpaths/add/elements/$learnpathId/update/text/$elementId'
    | '/company/learnpaths/add/elements/$learnpathId/delete/video/$elementId'
    | '/company/learnpaths/add/elements/$learnpathId/update/video/$elementId'
    | '/company/learnpaths/add/elements/$learnpathId/create/file/$elementId/$assetId'
    | '/company/learnpaths/add/elements/$learnpathId/update/file/$elementId/$assetId'
    | '/company/learnpaths/add/elements/$learnpathId/create/video/$elementId/$assetId'
    | '/company/learnpaths/add/elements/$learnpathId/update/video/$elementId/$assetId'
    | '/company/learnpaths/add/elements/$learnpathId/create/platform-topic/$elementId/preview/$topicId/$lectureId'
    | '/company/learnpaths/add/elements/$learnpathId/update/platform-topic/$elementId/preview/$topicId/$lectureId'
  id:
    | '__root__'
    | '/'
    | '/_learning'
    | '/company'
    | '/core-skills-assessment'
    | '/signup'
    | '/skills-assessment'
    | '/_learning/_company'
    | '/_learning/_my-learning'
    | '/_learning/discover'
    | '/_learning/growth-map'
    | '/company/_management'
    | '/user/settings'
    | '/consents/$consentKey'
    | '/login/$ssoSourceId'
    | '/registration/$ssoSourceId'
    | '/signup/$slug'
    | '/signup/email'
    | '/signup/poll'
    | '/signup/profile'
    | '/skills-assessment/poll-dynamic'
    | '/skills-assessment/poll-static'
    | '/skills-assessment/results-final'
    | '/skills-assessment/results-initial'
    | '/skills-assessment/welcome'
    | '/login/'
    | '/skills-assessment/'
    | '/company/_management/'
    | '/_learning/_company/_list'
    | '/company/_management/activities'
    | '/company/_management/ai-assistant'
    | '/company/_management/ai-assistant-debug'
    | '/company/_management/analytics'
    | '/company/_management/audit-log'
    | '/company/_management/batch-operations'
    | '/company/_management/events'
    | '/company/_management/groups'
    | '/company/_management/licenses-structure'
    | '/company/_management/settings'
    | '/company/_management/users'
    | '/company/members/groups'
    | '/_learning/_company/exclusive-content'
    | '/_learning/_company/learngroup'
    | '/_learning/_my-learning/achievements'
    | '/_learning/_my-learning/certificates'
    | '/_learning/courses/$topic'
    | '/_learning/discover/channels'
    | '/_learning/discover/course-generic'
    | '/_learning/glossary/{-$letter}'
    | '/_learning/growth-map/$skillSlug'
    | '/_learning/home/_overview'
    | '/_learning/home/activities'
    | '/company/learnpaths/add'
    | '/signup/credentials/{-$uuid}'
    | '/signup/welcome/{-$uuid}'
    | '/user/settings/general-settings'
    | '/user/settings/personal-data'
    | '/user/settings/security'
    | '/_learning/growth-map/'
    | '/company/_management/batch-operations/upload'
    | '/company/_management/groups/$groupId'
    | '/_learning/(deprecated)/dashboard/certificate'
    | '/_learning/(deprecated)/dashboard/certificates'
    | '/_learning/_company/_list/company-courses'
    | '/_learning/_company/_list/learnpaths'
    | '/_learning/_my-learning/home/bookmarked'
    | '/_learning/_my-learning/home/notes'
    | '/_learning/_my-learning/user/progress'
    | '/_learning/discover/(deprecated)/$channelSlug'
    | '/_learning/discover/(deprecated)/grundlagenkurs-digitalisierung'
    | '/_learning/discover/channels/$channel'
    | '/_learning/discover/channels/_overview'
    | '/_learning/discover/channels/view'
    | '/_learning/discover/course-generic/$courseSlug'
    | '/_learning/discover/search/$query'
    | '/_learning/learnpaths/$learnpathId/{-$elementId}'
    | '/company/_management/analytics/company-overview'
    | '/company/_management/analytics/content'
    | '/company/_management/analytics/learning-paths'
    | '/company/_management/analytics/performance'
    | '/company/_management/analytics/power-skills'
    | '/company/_management/courses/overview'
    | '/company/_management/events/add'
    | '/company/_management/events/overview'
    | '/company/_management/groups/add'
    | '/company/_management/invite/$role'
    | '/company/_management/learnpaths/overview'
    | '/company/_management/licenses-structure/$nodeId'
    | '/company/_management/settings/roles'
    | '/company/_management/users/$userId'
    | '/company/learnpaths/add/general-information-course'
    | '/company/members/groups/add-group'
    | '/_learning/discover/(deprecated)/'
    | '/_learning/home/_overview/'
    | '/company/_management/analytics/'
    | '/company/_management/settings/'
    | '/company/_management/groups/$groupId/details'
    | '/company/_management/groups/$groupId/learnpaths'
    | '/company/_management/groups/$groupId/members'
    | '/company/learnpaths/add/elements/$learnpathId'
    | '/_learning/_company/exclusive-content/view/$topic'
    | '/_learning/_my-learning/certificate/$certificateId/personalize'
    | '/_learning/_my-learning/certificate/$certificateId/poll'
    | '/_learning/discover/course-generic/$courseSlug/$themeSlug'
    | '/_learning/learnpaths/$learnpathId/$elementId/$suffix'
    | '/_learning/poll/$pollId/$source/$sourceId'
    | '/company/_management/events/add/$mediaId'
    | '/company/_management/learnpaths/overview/$learnpathId'
    | '/company/_management/licenses-structure/$nodeId/_panel'
    | '/company/_management/users/$userId/learning-paths'
    | '/company/_management/users/$userId/licenses'
    | '/company/_management/users/$userId/user-groups'
    | '/company/learnpaths/add/completion-time/$learnpathId'
    | '/company/learnpaths/add/general-information/$learnpathId'
    | '/company/learnpaths/add/learners/$learnpathId'
    | '/_learning/channel/$channel/$topic/'
    | '/_learning/course-generic/$course/$topic/'
    | '/_learning/discover/channels/_overview/'
    | '/_learning/discover/course-generic/$courseSlug/'
    | '/_learning/skill/$skill/$topic/'
    | '/company/_management/events/add/'
    | '/company/_management/users/$userId/'
    | '/company/learnpaths/add/general-information/'
    | '/_learning/_company/_list/company-courses/view/$learnpathId'
    | '/_learning/_company/_list/learnpaths/view/$learnpathId'
    | '/_learning/_my-learning/user/progress/view/$topic'
    | '/_learning/discover/channels/$channel/view/$topic'
    | '/_learning/discover/search/$query/view/$topic'
    | '/_learning/home/_overview/view/$channel/$topic'
    | '/_learning/lectures/$topic/{-$lecture}/{-$suffix}/{-$id}'
    | '/company/_management/courses/overview/$mediaId/$tab'
    | '/company/_management/events/overview/$mediaId/$tab'
    | '/company/_management/groups/$groupId/members/add'
    | '/company/_management/learnpaths/overview/$learnpathId/details'
    | '/company/_management/learnpaths/overview/$learnpathId/progress'
    | '/company/_management/learnpaths/overview/$learnpathId/progress-user-groups'
    | '/company/_management/learnpaths/overview/$learnpathId/releases'
    | '/company/_management/learnpaths/overview/$learnpathId/reports'
    | '/company/_management/learnpaths/overview/$learnpathId/translations'
    | '/company/_management/licenses-structure/$nodeId/_panel/learners'
    | '/company/_management/licenses-structure/$nodeId/learner/$learnerId'
    | '/company/_management/learnpaths/overview/$learnpathId/'
    | '/company/_management/licenses-structure/$nodeId/_panel/'
    | '/_learning/channel/$channel/$topic/$lecture/{-$suffix}/{-$id}'
    | '/_learning/course-generic/$course/$topic/$lecture/{-$suffix}/{-$id}'
    | '/_learning/course/$course/$theme/$topic/$lecture/{-$suffix}'
    | '/_learning/discover/channels/_overview/view/$channel/$topic'
    | '/_learning/learnpaths/$learnpathId/$elementId/$topic/$lecture/{-$suffix}'
    | '/_learning/skill/$skill/$topic/$lecture/{-$suffix}/{-$id}'
    | '/_learning/_company/_list/company-courses/view/$learnpathId/{-$elementId}/{-$topic}'
    | '/_learning/_company/_list/learnpaths/view/$learnpathId/{-$elementId}/{-$topic}'
    | '/company/learnpaths/add/elements/$learnpathId/(embedded-video)/create/embedded-video'
    | '/company/learnpaths/add/elements/$learnpathId/(event)/create/event'
    | '/company/learnpaths/add/elements/$learnpathId/(file)/create/file'
    | '/company/learnpaths/add/elements/$learnpathId/(link)/create/link'
    | '/company/learnpaths/add/elements/$learnpathId/(platform-topic)/create/platform-topic'
    | '/company/learnpaths/add/elements/$learnpathId/(quiz)/create/quiz'
    | '/company/learnpaths/add/elements/$learnpathId/(scorm)/create/scorm'
    | '/company/learnpaths/add/elements/$learnpathId/(text)/create/text'
    | '/company/learnpaths/add/elements/$learnpathId/(video)/create/video'
    | '/company/learnpaths/add/elements/$learnpathId/(embedded-video)/delete/embedded-video/$elementId'
    | '/company/learnpaths/add/elements/$learnpathId/(embedded-video)/update/embedded-video/$elementId'
    | '/company/learnpaths/add/elements/$learnpathId/(event)/delete/event/$elementId'
    | '/company/learnpaths/add/elements/$learnpathId/(event)/update/event/$elementId'
    | '/company/learnpaths/add/elements/$learnpathId/(file)/delete/file/$elementId'
    | '/company/learnpaths/add/elements/$learnpathId/(file)/update/file/$elementId'
    | '/company/learnpaths/add/elements/$learnpathId/(link)/delete/link/$elementId'
    | '/company/learnpaths/add/elements/$learnpathId/(link)/update/link/$elementId'
    | '/company/learnpaths/add/elements/$learnpathId/(platform-topic)/delete/platform-topic/$elementId'
    | '/company/learnpaths/add/elements/$learnpathId/(platform-topic)/update/platform-topic/$elementId'
    | '/company/learnpaths/add/elements/$learnpathId/(quiz)/delete/quiz/$elementId'
    | '/company/learnpaths/add/elements/$learnpathId/(quiz)/update/quiz/$elementId'
    | '/company/learnpaths/add/elements/$learnpathId/(scorm)/delete/scorm/$elementId'
    | '/company/learnpaths/add/elements/$learnpathId/(scorm)/update/scorm/$elementId'
    | '/company/learnpaths/add/elements/$learnpathId/(text)/delete/text/$elementId'
    | '/company/learnpaths/add/elements/$learnpathId/(text)/update/text/$elementId'
    | '/company/learnpaths/add/elements/$learnpathId/(video)/delete/video/$elementId'
    | '/company/learnpaths/add/elements/$learnpathId/(video)/update/video/$elementId'
    | '/company/learnpaths/add/elements/$learnpathId/(file)/create/file/$elementId/$assetId'
    | '/company/learnpaths/add/elements/$learnpathId/(file)/update/file/$elementId/$assetId'
    | '/company/learnpaths/add/elements/$learnpathId/(video)/create/video/$elementId/$assetId'
    | '/company/learnpaths/add/elements/$learnpathId/(video)/update/video/$elementId/$assetId'
    | '/company/learnpaths/add/elements/$learnpathId/(platform-topic)/create/platform-topic/$elementId/preview/$topicId/$lectureId'
    | '/company/learnpaths/add/elements/$learnpathId/(platform-topic)/update/platform-topic/$elementId/preview/$topicId/$lectureId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  LearningRouteRoute: typeof LearningRouteRouteWithChildren
  CompanyRouteRoute: typeof CompanyRouteRouteWithChildren
  CoreSkillsAssessmentRouteRoute: typeof CoreSkillsAssessmentRouteRoute
  SignupRouteRoute: typeof SignupRouteRouteWithChildren
  SkillsAssessmentRouteRoute: typeof SkillsAssessmentRouteRouteWithChildren
  UserSettingsRouteRoute: typeof UserSettingsRouteRouteWithChildren
  ConsentsConsentKeyRoute: typeof ConsentsConsentKeyRoute
  LoginSsoSourceIdRoute: typeof LoginSsoSourceIdRoute
  RegistrationSsoSourceIdRoute: typeof RegistrationSsoSourceIdRoute
  LoginIndexRoute: typeof LoginIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/skills-assessment': {
      id: '/skills-assessment'
      path: '/skills-assessment'
      fullPath: '/skills-assessment'
      preLoaderRoute: typeof SkillsAssessmentRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signup': {
      id: '/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof SignupRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/core-skills-assessment': {
      id: '/core-skills-assessment'
      path: '/core-skills-assessment'
      fullPath: '/core-skills-assessment'
      preLoaderRoute: typeof CoreSkillsAssessmentRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/company': {
      id: '/company'
      path: '/company'
      fullPath: '/company'
      preLoaderRoute: typeof CompanyRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_learning': {
      id: '/_learning'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof LearningRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/skills-assessment/': {
      id: '/skills-assessment/'
      path: '/'
      fullPath: '/skills-assessment/'
      preLoaderRoute: typeof SkillsAssessmentIndexRouteImport
      parentRoute: typeof SkillsAssessmentRouteRoute
    }
    '/login/': {
      id: '/login/'
      path: '/login'
      fullPath: '/login/'
      preLoaderRoute: typeof LoginIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/skills-assessment/welcome': {
      id: '/skills-assessment/welcome'
      path: '/welcome'
      fullPath: '/skills-assessment/welcome'
      preLoaderRoute: typeof SkillsAssessmentWelcomeRouteImport
      parentRoute: typeof SkillsAssessmentRouteRoute
    }
    '/skills-assessment/results-initial': {
      id: '/skills-assessment/results-initial'
      path: '/results-initial'
      fullPath: '/skills-assessment/results-initial'
      preLoaderRoute: typeof SkillsAssessmentResultsInitialRouteImport
      parentRoute: typeof SkillsAssessmentRouteRoute
    }
    '/skills-assessment/results-final': {
      id: '/skills-assessment/results-final'
      path: '/results-final'
      fullPath: '/skills-assessment/results-final'
      preLoaderRoute: typeof SkillsAssessmentResultsFinalRouteImport
      parentRoute: typeof SkillsAssessmentRouteRoute
    }
    '/skills-assessment/poll-static': {
      id: '/skills-assessment/poll-static'
      path: '/poll-static'
      fullPath: '/skills-assessment/poll-static'
      preLoaderRoute: typeof SkillsAssessmentPollStaticRouteImport
      parentRoute: typeof SkillsAssessmentRouteRoute
    }
    '/skills-assessment/poll-dynamic': {
      id: '/skills-assessment/poll-dynamic'
      path: '/poll-dynamic'
      fullPath: '/skills-assessment/poll-dynamic'
      preLoaderRoute: typeof SkillsAssessmentPollDynamicRouteImport
      parentRoute: typeof SkillsAssessmentRouteRoute
    }
    '/signup/profile': {
      id: '/signup/profile'
      path: '/profile'
      fullPath: '/signup/profile'
      preLoaderRoute: typeof SignupProfileRouteImport
      parentRoute: typeof SignupRouteRoute
    }
    '/signup/poll': {
      id: '/signup/poll'
      path: '/poll'
      fullPath: '/signup/poll'
      preLoaderRoute: typeof SignupPollRouteImport
      parentRoute: typeof SignupRouteRoute
    }
    '/signup/email': {
      id: '/signup/email'
      path: '/email'
      fullPath: '/signup/email'
      preLoaderRoute: typeof SignupEmailRouteImport
      parentRoute: typeof SignupRouteRoute
    }
    '/signup/$slug': {
      id: '/signup/$slug'
      path: '/$slug'
      fullPath: '/signup/$slug'
      preLoaderRoute: typeof SignupSlugRouteImport
      parentRoute: typeof SignupRouteRoute
    }
    '/registration/$ssoSourceId': {
      id: '/registration/$ssoSourceId'
      path: '/registration/$ssoSourceId'
      fullPath: '/registration/$ssoSourceId'
      preLoaderRoute: typeof RegistrationSsoSourceIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login/$ssoSourceId': {
      id: '/login/$ssoSourceId'
      path: '/login/$ssoSourceId'
      fullPath: '/login/$ssoSourceId'
      preLoaderRoute: typeof LoginSsoSourceIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/consents/$consentKey': {
      id: '/consents/$consentKey'
      path: '/consents/$consentKey'
      fullPath: '/consents/$consentKey'
      preLoaderRoute: typeof ConsentsConsentKeyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/user/settings': {
      id: '/user/settings'
      path: '/user/settings'
      fullPath: '/user/settings'
      preLoaderRoute: typeof UserSettingsRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/company/_management': {
      id: '/company/_management'
      path: ''
      fullPath: '/company'
      preLoaderRoute: typeof CompanyManagementRouteRouteImport
      parentRoute: typeof CompanyRouteRoute
    }
    '/_learning/growth-map': {
      id: '/_learning/growth-map'
      path: '/growth-map'
      fullPath: '/growth-map'
      preLoaderRoute: typeof LearningGrowthMapRouteRouteImport
      parentRoute: typeof LearningRouteRoute
    }
    '/_learning/discover': {
      id: '/_learning/discover'
      path: '/discover'
      fullPath: '/discover'
      preLoaderRoute: typeof LearningDiscoverRouteRouteImport
      parentRoute: typeof LearningRouteRoute
    }
    '/_learning/_my-learning': {
      id: '/_learning/_my-learning'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof LearningMyLearningRouteRouteImport
      parentRoute: typeof LearningRouteRoute
    }
    '/_learning/_company': {
      id: '/_learning/_company'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof LearningCompanyRouteRouteImport
      parentRoute: typeof LearningRouteRoute
    }
    '/_learning/growth-map/': {
      id: '/_learning/growth-map/'
      path: '/'
      fullPath: '/growth-map/'
      preLoaderRoute: typeof LearningGrowthMapIndexRouteImport
      parentRoute: typeof LearningGrowthMapRouteRoute
    }
    '/user/settings/security': {
      id: '/user/settings/security'
      path: '/security'
      fullPath: '/user/settings/security'
      preLoaderRoute: typeof UserSettingsSecurityRouteImport
      parentRoute: typeof UserSettingsRouteRoute
    }
    '/user/settings/personal-data': {
      id: '/user/settings/personal-data'
      path: '/personal-data'
      fullPath: '/user/settings/personal-data'
      preLoaderRoute: typeof UserSettingsPersonalDataRouteImport
      parentRoute: typeof UserSettingsRouteRoute
    }
    '/user/settings/general-settings': {
      id: '/user/settings/general-settings'
      path: '/general-settings'
      fullPath: '/user/settings/general-settings'
      preLoaderRoute: typeof UserSettingsGeneralSettingsRouteImport
      parentRoute: typeof UserSettingsRouteRoute
    }
    '/signup/welcome/{-$uuid}': {
      id: '/signup/welcome/{-$uuid}'
      path: '/welcome/{-$uuid}'
      fullPath: '/signup/welcome/{-$uuid}'
      preLoaderRoute: typeof SignupWelcomeChar123UuidChar125RouteImport
      parentRoute: typeof SignupRouteRoute
    }
    '/signup/credentials/{-$uuid}': {
      id: '/signup/credentials/{-$uuid}'
      path: '/credentials/{-$uuid}'
      fullPath: '/signup/credentials/{-$uuid}'
      preLoaderRoute: typeof SignupCredentialsChar123UuidChar125RouteImport
      parentRoute: typeof SignupRouteRoute
    }
    '/company/learnpaths/add': {
      id: '/company/learnpaths/add'
      path: '/learnpaths/add'
      fullPath: '/company/learnpaths/add'
      preLoaderRoute: typeof CompanyLearnpathsAddRouteImport
      parentRoute: typeof CompanyRouteRoute
    }
    '/_learning/home/activities': {
      id: '/_learning/home/activities'
      path: '/home/activities'
      fullPath: '/home/activities'
      preLoaderRoute: typeof LearningHomeActivitiesRouteImport
      parentRoute: typeof LearningRouteRoute
    }
    '/_learning/home/_overview': {
      id: '/_learning/home/_overview'
      path: '/home'
      fullPath: '/home'
      preLoaderRoute: typeof LearningHomeOverviewRouteImport
      parentRoute: typeof LearningRouteRoute
    }
    '/_learning/growth-map/$skillSlug': {
      id: '/_learning/growth-map/$skillSlug'
      path: '/$skillSlug'
      fullPath: '/growth-map/$skillSlug'
      preLoaderRoute: typeof LearningGrowthMapSkillSlugRouteImport
      parentRoute: typeof LearningGrowthMapRouteRoute
    }
    '/_learning/glossary/{-$letter}': {
      id: '/_learning/glossary/{-$letter}'
      path: '/glossary/{-$letter}'
      fullPath: '/glossary/{-$letter}'
      preLoaderRoute: typeof LearningGlossaryChar123LetterChar125RouteImport
      parentRoute: typeof LearningRouteRoute
    }
    '/_learning/discover/course-generic': {
      id: '/_learning/discover/course-generic'
      path: '/course-generic'
      fullPath: '/discover/course-generic'
      preLoaderRoute: typeof LearningDiscoverCourseGenericRouteImport
      parentRoute: typeof LearningDiscoverRouteRoute
    }
    '/_learning/discover/channels': {
      id: '/_learning/discover/channels'
      path: '/channels'
      fullPath: '/discover/channels'
      preLoaderRoute: typeof LearningDiscoverChannelsRouteImport
      parentRoute: typeof LearningDiscoverRouteRoute
    }
    '/_learning/courses/$topic': {
      id: '/_learning/courses/$topic'
      path: '/courses/$topic'
      fullPath: '/courses/$topic'
      preLoaderRoute: typeof LearningCoursesTopicRouteImport
      parentRoute: typeof LearningRouteRoute
    }
    '/_learning/_my-learning/certificates': {
      id: '/_learning/_my-learning/certificates'
      path: '/certificates'
      fullPath: '/certificates'
      preLoaderRoute: typeof LearningMyLearningCertificatesRouteImport
      parentRoute: typeof LearningMyLearningRouteRoute
    }
    '/_learning/_my-learning/achievements': {
      id: '/_learning/_my-learning/achievements'
      path: '/achievements'
      fullPath: '/achievements'
      preLoaderRoute: typeof LearningMyLearningAchievementsRouteImport
      parentRoute: typeof LearningMyLearningRouteRoute
    }
    '/_learning/_company/learngroup': {
      id: '/_learning/_company/learngroup'
      path: '/learngroup'
      fullPath: '/learngroup'
      preLoaderRoute: typeof LearningCompanyLearngroupRouteImport
      parentRoute: typeof LearningCompanyRouteRoute
    }
    '/_learning/_company/exclusive-content': {
      id: '/_learning/_company/exclusive-content'
      path: '/exclusive-content'
      fullPath: '/exclusive-content'
      preLoaderRoute: typeof LearningCompanyExclusiveContentRouteImport
      parentRoute: typeof LearningCompanyRouteRoute
    }
    '/company/members/groups': {
      id: '/company/members/groups'
      path: '/members/groups'
      fullPath: '/company/members/groups'
      preLoaderRoute: typeof CompanyMembersGroupsRouteRouteImport
      parentRoute: typeof CompanyRouteRoute
    }
    '/company/_management/users': {
      id: '/company/_management/users'
      path: '/users'
      fullPath: '/company/users'
      preLoaderRoute: typeof CompanyManagementUsersRouteRouteImport
      parentRoute: typeof CompanyManagementRouteRoute
    }
    '/company/_management/settings': {
      id: '/company/_management/settings'
      path: '/settings'
      fullPath: '/company/settings'
      preLoaderRoute: typeof CompanyManagementSettingsRouteRouteImport
      parentRoute: typeof CompanyManagementRouteRoute
    }
    '/company/_management/licenses-structure': {
      id: '/company/_management/licenses-structure'
      path: '/licenses-structure'
      fullPath: '/company/licenses-structure'
      preLoaderRoute: typeof CompanyManagementLicensesStructureRouteRouteImport
      parentRoute: typeof CompanyManagementRouteRoute
    }
    '/company/_management/groups': {
      id: '/company/_management/groups'
      path: '/groups'
      fullPath: '/company/groups'
      preLoaderRoute: typeof CompanyManagementGroupsRouteRouteImport
      parentRoute: typeof CompanyManagementRouteRoute
    }
    '/company/_management/events': {
      id: '/company/_management/events'
      path: '/events'
      fullPath: '/company/events'
      preLoaderRoute: typeof CompanyManagementEventsRouteRouteImport
      parentRoute: typeof CompanyManagementRouteRoute
    }
    '/company/_management/batch-operations': {
      id: '/company/_management/batch-operations'
      path: '/batch-operations'
      fullPath: '/company/batch-operations'
      preLoaderRoute: typeof CompanyManagementBatchOperationsRouteRouteImport
      parentRoute: typeof CompanyManagementRouteRoute
    }
    '/company/_management/audit-log': {
      id: '/company/_management/audit-log'
      path: '/audit-log'
      fullPath: '/company/audit-log'
      preLoaderRoute: typeof CompanyManagementAuditLogRouteRouteImport
      parentRoute: typeof CompanyManagementRouteRoute
    }
    '/company/_management/analytics': {
      id: '/company/_management/analytics'
      path: '/analytics'
      fullPath: '/company/analytics'
      preLoaderRoute: typeof CompanyManagementAnalyticsRouteRouteImport
      parentRoute: typeof CompanyManagementRouteRoute
    }
    '/company/_management/ai-assistant-debug': {
      id: '/company/_management/ai-assistant-debug'
      path: '/ai-assistant-debug'
      fullPath: '/company/ai-assistant-debug'
      preLoaderRoute: typeof CompanyManagementAiAssistantDebugRouteRouteImport
      parentRoute: typeof CompanyManagementRouteRoute
    }
    '/company/_management/ai-assistant': {
      id: '/company/_management/ai-assistant'
      path: '/ai-assistant'
      fullPath: '/company/ai-assistant'
      preLoaderRoute: typeof CompanyManagementAiAssistantRouteRouteImport
      parentRoute: typeof CompanyManagementRouteRoute
    }
    '/company/_management/activities': {
      id: '/company/_management/activities'
      path: '/activities'
      fullPath: '/company/activities'
      preLoaderRoute: typeof CompanyManagementActivitiesRouteRouteImport
      parentRoute: typeof CompanyManagementRouteRoute
    }
    '/_learning/_company/_list': {
      id: '/_learning/_company/_list'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof LearningCompanyListRouteRouteImport
      parentRoute: typeof LearningCompanyRouteRoute
    }
    '/company/_management/': {
      id: '/company/_management/'
      path: ''
      fullPath: '/company/'
      preLoaderRoute: typeof CompanyManagementIndexRouteRouteImport
      parentRoute: typeof CompanyManagementRouteRoute
    }
    '/company/_management/settings/': {
      id: '/company/_management/settings/'
      path: '/'
      fullPath: '/company/settings/'
      preLoaderRoute: typeof CompanyManagementSettingsIndexRouteImport
      parentRoute: typeof CompanyManagementSettingsRouteRoute
    }
    '/company/_management/analytics/': {
      id: '/company/_management/analytics/'
      path: '/'
      fullPath: '/company/analytics/'
      preLoaderRoute: typeof CompanyManagementAnalyticsIndexRouteImport
      parentRoute: typeof CompanyManagementAnalyticsRouteRoute
    }
    '/_learning/home/_overview/': {
      id: '/_learning/home/_overview/'
      path: '/'
      fullPath: '/home/'
      preLoaderRoute: typeof LearningHomeOverviewIndexRouteImport
      parentRoute: typeof LearningHomeOverviewRoute
    }
    '/_learning/discover/(deprecated)/': {
      id: '/_learning/discover/(deprecated)/'
      path: '/'
      fullPath: '/discover/'
      preLoaderRoute: typeof LearningDiscoverdeprecatedIndexRouteImport
      parentRoute: typeof LearningDiscoverRouteRoute
    }
    '/company/members/groups/add-group': {
      id: '/company/members/groups/add-group'
      path: '/add-group'
      fullPath: '/company/members/groups/add-group'
      preLoaderRoute: typeof CompanyMembersGroupsAddGroupRouteImport
      parentRoute: typeof CompanyMembersGroupsRouteRoute
    }
    '/company/learnpaths/add/general-information-course': {
      id: '/company/learnpaths/add/general-information-course'
      path: '/general-information-course'
      fullPath: '/company/learnpaths/add/general-information-course'
      preLoaderRoute: typeof CompanyLearnpathsAddGeneralInformationCourseRouteImport
      parentRoute: typeof CompanyLearnpathsAddRoute
    }
    '/company/_management/users/$userId': {
      id: '/company/_management/users/$userId'
      path: '/$userId'
      fullPath: '/company/users/$userId'
      preLoaderRoute: typeof CompanyManagementUsersUserIdRouteImport
      parentRoute: typeof CompanyManagementUsersRouteRoute
    }
    '/company/_management/settings/roles': {
      id: '/company/_management/settings/roles'
      path: '/roles'
      fullPath: '/company/settings/roles'
      preLoaderRoute: typeof CompanyManagementSettingsRolesRouteImport
      parentRoute: typeof CompanyManagementSettingsRouteRoute
    }
    '/company/_management/licenses-structure/$nodeId': {
      id: '/company/_management/licenses-structure/$nodeId'
      path: '/$nodeId'
      fullPath: '/company/licenses-structure/$nodeId'
      preLoaderRoute: typeof CompanyManagementLicensesStructureNodeIdRouteImport
      parentRoute: typeof CompanyManagementLicensesStructureRouteRoute
    }
    '/company/_management/learnpaths/overview': {
      id: '/company/_management/learnpaths/overview'
      path: '/learnpaths/overview'
      fullPath: '/company/learnpaths/overview'
      preLoaderRoute: typeof CompanyManagementLearnpathsOverviewRouteImport
      parentRoute: typeof CompanyManagementRouteRoute
    }
    '/company/_management/invite/$role': {
      id: '/company/_management/invite/$role'
      path: '/invite/$role'
      fullPath: '/company/invite/$role'
      preLoaderRoute: typeof CompanyManagementInviteRoleRouteImport
      parentRoute: typeof CompanyManagementRouteRoute
    }
    '/company/_management/groups/add': {
      id: '/company/_management/groups/add'
      path: '/add'
      fullPath: '/company/groups/add'
      preLoaderRoute: typeof CompanyManagementGroupsAddRouteImport
      parentRoute: typeof CompanyManagementGroupsRouteRoute
    }
    '/company/_management/events/overview': {
      id: '/company/_management/events/overview'
      path: '/overview'
      fullPath: '/company/events/overview'
      preLoaderRoute: typeof CompanyManagementEventsOverviewRouteImport
      parentRoute: typeof CompanyManagementEventsRouteRoute
    }
    '/company/_management/events/add': {
      id: '/company/_management/events/add'
      path: '/add'
      fullPath: '/company/events/add'
      preLoaderRoute: typeof CompanyManagementEventsAddRouteImport
      parentRoute: typeof CompanyManagementEventsRouteRoute
    }
    '/company/_management/courses/overview': {
      id: '/company/_management/courses/overview'
      path: '/courses/overview'
      fullPath: '/company/courses/overview'
      preLoaderRoute: typeof CompanyManagementCoursesOverviewRouteImport
      parentRoute: typeof CompanyManagementRouteRoute
    }
    '/company/_management/analytics/power-skills': {
      id: '/company/_management/analytics/power-skills'
      path: '/power-skills'
      fullPath: '/company/analytics/power-skills'
      preLoaderRoute: typeof CompanyManagementAnalyticsPowerSkillsRouteImport
      parentRoute: typeof CompanyManagementAnalyticsRouteRoute
    }
    '/company/_management/analytics/performance': {
      id: '/company/_management/analytics/performance'
      path: '/performance'
      fullPath: '/company/analytics/performance'
      preLoaderRoute: typeof CompanyManagementAnalyticsPerformanceRouteImport
      parentRoute: typeof CompanyManagementAnalyticsRouteRoute
    }
    '/company/_management/analytics/learning-paths': {
      id: '/company/_management/analytics/learning-paths'
      path: '/learning-paths'
      fullPath: '/company/analytics/learning-paths'
      preLoaderRoute: typeof CompanyManagementAnalyticsLearningPathsRouteImport
      parentRoute: typeof CompanyManagementAnalyticsRouteRoute
    }
    '/company/_management/analytics/content': {
      id: '/company/_management/analytics/content'
      path: '/content'
      fullPath: '/company/analytics/content'
      preLoaderRoute: typeof CompanyManagementAnalyticsContentRouteImport
      parentRoute: typeof CompanyManagementAnalyticsRouteRoute
    }
    '/company/_management/analytics/company-overview': {
      id: '/company/_management/analytics/company-overview'
      path: '/company-overview'
      fullPath: '/company/analytics/company-overview'
      preLoaderRoute: typeof CompanyManagementAnalyticsCompanyOverviewRouteImport
      parentRoute: typeof CompanyManagementAnalyticsRouteRoute
    }
    '/_learning/learnpaths/$learnpathId/{-$elementId}': {
      id: '/_learning/learnpaths/$learnpathId/{-$elementId}'
      path: '/learnpaths/$learnpathId/{-$elementId}'
      fullPath: '/learnpaths/$learnpathId/{-$elementId}'
      preLoaderRoute: typeof LearningLearnpathsLearnpathIdChar123ElementIdChar125RouteImport
      parentRoute: typeof LearningRouteRoute
    }
    '/_learning/discover/search/$query': {
      id: '/_learning/discover/search/$query'
      path: '/search/$query'
      fullPath: '/discover/search/$query'
      preLoaderRoute: typeof LearningDiscoverSearchQueryRouteImport
      parentRoute: typeof LearningDiscoverRouteRoute
    }
    '/_learning/discover/course-generic/$courseSlug': {
      id: '/_learning/discover/course-generic/$courseSlug'
      path: '/$courseSlug'
      fullPath: '/discover/course-generic/$courseSlug'
      preLoaderRoute: typeof LearningDiscoverCourseGenericCourseSlugRouteImport
      parentRoute: typeof LearningDiscoverCourseGenericRoute
    }
    '/_learning/discover/channels/view': {
      id: '/_learning/discover/channels/view'
      path: '/view'
      fullPath: '/discover/channels/view'
      preLoaderRoute: typeof LearningDiscoverChannelsViewRouteImport
      parentRoute: typeof LearningDiscoverChannelsRoute
    }
    '/_learning/discover/channels/_overview': {
      id: '/_learning/discover/channels/_overview'
      path: ''
      fullPath: '/discover/channels'
      preLoaderRoute: typeof LearningDiscoverChannelsOverviewRouteImport
      parentRoute: typeof LearningDiscoverChannelsRoute
    }
    '/_learning/discover/channels/$channel': {
      id: '/_learning/discover/channels/$channel'
      path: '/$channel'
      fullPath: '/discover/channels/$channel'
      preLoaderRoute: typeof LearningDiscoverChannelsChannelRouteImport
      parentRoute: typeof LearningDiscoverChannelsRoute
    }
    '/_learning/discover/(deprecated)/grundlagenkurs-digitalisierung': {
      id: '/_learning/discover/(deprecated)/grundlagenkurs-digitalisierung'
      path: '/grundlagenkurs-digitalisierung'
      fullPath: '/discover/grundlagenkurs-digitalisierung'
      preLoaderRoute: typeof LearningDiscoverdeprecatedGrundlagenkursDigitalisierungRouteImport
      parentRoute: typeof LearningDiscoverRouteRoute
    }
    '/_learning/discover/(deprecated)/$channelSlug': {
      id: '/_learning/discover/(deprecated)/$channelSlug'
      path: '/$channelSlug'
      fullPath: '/discover/$channelSlug'
      preLoaderRoute: typeof LearningDiscoverdeprecatedChannelSlugRouteImport
      parentRoute: typeof LearningDiscoverRouteRoute
    }
    '/_learning/_my-learning/user/progress': {
      id: '/_learning/_my-learning/user/progress'
      path: '/user/progress'
      fullPath: '/user/progress'
      preLoaderRoute: typeof LearningMyLearningUserProgressRouteImport
      parentRoute: typeof LearningMyLearningRouteRoute
    }
    '/_learning/_my-learning/home/notes': {
      id: '/_learning/_my-learning/home/notes'
      path: '/home/notes'
      fullPath: '/home/notes'
      preLoaderRoute: typeof LearningMyLearningHomeNotesRouteImport
      parentRoute: typeof LearningMyLearningRouteRoute
    }
    '/_learning/_my-learning/home/bookmarked': {
      id: '/_learning/_my-learning/home/bookmarked'
      path: '/home/bookmarked'
      fullPath: '/home/bookmarked'
      preLoaderRoute: typeof LearningMyLearningHomeBookmarkedRouteImport
      parentRoute: typeof LearningMyLearningRouteRoute
    }
    '/_learning/_company/_list/learnpaths': {
      id: '/_learning/_company/_list/learnpaths'
      path: '/learnpaths'
      fullPath: '/learnpaths'
      preLoaderRoute: typeof LearningCompanyListLearnpathsRouteImport
      parentRoute: typeof LearningCompanyListRouteRoute
    }
    '/_learning/_company/_list/company-courses': {
      id: '/_learning/_company/_list/company-courses'
      path: '/company-courses'
      fullPath: '/company-courses'
      preLoaderRoute: typeof LearningCompanyListCompanyCoursesRouteImport
      parentRoute: typeof LearningCompanyListRouteRoute
    }
    '/_learning/(deprecated)/dashboard/certificates': {
      id: '/_learning/(deprecated)/dashboard/certificates'
      path: '/dashboard/certificates'
      fullPath: '/dashboard/certificates'
      preLoaderRoute: typeof LearningdeprecatedDashboardCertificatesRouteImport
      parentRoute: typeof LearningRouteRoute
    }
    '/_learning/(deprecated)/dashboard/certificate': {
      id: '/_learning/(deprecated)/dashboard/certificate'
      path: '/dashboard/certificate'
      fullPath: '/dashboard/certificate'
      preLoaderRoute: typeof LearningdeprecatedDashboardCertificateRouteImport
      parentRoute: typeof LearningRouteRoute
    }
    '/company/_management/groups/$groupId': {
      id: '/company/_management/groups/$groupId'
      path: '/$groupId'
      fullPath: '/company/groups/$groupId'
      preLoaderRoute: typeof CompanyManagementGroupsGroupIdRouteRouteImport
      parentRoute: typeof CompanyManagementGroupsRouteRoute
    }
    '/company/_management/batch-operations/upload': {
      id: '/company/_management/batch-operations/upload'
      path: '/upload'
      fullPath: '/company/batch-operations/upload'
      preLoaderRoute: typeof CompanyManagementBatchOperationsUploadRouteRouteImport
      parentRoute: typeof CompanyManagementBatchOperationsRouteRoute
    }
    '/company/learnpaths/add/general-information/': {
      id: '/company/learnpaths/add/general-information/'
      path: '/general-information'
      fullPath: '/company/learnpaths/add/general-information/'
      preLoaderRoute: typeof CompanyLearnpathsAddGeneralInformationIndexRouteImport
      parentRoute: typeof CompanyLearnpathsAddRoute
    }
    '/company/_management/users/$userId/': {
      id: '/company/_management/users/$userId/'
      path: '/'
      fullPath: '/company/users/$userId/'
      preLoaderRoute: typeof CompanyManagementUsersUserIdIndexRouteImport
      parentRoute: typeof CompanyManagementUsersUserIdRoute
    }
    '/company/_management/events/add/': {
      id: '/company/_management/events/add/'
      path: '/'
      fullPath: '/company/events/add/'
      preLoaderRoute: typeof CompanyManagementEventsAddIndexRouteImport
      parentRoute: typeof CompanyManagementEventsAddRoute
    }
    '/_learning/skill/$skill/$topic/': {
      id: '/_learning/skill/$skill/$topic/'
      path: '/skill/$skill/$topic'
      fullPath: '/skill/$skill/$topic/'
      preLoaderRoute: typeof LearningSkillSkillTopicIndexRouteImport
      parentRoute: typeof LearningRouteRoute
    }
    '/_learning/discover/course-generic/$courseSlug/': {
      id: '/_learning/discover/course-generic/$courseSlug/'
      path: '/'
      fullPath: '/discover/course-generic/$courseSlug/'
      preLoaderRoute: typeof LearningDiscoverCourseGenericCourseSlugIndexRouteImport
      parentRoute: typeof LearningDiscoverCourseGenericCourseSlugRoute
    }
    '/_learning/discover/channels/_overview/': {
      id: '/_learning/discover/channels/_overview/'
      path: '/'
      fullPath: '/discover/channels/'
      preLoaderRoute: typeof LearningDiscoverChannelsOverviewIndexRouteImport
      parentRoute: typeof LearningDiscoverChannelsOverviewRoute
    }
    '/_learning/course-generic/$course/$topic/': {
      id: '/_learning/course-generic/$course/$topic/'
      path: '/course-generic/$course/$topic'
      fullPath: '/course-generic/$course/$topic/'
      preLoaderRoute: typeof LearningCourseGenericCourseTopicIndexRouteImport
      parentRoute: typeof LearningRouteRoute
    }
    '/_learning/channel/$channel/$topic/': {
      id: '/_learning/channel/$channel/$topic/'
      path: '/channel/$channel/$topic'
      fullPath: '/channel/$channel/$topic/'
      preLoaderRoute: typeof LearningChannelChannelTopicIndexRouteImport
      parentRoute: typeof LearningRouteRoute
    }
    '/company/learnpaths/add/learners/$learnpathId': {
      id: '/company/learnpaths/add/learners/$learnpathId'
      path: '/learners/$learnpathId'
      fullPath: '/company/learnpaths/add/learners/$learnpathId'
      preLoaderRoute: typeof CompanyLearnpathsAddLearnersLearnpathIdRouteImport
      parentRoute: typeof CompanyLearnpathsAddRoute
    }
    '/company/learnpaths/add/general-information/$learnpathId': {
      id: '/company/learnpaths/add/general-information/$learnpathId'
      path: '/general-information/$learnpathId'
      fullPath: '/company/learnpaths/add/general-information/$learnpathId'
      preLoaderRoute: typeof CompanyLearnpathsAddGeneralInformationLearnpathIdRouteImport
      parentRoute: typeof CompanyLearnpathsAddRoute
    }
    '/company/learnpaths/add/completion-time/$learnpathId': {
      id: '/company/learnpaths/add/completion-time/$learnpathId'
      path: '/completion-time/$learnpathId'
      fullPath: '/company/learnpaths/add/completion-time/$learnpathId'
      preLoaderRoute: typeof CompanyLearnpathsAddCompletionTimeLearnpathIdRouteImport
      parentRoute: typeof CompanyLearnpathsAddRoute
    }
    '/company/_management/users/$userId/user-groups': {
      id: '/company/_management/users/$userId/user-groups'
      path: '/user-groups'
      fullPath: '/company/users/$userId/user-groups'
      preLoaderRoute: typeof CompanyManagementUsersUserIdUserGroupsRouteImport
      parentRoute: typeof CompanyManagementUsersUserIdRoute
    }
    '/company/_management/users/$userId/licenses': {
      id: '/company/_management/users/$userId/licenses'
      path: '/licenses'
      fullPath: '/company/users/$userId/licenses'
      preLoaderRoute: typeof CompanyManagementUsersUserIdLicensesRouteImport
      parentRoute: typeof CompanyManagementUsersUserIdRoute
    }
    '/company/_management/users/$userId/learning-paths': {
      id: '/company/_management/users/$userId/learning-paths'
      path: '/learning-paths'
      fullPath: '/company/users/$userId/learning-paths'
      preLoaderRoute: typeof CompanyManagementUsersUserIdLearningPathsRouteImport
      parentRoute: typeof CompanyManagementUsersUserIdRoute
    }
    '/company/_management/licenses-structure/$nodeId/_panel': {
      id: '/company/_management/licenses-structure/$nodeId/_panel'
      path: ''
      fullPath: '/company/licenses-structure/$nodeId'
      preLoaderRoute: typeof CompanyManagementLicensesStructureNodeIdPanelRouteImport
      parentRoute: typeof CompanyManagementLicensesStructureNodeIdRoute
    }
    '/company/_management/learnpaths/overview/$learnpathId': {
      id: '/company/_management/learnpaths/overview/$learnpathId'
      path: '/$learnpathId'
      fullPath: '/company/learnpaths/overview/$learnpathId'
      preLoaderRoute: typeof CompanyManagementLearnpathsOverviewLearnpathIdRouteImport
      parentRoute: typeof CompanyManagementLearnpathsOverviewRoute
    }
    '/company/_management/events/add/$mediaId': {
      id: '/company/_management/events/add/$mediaId'
      path: '/$mediaId'
      fullPath: '/company/events/add/$mediaId'
      preLoaderRoute: typeof CompanyManagementEventsAddMediaIdRouteImport
      parentRoute: typeof CompanyManagementEventsAddRoute
    }
    '/_learning/poll/$pollId/$source/$sourceId': {
      id: '/_learning/poll/$pollId/$source/$sourceId'
      path: '/poll/$pollId/$source/$sourceId'
      fullPath: '/poll/$pollId/$source/$sourceId'
      preLoaderRoute: typeof LearningPollPollIdSourceSourceIdRouteImport
      parentRoute: typeof LearningRouteRoute
    }
    '/_learning/learnpaths/$learnpathId/$elementId/$suffix': {
      id: '/_learning/learnpaths/$learnpathId/$elementId/$suffix'
      path: '/learnpaths/$learnpathId/$elementId/$suffix'
      fullPath: '/learnpaths/$learnpathId/$elementId/$suffix'
      preLoaderRoute: typeof LearningLearnpathsLearnpathIdElementIdSuffixRouteImport
      parentRoute: typeof LearningRouteRoute
    }
    '/_learning/discover/course-generic/$courseSlug/$themeSlug': {
      id: '/_learning/discover/course-generic/$courseSlug/$themeSlug'
      path: '/$themeSlug'
      fullPath: '/discover/course-generic/$courseSlug/$themeSlug'
      preLoaderRoute: typeof LearningDiscoverCourseGenericCourseSlugThemeSlugRouteImport
      parentRoute: typeof LearningDiscoverCourseGenericCourseSlugRoute
    }
    '/_learning/_my-learning/certificate/$certificateId/poll': {
      id: '/_learning/_my-learning/certificate/$certificateId/poll'
      path: '/certificate/$certificateId/poll'
      fullPath: '/certificate/$certificateId/poll'
      preLoaderRoute: typeof LearningMyLearningCertificateCertificateIdPollRouteImport
      parentRoute: typeof LearningMyLearningRouteRoute
    }
    '/_learning/_my-learning/certificate/$certificateId/personalize': {
      id: '/_learning/_my-learning/certificate/$certificateId/personalize'
      path: '/certificate/$certificateId/personalize'
      fullPath: '/certificate/$certificateId/personalize'
      preLoaderRoute: typeof LearningMyLearningCertificateCertificateIdPersonalizeRouteImport
      parentRoute: typeof LearningMyLearningRouteRoute
    }
    '/_learning/_company/exclusive-content/view/$topic': {
      id: '/_learning/_company/exclusive-content/view/$topic'
      path: '/view/$topic'
      fullPath: '/exclusive-content/view/$topic'
      preLoaderRoute: typeof LearningCompanyExclusiveContentViewTopicRouteImport
      parentRoute: typeof LearningCompanyExclusiveContentRoute
    }
    '/company/learnpaths/add/elements/$learnpathId': {
      id: '/company/learnpaths/add/elements/$learnpathId'
      path: '/elements/$learnpathId'
      fullPath: '/company/learnpaths/add/elements/$learnpathId'
      preLoaderRoute: typeof CompanyLearnpathsAddElementsLearnpathIdRouteRouteImport
      parentRoute: typeof CompanyLearnpathsAddRoute
    }
    '/company/_management/groups/$groupId/members': {
      id: '/company/_management/groups/$groupId/members'
      path: '/members'
      fullPath: '/company/groups/$groupId/members'
      preLoaderRoute: typeof CompanyManagementGroupsGroupIdMembersRouteRouteImport
      parentRoute: typeof CompanyManagementGroupsGroupIdRouteRoute
    }
    '/company/_management/groups/$groupId/learnpaths': {
      id: '/company/_management/groups/$groupId/learnpaths'
      path: '/learnpaths'
      fullPath: '/company/groups/$groupId/learnpaths'
      preLoaderRoute: typeof CompanyManagementGroupsGroupIdLearnpathsRouteRouteImport
      parentRoute: typeof CompanyManagementGroupsGroupIdRouteRoute
    }
    '/company/_management/groups/$groupId/details': {
      id: '/company/_management/groups/$groupId/details'
      path: '/details'
      fullPath: '/company/groups/$groupId/details'
      preLoaderRoute: typeof CompanyManagementGroupsGroupIdDetailsRouteRouteImport
      parentRoute: typeof CompanyManagementGroupsGroupIdRouteRoute
    }
    '/company/_management/licenses-structure/$nodeId/_panel/': {
      id: '/company/_management/licenses-structure/$nodeId/_panel/'
      path: '/'
      fullPath: '/company/licenses-structure/$nodeId/'
      preLoaderRoute: typeof CompanyManagementLicensesStructureNodeIdPanelIndexRouteImport
      parentRoute: typeof CompanyManagementLicensesStructureNodeIdPanelRoute
    }
    '/company/_management/learnpaths/overview/$learnpathId/': {
      id: '/company/_management/learnpaths/overview/$learnpathId/'
      path: '/'
      fullPath: '/company/learnpaths/overview/$learnpathId/'
      preLoaderRoute: typeof CompanyManagementLearnpathsOverviewLearnpathIdIndexRouteImport
      parentRoute: typeof CompanyManagementLearnpathsOverviewLearnpathIdRoute
    }
    '/company/_management/licenses-structure/$nodeId/learner/$learnerId': {
      id: '/company/_management/licenses-structure/$nodeId/learner/$learnerId'
      path: '/learner/$learnerId'
      fullPath: '/company/licenses-structure/$nodeId/learner/$learnerId'
      preLoaderRoute: typeof CompanyManagementLicensesStructureNodeIdLearnerLearnerIdRouteImport
      parentRoute: typeof CompanyManagementLicensesStructureNodeIdRoute
    }
    '/company/_management/licenses-structure/$nodeId/_panel/learners': {
      id: '/company/_management/licenses-structure/$nodeId/_panel/learners'
      path: '/learners'
      fullPath: '/company/licenses-structure/$nodeId/learners'
      preLoaderRoute: typeof CompanyManagementLicensesStructureNodeIdPanelLearnersRouteImport
      parentRoute: typeof CompanyManagementLicensesStructureNodeIdPanelRoute
    }
    '/company/_management/learnpaths/overview/$learnpathId/translations': {
      id: '/company/_management/learnpaths/overview/$learnpathId/translations'
      path: '/translations'
      fullPath: '/company/learnpaths/overview/$learnpathId/translations'
      preLoaderRoute: typeof CompanyManagementLearnpathsOverviewLearnpathIdTranslationsRouteImport
      parentRoute: typeof CompanyManagementLearnpathsOverviewLearnpathIdRoute
    }
    '/company/_management/learnpaths/overview/$learnpathId/reports': {
      id: '/company/_management/learnpaths/overview/$learnpathId/reports'
      path: '/reports'
      fullPath: '/company/learnpaths/overview/$learnpathId/reports'
      preLoaderRoute: typeof CompanyManagementLearnpathsOverviewLearnpathIdReportsRouteImport
      parentRoute: typeof CompanyManagementLearnpathsOverviewLearnpathIdRoute
    }
    '/company/_management/learnpaths/overview/$learnpathId/releases': {
      id: '/company/_management/learnpaths/overview/$learnpathId/releases'
      path: '/releases'
      fullPath: '/company/learnpaths/overview/$learnpathId/releases'
      preLoaderRoute: typeof CompanyManagementLearnpathsOverviewLearnpathIdReleasesRouteImport
      parentRoute: typeof CompanyManagementLearnpathsOverviewLearnpathIdRoute
    }
    '/company/_management/learnpaths/overview/$learnpathId/progress-user-groups': {
      id: '/company/_management/learnpaths/overview/$learnpathId/progress-user-groups'
      path: '/progress-user-groups'
      fullPath: '/company/learnpaths/overview/$learnpathId/progress-user-groups'
      preLoaderRoute: typeof CompanyManagementLearnpathsOverviewLearnpathIdProgressUserGroupsRouteImport
      parentRoute: typeof CompanyManagementLearnpathsOverviewLearnpathIdRoute
    }
    '/company/_management/learnpaths/overview/$learnpathId/progress': {
      id: '/company/_management/learnpaths/overview/$learnpathId/progress'
      path: '/progress'
      fullPath: '/company/learnpaths/overview/$learnpathId/progress'
      preLoaderRoute: typeof CompanyManagementLearnpathsOverviewLearnpathIdProgressRouteImport
      parentRoute: typeof CompanyManagementLearnpathsOverviewLearnpathIdRoute
    }
    '/company/_management/learnpaths/overview/$learnpathId/details': {
      id: '/company/_management/learnpaths/overview/$learnpathId/details'
      path: '/details'
      fullPath: '/company/learnpaths/overview/$learnpathId/details'
      preLoaderRoute: typeof CompanyManagementLearnpathsOverviewLearnpathIdDetailsRouteImport
      parentRoute: typeof CompanyManagementLearnpathsOverviewLearnpathIdRoute
    }
    '/company/_management/groups/$groupId/members/add': {
      id: '/company/_management/groups/$groupId/members/add'
      path: '/add'
      fullPath: '/company/groups/$groupId/members/add'
      preLoaderRoute: typeof CompanyManagementGroupsGroupIdMembersAddRouteImport
      parentRoute: typeof CompanyManagementGroupsGroupIdMembersRouteRoute
    }
    '/company/_management/events/overview/$mediaId/$tab': {
      id: '/company/_management/events/overview/$mediaId/$tab'
      path: '/$mediaId/$tab'
      fullPath: '/company/events/overview/$mediaId/$tab'
      preLoaderRoute: typeof CompanyManagementEventsOverviewMediaIdTabRouteImport
      parentRoute: typeof CompanyManagementEventsOverviewRoute
    }
    '/company/_management/courses/overview/$mediaId/$tab': {
      id: '/company/_management/courses/overview/$mediaId/$tab'
      path: '/$mediaId/$tab'
      fullPath: '/company/courses/overview/$mediaId/$tab'
      preLoaderRoute: typeof CompanyManagementCoursesOverviewMediaIdTabRouteImport
      parentRoute: typeof CompanyManagementCoursesOverviewRoute
    }
    '/_learning/lectures/$topic/{-$lecture}/{-$suffix}/{-$id}': {
      id: '/_learning/lectures/$topic/{-$lecture}/{-$suffix}/{-$id}'
      path: '/lectures/$topic/{-$lecture}/{-$suffix}/{-$id}'
      fullPath: '/lectures/$topic/{-$lecture}/{-$suffix}/{-$id}'
      preLoaderRoute: typeof LearningLecturesTopicChar123LectureChar125Char123SuffixChar125Char123IdChar125RouteImport
      parentRoute: typeof LearningRouteRoute
    }
    '/_learning/home/_overview/view/$channel/$topic': {
      id: '/_learning/home/_overview/view/$channel/$topic'
      path: '/view/$channel/$topic'
      fullPath: '/home/view/$channel/$topic'
      preLoaderRoute: typeof LearningHomeOverviewViewChannelTopicRouteImport
      parentRoute: typeof LearningHomeOverviewRoute
    }
    '/_learning/discover/search/$query/view/$topic': {
      id: '/_learning/discover/search/$query/view/$topic'
      path: '/view/$topic'
      fullPath: '/discover/search/$query/view/$topic'
      preLoaderRoute: typeof LearningDiscoverSearchQueryViewTopicRouteImport
      parentRoute: typeof LearningDiscoverSearchQueryRoute
    }
    '/_learning/discover/channels/$channel/view/$topic': {
      id: '/_learning/discover/channels/$channel/view/$topic'
      path: '/view/$topic'
      fullPath: '/discover/channels/$channel/view/$topic'
      preLoaderRoute: typeof LearningDiscoverChannelsChannelViewTopicRouteImport
      parentRoute: typeof LearningDiscoverChannelsChannelRoute
    }
    '/_learning/_my-learning/user/progress/view/$topic': {
      id: '/_learning/_my-learning/user/progress/view/$topic'
      path: '/view/$topic'
      fullPath: '/user/progress/view/$topic'
      preLoaderRoute: typeof LearningMyLearningUserProgressViewTopicRouteImport
      parentRoute: typeof LearningMyLearningUserProgressRoute
    }
    '/_learning/_company/_list/learnpaths/view/$learnpathId': {
      id: '/_learning/_company/_list/learnpaths/view/$learnpathId'
      path: '/view/$learnpathId'
      fullPath: '/learnpaths/view/$learnpathId'
      preLoaderRoute: typeof LearningCompanyListLearnpathsViewLearnpathIdRouteImport
      parentRoute: typeof LearningCompanyListLearnpathsRoute
    }
    '/_learning/_company/_list/company-courses/view/$learnpathId': {
      id: '/_learning/_company/_list/company-courses/view/$learnpathId'
      path: '/view/$learnpathId'
      fullPath: '/company-courses/view/$learnpathId'
      preLoaderRoute: typeof LearningCompanyListCompanyCoursesViewLearnpathIdRouteImport
      parentRoute: typeof LearningCompanyListCompanyCoursesRoute
    }
    '/_learning/skill/$skill/$topic/$lecture/{-$suffix}/{-$id}': {
      id: '/_learning/skill/$skill/$topic/$lecture/{-$suffix}/{-$id}'
      path: '/skill/$skill/$topic/$lecture/{-$suffix}/{-$id}'
      fullPath: '/skill/$skill/$topic/$lecture/{-$suffix}/{-$id}'
      preLoaderRoute: typeof LearningSkillSkillTopicLectureChar123SuffixChar125Char123IdChar125RouteImport
      parentRoute: typeof LearningRouteRoute
    }
    '/_learning/learnpaths/$learnpathId/$elementId/$topic/$lecture/{-$suffix}': {
      id: '/_learning/learnpaths/$learnpathId/$elementId/$topic/$lecture/{-$suffix}'
      path: '/learnpaths/$learnpathId/$elementId/$topic/$lecture/{-$suffix}'
      fullPath: '/learnpaths/$learnpathId/$elementId/$topic/$lecture/{-$suffix}'
      preLoaderRoute: typeof LearningLearnpathsLearnpathIdElementIdTopicLectureChar123SuffixChar125RouteImport
      parentRoute: typeof LearningRouteRoute
    }
    '/_learning/discover/channels/_overview/view/$channel/$topic': {
      id: '/_learning/discover/channels/_overview/view/$channel/$topic'
      path: '/view/$channel/$topic'
      fullPath: '/discover/channels/view/$channel/$topic'
      preLoaderRoute: typeof LearningDiscoverChannelsOverviewViewChannelTopicRouteImport
      parentRoute: typeof LearningDiscoverChannelsOverviewRoute
    }
    '/_learning/course/$course/$theme/$topic/$lecture/{-$suffix}': {
      id: '/_learning/course/$course/$theme/$topic/$lecture/{-$suffix}'
      path: '/course/$course/$theme/$topic/$lecture/{-$suffix}'
      fullPath: '/course/$course/$theme/$topic/$lecture/{-$suffix}'
      preLoaderRoute: typeof LearningCourseCourseThemeTopicLectureChar123SuffixChar125RouteImport
      parentRoute: typeof LearningRouteRoute
    }
    '/_learning/course-generic/$course/$topic/$lecture/{-$suffix}/{-$id}': {
      id: '/_learning/course-generic/$course/$topic/$lecture/{-$suffix}/{-$id}'
      path: '/course-generic/$course/$topic/$lecture/{-$suffix}/{-$id}'
      fullPath: '/course-generic/$course/$topic/$lecture/{-$suffix}/{-$id}'
      preLoaderRoute: typeof LearningCourseGenericCourseTopicLectureChar123SuffixChar125Char123IdChar125RouteImport
      parentRoute: typeof LearningRouteRoute
    }
    '/_learning/channel/$channel/$topic/$lecture/{-$suffix}/{-$id}': {
      id: '/_learning/channel/$channel/$topic/$lecture/{-$suffix}/{-$id}'
      path: '/channel/$channel/$topic/$lecture/{-$suffix}/{-$id}'
      fullPath: '/channel/$channel/$topic/$lecture/{-$suffix}/{-$id}'
      preLoaderRoute: typeof LearningChannelChannelTopicLectureChar123SuffixChar125Char123IdChar125RouteImport
      parentRoute: typeof LearningRouteRoute
    }
    '/company/learnpaths/add/elements/$learnpathId/(video)/create/video': {
      id: '/company/learnpaths/add/elements/$learnpathId/(video)/create/video'
      path: '/create/video'
      fullPath: '/company/learnpaths/add/elements/$learnpathId/create/video'
      preLoaderRoute: typeof CompanyLearnpathsAddElementsLearnpathIdvideoCreateVideoRouteImport
      parentRoute: typeof CompanyLearnpathsAddElementsLearnpathIdRouteRoute
    }
    '/company/learnpaths/add/elements/$learnpathId/(text)/create/text': {
      id: '/company/learnpaths/add/elements/$learnpathId/(text)/create/text'
      path: '/create/text'
      fullPath: '/company/learnpaths/add/elements/$learnpathId/create/text'
      preLoaderRoute: typeof CompanyLearnpathsAddElementsLearnpathIdtextCreateTextRouteImport
      parentRoute: typeof CompanyLearnpathsAddElementsLearnpathIdRouteRoute
    }
    '/company/learnpaths/add/elements/$learnpathId/(scorm)/create/scorm': {
      id: '/company/learnpaths/add/elements/$learnpathId/(scorm)/create/scorm'
      path: '/create/scorm'
      fullPath: '/company/learnpaths/add/elements/$learnpathId/create/scorm'
      preLoaderRoute: typeof CompanyLearnpathsAddElementsLearnpathIdscormCreateScormRouteImport
      parentRoute: typeof CompanyLearnpathsAddElementsLearnpathIdRouteRoute
    }
    '/company/learnpaths/add/elements/$learnpathId/(quiz)/create/quiz': {
      id: '/company/learnpaths/add/elements/$learnpathId/(quiz)/create/quiz'
      path: '/create/quiz'
      fullPath: '/company/learnpaths/add/elements/$learnpathId/create/quiz'
      preLoaderRoute: typeof CompanyLearnpathsAddElementsLearnpathIdquizCreateQuizRouteImport
      parentRoute: typeof CompanyLearnpathsAddElementsLearnpathIdRouteRoute
    }
    '/company/learnpaths/add/elements/$learnpathId/(platform-topic)/create/platform-topic': {
      id: '/company/learnpaths/add/elements/$learnpathId/(platform-topic)/create/platform-topic'
      path: '/create/platform-topic'
      fullPath: '/company/learnpaths/add/elements/$learnpathId/create/platform-topic'
      preLoaderRoute: typeof CompanyLearnpathsAddElementsLearnpathIdplatformTopicCreatePlatformTopicRouteImport
      parentRoute: typeof CompanyLearnpathsAddElementsLearnpathIdRouteRoute
    }
    '/company/learnpaths/add/elements/$learnpathId/(link)/create/link': {
      id: '/company/learnpaths/add/elements/$learnpathId/(link)/create/link'
      path: '/create/link'
      fullPath: '/company/learnpaths/add/elements/$learnpathId/create/link'
      preLoaderRoute: typeof CompanyLearnpathsAddElementsLearnpathIdlinkCreateLinkRouteImport
      parentRoute: typeof CompanyLearnpathsAddElementsLearnpathIdRouteRoute
    }
    '/company/learnpaths/add/elements/$learnpathId/(file)/create/file': {
      id: '/company/learnpaths/add/elements/$learnpathId/(file)/create/file'
      path: '/create/file'
      fullPath: '/company/learnpaths/add/elements/$learnpathId/create/file'
      preLoaderRoute: typeof CompanyLearnpathsAddElementsLearnpathIdfileCreateFileRouteImport
      parentRoute: typeof CompanyLearnpathsAddElementsLearnpathIdRouteRoute
    }
    '/company/learnpaths/add/elements/$learnpathId/(event)/create/event': {
      id: '/company/learnpaths/add/elements/$learnpathId/(event)/create/event'
      path: '/create/event'
      fullPath: '/company/learnpaths/add/elements/$learnpathId/create/event'
      preLoaderRoute: typeof CompanyLearnpathsAddElementsLearnpathIdeventCreateEventRouteImport
      parentRoute: typeof CompanyLearnpathsAddElementsLearnpathIdRouteRoute
    }
    '/company/learnpaths/add/elements/$learnpathId/(embedded-video)/create/embedded-video': {
      id: '/company/learnpaths/add/elements/$learnpathId/(embedded-video)/create/embedded-video'
      path: '/create/embedded-video'
      fullPath: '/company/learnpaths/add/elements/$learnpathId/create/embedded-video'
      preLoaderRoute: typeof CompanyLearnpathsAddElementsLearnpathIdembeddedVideoCreateEmbeddedVideoRouteImport
      parentRoute: typeof CompanyLearnpathsAddElementsLearnpathIdRouteRoute
    }
    '/_learning/_company/_list/learnpaths/view/$learnpathId/{-$elementId}/{-$topic}': {
      id: '/_learning/_company/_list/learnpaths/view/$learnpathId/{-$elementId}/{-$topic}'
      path: '/{-$elementId}/{-$topic}'
      fullPath: '/learnpaths/view/$learnpathId/{-$elementId}/{-$topic}'
      preLoaderRoute: typeof LearningCompanyListLearnpathsViewLearnpathIdChar123ElementIdChar125Char123TopicChar125RouteImport
      parentRoute: typeof LearningCompanyListLearnpathsViewLearnpathIdRoute
    }
    '/_learning/_company/_list/company-courses/view/$learnpathId/{-$elementId}/{-$topic}': {
      id: '/_learning/_company/_list/company-courses/view/$learnpathId/{-$elementId}/{-$topic}'
      path: '/{-$elementId}/{-$topic}'
      fullPath: '/company-courses/view/$learnpathId/{-$elementId}/{-$topic}'
      preLoaderRoute: typeof LearningCompanyListCompanyCoursesViewLearnpathIdChar123ElementIdChar125Char123TopicChar125RouteImport
      parentRoute: typeof LearningCompanyListCompanyCoursesViewLearnpathIdRoute
    }
    '/company/learnpaths/add/elements/$learnpathId/(video)/update/video/$elementId': {
      id: '/company/learnpaths/add/elements/$learnpathId/(video)/update/video/$elementId'
      path: '/update/video/$elementId'
      fullPath: '/company/learnpaths/add/elements/$learnpathId/update/video/$elementId'
      preLoaderRoute: typeof CompanyLearnpathsAddElementsLearnpathIdvideoUpdateVideoElementIdRouteImport
      parentRoute: typeof CompanyLearnpathsAddElementsLearnpathIdRouteRoute
    }
    '/company/learnpaths/add/elements/$learnpathId/(video)/delete/video/$elementId': {
      id: '/company/learnpaths/add/elements/$learnpathId/(video)/delete/video/$elementId'
      path: '/delete/video/$elementId'
      fullPath: '/company/learnpaths/add/elements/$learnpathId/delete/video/$elementId'
      preLoaderRoute: typeof CompanyLearnpathsAddElementsLearnpathIdvideoDeleteVideoElementIdRouteImport
      parentRoute: typeof CompanyLearnpathsAddElementsLearnpathIdRouteRoute
    }
    '/company/learnpaths/add/elements/$learnpathId/(text)/update/text/$elementId': {
      id: '/company/learnpaths/add/elements/$learnpathId/(text)/update/text/$elementId'
      path: '/update/text/$elementId'
      fullPath: '/company/learnpaths/add/elements/$learnpathId/update/text/$elementId'
      preLoaderRoute: typeof CompanyLearnpathsAddElementsLearnpathIdtextUpdateTextElementIdRouteImport
      parentRoute: typeof CompanyLearnpathsAddElementsLearnpathIdRouteRoute
    }
    '/company/learnpaths/add/elements/$learnpathId/(text)/delete/text/$elementId': {
      id: '/company/learnpaths/add/elements/$learnpathId/(text)/delete/text/$elementId'
      path: '/delete/text/$elementId'
      fullPath: '/company/learnpaths/add/elements/$learnpathId/delete/text/$elementId'
      preLoaderRoute: typeof CompanyLearnpathsAddElementsLearnpathIdtextDeleteTextElementIdRouteImport
      parentRoute: typeof CompanyLearnpathsAddElementsLearnpathIdRouteRoute
    }
    '/company/learnpaths/add/elements/$learnpathId/(scorm)/update/scorm/$elementId': {
      id: '/company/learnpaths/add/elements/$learnpathId/(scorm)/update/scorm/$elementId'
      path: '/update/scorm/$elementId'
      fullPath: '/company/learnpaths/add/elements/$learnpathId/update/scorm/$elementId'
      preLoaderRoute: typeof CompanyLearnpathsAddElementsLearnpathIdscormUpdateScormElementIdRouteImport
      parentRoute: typeof CompanyLearnpathsAddElementsLearnpathIdRouteRoute
    }
    '/company/learnpaths/add/elements/$learnpathId/(scorm)/delete/scorm/$elementId': {
      id: '/company/learnpaths/add/elements/$learnpathId/(scorm)/delete/scorm/$elementId'
      path: '/delete/scorm/$elementId'
      fullPath: '/company/learnpaths/add/elements/$learnpathId/delete/scorm/$elementId'
      preLoaderRoute: typeof CompanyLearnpathsAddElementsLearnpathIdscormDeleteScormElementIdRouteImport
      parentRoute: typeof CompanyLearnpathsAddElementsLearnpathIdRouteRoute
    }
    '/company/learnpaths/add/elements/$learnpathId/(quiz)/update/quiz/$elementId': {
      id: '/company/learnpaths/add/elements/$learnpathId/(quiz)/update/quiz/$elementId'
      path: '/update/quiz/$elementId'
      fullPath: '/company/learnpaths/add/elements/$learnpathId/update/quiz/$elementId'
      preLoaderRoute: typeof CompanyLearnpathsAddElementsLearnpathIdquizUpdateQuizElementIdRouteImport
      parentRoute: typeof CompanyLearnpathsAddElementsLearnpathIdRouteRoute
    }
    '/company/learnpaths/add/elements/$learnpathId/(quiz)/delete/quiz/$elementId': {
      id: '/company/learnpaths/add/elements/$learnpathId/(quiz)/delete/quiz/$elementId'
      path: '/delete/quiz/$elementId'
      fullPath: '/company/learnpaths/add/elements/$learnpathId/delete/quiz/$elementId'
      preLoaderRoute: typeof CompanyLearnpathsAddElementsLearnpathIdquizDeleteQuizElementIdRouteImport
      parentRoute: typeof CompanyLearnpathsAddElementsLearnpathIdRouteRoute
    }
    '/company/learnpaths/add/elements/$learnpathId/(platform-topic)/update/platform-topic/$elementId': {
      id: '/company/learnpaths/add/elements/$learnpathId/(platform-topic)/update/platform-topic/$elementId'
      path: '/update/platform-topic/$elementId'
      fullPath: '/company/learnpaths/add/elements/$learnpathId/update/platform-topic/$elementId'
      preLoaderRoute: typeof CompanyLearnpathsAddElementsLearnpathIdplatformTopicUpdatePlatformTopicElementIdRouteImport
      parentRoute: typeof CompanyLearnpathsAddElementsLearnpathIdRouteRoute
    }
    '/company/learnpaths/add/elements/$learnpathId/(platform-topic)/delete/platform-topic/$elementId': {
      id: '/company/learnpaths/add/elements/$learnpathId/(platform-topic)/delete/platform-topic/$elementId'
      path: '/delete/platform-topic/$elementId'
      fullPath: '/company/learnpaths/add/elements/$learnpathId/delete/platform-topic/$elementId'
      preLoaderRoute: typeof CompanyLearnpathsAddElementsLearnpathIdplatformTopicDeletePlatformTopicElementIdRouteImport
      parentRoute: typeof CompanyLearnpathsAddElementsLearnpathIdRouteRoute
    }
    '/company/learnpaths/add/elements/$learnpathId/(link)/update/link/$elementId': {
      id: '/company/learnpaths/add/elements/$learnpathId/(link)/update/link/$elementId'
      path: '/update/link/$elementId'
      fullPath: '/company/learnpaths/add/elements/$learnpathId/update/link/$elementId'
      preLoaderRoute: typeof CompanyLearnpathsAddElementsLearnpathIdlinkUpdateLinkElementIdRouteImport
      parentRoute: typeof CompanyLearnpathsAddElementsLearnpathIdRouteRoute
    }
    '/company/learnpaths/add/elements/$learnpathId/(link)/delete/link/$elementId': {
      id: '/company/learnpaths/add/elements/$learnpathId/(link)/delete/link/$elementId'
      path: '/delete/link/$elementId'
      fullPath: '/company/learnpaths/add/elements/$learnpathId/delete/link/$elementId'
      preLoaderRoute: typeof CompanyLearnpathsAddElementsLearnpathIdlinkDeleteLinkElementIdRouteImport
      parentRoute: typeof CompanyLearnpathsAddElementsLearnpathIdRouteRoute
    }
    '/company/learnpaths/add/elements/$learnpathId/(file)/update/file/$elementId': {
      id: '/company/learnpaths/add/elements/$learnpathId/(file)/update/file/$elementId'
      path: '/update/file/$elementId'
      fullPath: '/company/learnpaths/add/elements/$learnpathId/update/file/$elementId'
      preLoaderRoute: typeof CompanyLearnpathsAddElementsLearnpathIdfileUpdateFileElementIdRouteImport
      parentRoute: typeof CompanyLearnpathsAddElementsLearnpathIdRouteRoute
    }
    '/company/learnpaths/add/elements/$learnpathId/(file)/delete/file/$elementId': {
      id: '/company/learnpaths/add/elements/$learnpathId/(file)/delete/file/$elementId'
      path: '/delete/file/$elementId'
      fullPath: '/company/learnpaths/add/elements/$learnpathId/delete/file/$elementId'
      preLoaderRoute: typeof CompanyLearnpathsAddElementsLearnpathIdfileDeleteFileElementIdRouteImport
      parentRoute: typeof CompanyLearnpathsAddElementsLearnpathIdRouteRoute
    }
    '/company/learnpaths/add/elements/$learnpathId/(event)/update/event/$elementId': {
      id: '/company/learnpaths/add/elements/$learnpathId/(event)/update/event/$elementId'
      path: '/update/event/$elementId'
      fullPath: '/company/learnpaths/add/elements/$learnpathId/update/event/$elementId'
      preLoaderRoute: typeof CompanyLearnpathsAddElementsLearnpathIdeventUpdateEventElementIdRouteImport
      parentRoute: typeof CompanyLearnpathsAddElementsLearnpathIdRouteRoute
    }
    '/company/learnpaths/add/elements/$learnpathId/(event)/delete/event/$elementId': {
      id: '/company/learnpaths/add/elements/$learnpathId/(event)/delete/event/$elementId'
      path: '/delete/event/$elementId'
      fullPath: '/company/learnpaths/add/elements/$learnpathId/delete/event/$elementId'
      preLoaderRoute: typeof CompanyLearnpathsAddElementsLearnpathIdeventDeleteEventElementIdRouteImport
      parentRoute: typeof CompanyLearnpathsAddElementsLearnpathIdRouteRoute
    }
    '/company/learnpaths/add/elements/$learnpathId/(embedded-video)/update/embedded-video/$elementId': {
      id: '/company/learnpaths/add/elements/$learnpathId/(embedded-video)/update/embedded-video/$elementId'
      path: '/update/embedded-video/$elementId'
      fullPath: '/company/learnpaths/add/elements/$learnpathId/update/embedded-video/$elementId'
      preLoaderRoute: typeof CompanyLearnpathsAddElementsLearnpathIdembeddedVideoUpdateEmbeddedVideoElementIdRouteImport
      parentRoute: typeof CompanyLearnpathsAddElementsLearnpathIdRouteRoute
    }
    '/company/learnpaths/add/elements/$learnpathId/(embedded-video)/delete/embedded-video/$elementId': {
      id: '/company/learnpaths/add/elements/$learnpathId/(embedded-video)/delete/embedded-video/$elementId'
      path: '/delete/embedded-video/$elementId'
      fullPath: '/company/learnpaths/add/elements/$learnpathId/delete/embedded-video/$elementId'
      preLoaderRoute: typeof CompanyLearnpathsAddElementsLearnpathIdembeddedVideoDeleteEmbeddedVideoElementIdRouteImport
      parentRoute: typeof CompanyLearnpathsAddElementsLearnpathIdRouteRoute
    }
    '/company/learnpaths/add/elements/$learnpathId/(video)/update/video/$elementId/$assetId': {
      id: '/company/learnpaths/add/elements/$learnpathId/(video)/update/video/$elementId/$assetId'
      path: '/$assetId'
      fullPath: '/company/learnpaths/add/elements/$learnpathId/update/video/$elementId/$assetId'
      preLoaderRoute: typeof CompanyLearnpathsAddElementsLearnpathIdvideoUpdateVideoElementIdAssetIdRouteImport
      parentRoute: typeof CompanyLearnpathsAddElementsLearnpathIdvideoUpdateVideoElementIdRoute
    }
    '/company/learnpaths/add/elements/$learnpathId/(video)/create/video/$elementId/$assetId': {
      id: '/company/learnpaths/add/elements/$learnpathId/(video)/create/video/$elementId/$assetId'
      path: '/$elementId/$assetId'
      fullPath: '/company/learnpaths/add/elements/$learnpathId/create/video/$elementId/$assetId'
      preLoaderRoute: typeof CompanyLearnpathsAddElementsLearnpathIdvideoCreateVideoElementIdAssetIdRouteImport
      parentRoute: typeof CompanyLearnpathsAddElementsLearnpathIdvideoCreateVideoRoute
    }
    '/company/learnpaths/add/elements/$learnpathId/(file)/update/file/$elementId/$assetId': {
      id: '/company/learnpaths/add/elements/$learnpathId/(file)/update/file/$elementId/$assetId'
      path: '/$assetId'
      fullPath: '/company/learnpaths/add/elements/$learnpathId/update/file/$elementId/$assetId'
      preLoaderRoute: typeof CompanyLearnpathsAddElementsLearnpathIdfileUpdateFileElementIdAssetIdRouteImport
      parentRoute: typeof CompanyLearnpathsAddElementsLearnpathIdfileUpdateFileElementIdRoute
    }
    '/company/learnpaths/add/elements/$learnpathId/(file)/create/file/$elementId/$assetId': {
      id: '/company/learnpaths/add/elements/$learnpathId/(file)/create/file/$elementId/$assetId'
      path: '/$elementId/$assetId'
      fullPath: '/company/learnpaths/add/elements/$learnpathId/create/file/$elementId/$assetId'
      preLoaderRoute: typeof CompanyLearnpathsAddElementsLearnpathIdfileCreateFileElementIdAssetIdRouteImport
      parentRoute: typeof CompanyLearnpathsAddElementsLearnpathIdfileCreateFileRoute
    }
    '/company/learnpaths/add/elements/$learnpathId/(platform-topic)/update/platform-topic/$elementId/preview/$topicId/$lectureId': {
      id: '/company/learnpaths/add/elements/$learnpathId/(platform-topic)/update/platform-topic/$elementId/preview/$topicId/$lectureId'
      path: '/preview/$topicId/$lectureId'
      fullPath: '/company/learnpaths/add/elements/$learnpathId/update/platform-topic/$elementId/preview/$topicId/$lectureId'
      preLoaderRoute: typeof CompanyLearnpathsAddElementsLearnpathIdplatformTopicUpdatePlatformTopicElementIdPreviewTopicIdLectureIdRouteImport
      parentRoute: typeof CompanyLearnpathsAddElementsLearnpathIdplatformTopicUpdatePlatformTopicElementIdRoute
    }
    '/company/learnpaths/add/elements/$learnpathId/(platform-topic)/create/platform-topic/$elementId/preview/$topicId/$lectureId': {
      id: '/company/learnpaths/add/elements/$learnpathId/(platform-topic)/create/platform-topic/$elementId/preview/$topicId/$lectureId'
      path: '/$elementId/preview/$topicId/$lectureId'
      fullPath: '/company/learnpaths/add/elements/$learnpathId/create/platform-topic/$elementId/preview/$topicId/$lectureId'
      preLoaderRoute: typeof CompanyLearnpathsAddElementsLearnpathIdplatformTopicCreatePlatformTopicElementIdPreviewTopicIdLectureIdRouteImport
      parentRoute: typeof CompanyLearnpathsAddElementsLearnpathIdplatformTopicCreatePlatformTopicRoute
    }
  }
}

interface LearningCompanyListCompanyCoursesViewLearnpathIdRouteChildren {
  LearningCompanyListCompanyCoursesViewLearnpathIdChar123ElementIdChar125Char123TopicChar125Route: typeof LearningCompanyListCompanyCoursesViewLearnpathIdChar123ElementIdChar125Char123TopicChar125Route
}

const LearningCompanyListCompanyCoursesViewLearnpathIdRouteChildren: LearningCompanyListCompanyCoursesViewLearnpathIdRouteChildren =
  {
    LearningCompanyListCompanyCoursesViewLearnpathIdChar123ElementIdChar125Char123TopicChar125Route:
      LearningCompanyListCompanyCoursesViewLearnpathIdChar123ElementIdChar125Char123TopicChar125Route,
  }

const LearningCompanyListCompanyCoursesViewLearnpathIdRouteWithChildren =
  LearningCompanyListCompanyCoursesViewLearnpathIdRoute._addFileChildren(
    LearningCompanyListCompanyCoursesViewLearnpathIdRouteChildren,
  )

interface LearningCompanyListCompanyCoursesRouteChildren {
  LearningCompanyListCompanyCoursesViewLearnpathIdRoute: typeof LearningCompanyListCompanyCoursesViewLearnpathIdRouteWithChildren
}

const LearningCompanyListCompanyCoursesRouteChildren: LearningCompanyListCompanyCoursesRouteChildren =
  {
    LearningCompanyListCompanyCoursesViewLearnpathIdRoute:
      LearningCompanyListCompanyCoursesViewLearnpathIdRouteWithChildren,
  }

const LearningCompanyListCompanyCoursesRouteWithChildren =
  LearningCompanyListCompanyCoursesRoute._addFileChildren(
    LearningCompanyListCompanyCoursesRouteChildren,
  )

interface LearningCompanyListLearnpathsViewLearnpathIdRouteChildren {
  LearningCompanyListLearnpathsViewLearnpathIdChar123ElementIdChar125Char123TopicChar125Route: typeof LearningCompanyListLearnpathsViewLearnpathIdChar123ElementIdChar125Char123TopicChar125Route
}

const LearningCompanyListLearnpathsViewLearnpathIdRouteChildren: LearningCompanyListLearnpathsViewLearnpathIdRouteChildren =
  {
    LearningCompanyListLearnpathsViewLearnpathIdChar123ElementIdChar125Char123TopicChar125Route:
      LearningCompanyListLearnpathsViewLearnpathIdChar123ElementIdChar125Char123TopicChar125Route,
  }

const LearningCompanyListLearnpathsViewLearnpathIdRouteWithChildren =
  LearningCompanyListLearnpathsViewLearnpathIdRoute._addFileChildren(
    LearningCompanyListLearnpathsViewLearnpathIdRouteChildren,
  )

interface LearningCompanyListLearnpathsRouteChildren {
  LearningCompanyListLearnpathsViewLearnpathIdRoute: typeof LearningCompanyListLearnpathsViewLearnpathIdRouteWithChildren
}

const LearningCompanyListLearnpathsRouteChildren: LearningCompanyListLearnpathsRouteChildren =
  {
    LearningCompanyListLearnpathsViewLearnpathIdRoute:
      LearningCompanyListLearnpathsViewLearnpathIdRouteWithChildren,
  }

const LearningCompanyListLearnpathsRouteWithChildren =
  LearningCompanyListLearnpathsRoute._addFileChildren(
    LearningCompanyListLearnpathsRouteChildren,
  )

interface LearningCompanyListRouteRouteChildren {
  LearningCompanyListCompanyCoursesRoute: typeof LearningCompanyListCompanyCoursesRouteWithChildren
  LearningCompanyListLearnpathsRoute: typeof LearningCompanyListLearnpathsRouteWithChildren
}

const LearningCompanyListRouteRouteChildren: LearningCompanyListRouteRouteChildren =
  {
    LearningCompanyListCompanyCoursesRoute:
      LearningCompanyListCompanyCoursesRouteWithChildren,
    LearningCompanyListLearnpathsRoute:
      LearningCompanyListLearnpathsRouteWithChildren,
  }

const LearningCompanyListRouteRouteWithChildren =
  LearningCompanyListRouteRoute._addFileChildren(
    LearningCompanyListRouteRouteChildren,
  )

interface LearningCompanyExclusiveContentRouteChildren {
  LearningCompanyExclusiveContentViewTopicRoute: typeof LearningCompanyExclusiveContentViewTopicRoute
}

const LearningCompanyExclusiveContentRouteChildren: LearningCompanyExclusiveContentRouteChildren =
  {
    LearningCompanyExclusiveContentViewTopicRoute:
      LearningCompanyExclusiveContentViewTopicRoute,
  }

const LearningCompanyExclusiveContentRouteWithChildren =
  LearningCompanyExclusiveContentRoute._addFileChildren(
    LearningCompanyExclusiveContentRouteChildren,
  )

interface LearningCompanyRouteRouteChildren {
  LearningCompanyListRouteRoute: typeof LearningCompanyListRouteRouteWithChildren
  LearningCompanyExclusiveContentRoute: typeof LearningCompanyExclusiveContentRouteWithChildren
  LearningCompanyLearngroupRoute: typeof LearningCompanyLearngroupRoute
}

const LearningCompanyRouteRouteChildren: LearningCompanyRouteRouteChildren = {
  LearningCompanyListRouteRoute: LearningCompanyListRouteRouteWithChildren,
  LearningCompanyExclusiveContentRoute:
    LearningCompanyExclusiveContentRouteWithChildren,
  LearningCompanyLearngroupRoute: LearningCompanyLearngroupRoute,
}

const LearningCompanyRouteRouteWithChildren =
  LearningCompanyRouteRoute._addFileChildren(LearningCompanyRouteRouteChildren)

interface LearningMyLearningUserProgressRouteChildren {
  LearningMyLearningUserProgressViewTopicRoute: typeof LearningMyLearningUserProgressViewTopicRoute
}

const LearningMyLearningUserProgressRouteChildren: LearningMyLearningUserProgressRouteChildren =
  {
    LearningMyLearningUserProgressViewTopicRoute:
      LearningMyLearningUserProgressViewTopicRoute,
  }

const LearningMyLearningUserProgressRouteWithChildren =
  LearningMyLearningUserProgressRoute._addFileChildren(
    LearningMyLearningUserProgressRouteChildren,
  )

interface LearningMyLearningRouteRouteChildren {
  LearningMyLearningAchievementsRoute: typeof LearningMyLearningAchievementsRoute
  LearningMyLearningCertificatesRoute: typeof LearningMyLearningCertificatesRoute
  LearningMyLearningHomeBookmarkedRoute: typeof LearningMyLearningHomeBookmarkedRoute
  LearningMyLearningHomeNotesRoute: typeof LearningMyLearningHomeNotesRoute
  LearningMyLearningUserProgressRoute: typeof LearningMyLearningUserProgressRouteWithChildren
  LearningMyLearningCertificateCertificateIdPersonalizeRoute: typeof LearningMyLearningCertificateCertificateIdPersonalizeRoute
  LearningMyLearningCertificateCertificateIdPollRoute: typeof LearningMyLearningCertificateCertificateIdPollRoute
}

const LearningMyLearningRouteRouteChildren: LearningMyLearningRouteRouteChildren =
  {
    LearningMyLearningAchievementsRoute: LearningMyLearningAchievementsRoute,
    LearningMyLearningCertificatesRoute: LearningMyLearningCertificatesRoute,
    LearningMyLearningHomeBookmarkedRoute:
      LearningMyLearningHomeBookmarkedRoute,
    LearningMyLearningHomeNotesRoute: LearningMyLearningHomeNotesRoute,
    LearningMyLearningUserProgressRoute:
      LearningMyLearningUserProgressRouteWithChildren,
    LearningMyLearningCertificateCertificateIdPersonalizeRoute:
      LearningMyLearningCertificateCertificateIdPersonalizeRoute,
    LearningMyLearningCertificateCertificateIdPollRoute:
      LearningMyLearningCertificateCertificateIdPollRoute,
  }

const LearningMyLearningRouteRouteWithChildren =
  LearningMyLearningRouteRoute._addFileChildren(
    LearningMyLearningRouteRouteChildren,
  )

interface LearningDiscoverChannelsChannelRouteChildren {
  LearningDiscoverChannelsChannelViewTopicRoute: typeof LearningDiscoverChannelsChannelViewTopicRoute
}

const LearningDiscoverChannelsChannelRouteChildren: LearningDiscoverChannelsChannelRouteChildren =
  {
    LearningDiscoverChannelsChannelViewTopicRoute:
      LearningDiscoverChannelsChannelViewTopicRoute,
  }

const LearningDiscoverChannelsChannelRouteWithChildren =
  LearningDiscoverChannelsChannelRoute._addFileChildren(
    LearningDiscoverChannelsChannelRouteChildren,
  )

interface LearningDiscoverChannelsOverviewRouteChildren {
  LearningDiscoverChannelsOverviewIndexRoute: typeof LearningDiscoverChannelsOverviewIndexRoute
  LearningDiscoverChannelsOverviewViewChannelTopicRoute: typeof LearningDiscoverChannelsOverviewViewChannelTopicRoute
}

const LearningDiscoverChannelsOverviewRouteChildren: LearningDiscoverChannelsOverviewRouteChildren =
  {
    LearningDiscoverChannelsOverviewIndexRoute:
      LearningDiscoverChannelsOverviewIndexRoute,
    LearningDiscoverChannelsOverviewViewChannelTopicRoute:
      LearningDiscoverChannelsOverviewViewChannelTopicRoute,
  }

const LearningDiscoverChannelsOverviewRouteWithChildren =
  LearningDiscoverChannelsOverviewRoute._addFileChildren(
    LearningDiscoverChannelsOverviewRouteChildren,
  )

interface LearningDiscoverChannelsRouteChildren {
  LearningDiscoverChannelsChannelRoute: typeof LearningDiscoverChannelsChannelRouteWithChildren
  LearningDiscoverChannelsOverviewRoute: typeof LearningDiscoverChannelsOverviewRouteWithChildren
  LearningDiscoverChannelsViewRoute: typeof LearningDiscoverChannelsViewRoute
}

const LearningDiscoverChannelsRouteChildren: LearningDiscoverChannelsRouteChildren =
  {
    LearningDiscoverChannelsChannelRoute:
      LearningDiscoverChannelsChannelRouteWithChildren,
    LearningDiscoverChannelsOverviewRoute:
      LearningDiscoverChannelsOverviewRouteWithChildren,
    LearningDiscoverChannelsViewRoute: LearningDiscoverChannelsViewRoute,
  }

const LearningDiscoverChannelsRouteWithChildren =
  LearningDiscoverChannelsRoute._addFileChildren(
    LearningDiscoverChannelsRouteChildren,
  )

interface LearningDiscoverCourseGenericCourseSlugRouteChildren {
  LearningDiscoverCourseGenericCourseSlugThemeSlugRoute: typeof LearningDiscoverCourseGenericCourseSlugThemeSlugRoute
  LearningDiscoverCourseGenericCourseSlugIndexRoute: typeof LearningDiscoverCourseGenericCourseSlugIndexRoute
}

const LearningDiscoverCourseGenericCourseSlugRouteChildren: LearningDiscoverCourseGenericCourseSlugRouteChildren =
  {
    LearningDiscoverCourseGenericCourseSlugThemeSlugRoute:
      LearningDiscoverCourseGenericCourseSlugThemeSlugRoute,
    LearningDiscoverCourseGenericCourseSlugIndexRoute:
      LearningDiscoverCourseGenericCourseSlugIndexRoute,
  }

const LearningDiscoverCourseGenericCourseSlugRouteWithChildren =
  LearningDiscoverCourseGenericCourseSlugRoute._addFileChildren(
    LearningDiscoverCourseGenericCourseSlugRouteChildren,
  )

interface LearningDiscoverCourseGenericRouteChildren {
  LearningDiscoverCourseGenericCourseSlugRoute: typeof LearningDiscoverCourseGenericCourseSlugRouteWithChildren
}

const LearningDiscoverCourseGenericRouteChildren: LearningDiscoverCourseGenericRouteChildren =
  {
    LearningDiscoverCourseGenericCourseSlugRoute:
      LearningDiscoverCourseGenericCourseSlugRouteWithChildren,
  }

const LearningDiscoverCourseGenericRouteWithChildren =
  LearningDiscoverCourseGenericRoute._addFileChildren(
    LearningDiscoverCourseGenericRouteChildren,
  )

interface LearningDiscoverSearchQueryRouteChildren {
  LearningDiscoverSearchQueryViewTopicRoute: typeof LearningDiscoverSearchQueryViewTopicRoute
}

const LearningDiscoverSearchQueryRouteChildren: LearningDiscoverSearchQueryRouteChildren =
  {
    LearningDiscoverSearchQueryViewTopicRoute:
      LearningDiscoverSearchQueryViewTopicRoute,
  }

const LearningDiscoverSearchQueryRouteWithChildren =
  LearningDiscoverSearchQueryRoute._addFileChildren(
    LearningDiscoverSearchQueryRouteChildren,
  )

interface LearningDiscoverRouteRouteChildren {
  LearningDiscoverChannelsRoute: typeof LearningDiscoverChannelsRouteWithChildren
  LearningDiscoverCourseGenericRoute: typeof LearningDiscoverCourseGenericRouteWithChildren
  LearningDiscoverdeprecatedChannelSlugRoute: typeof LearningDiscoverdeprecatedChannelSlugRoute
  LearningDiscoverdeprecatedGrundlagenkursDigitalisierungRoute: typeof LearningDiscoverdeprecatedGrundlagenkursDigitalisierungRoute
  LearningDiscoverSearchQueryRoute: typeof LearningDiscoverSearchQueryRouteWithChildren
  LearningDiscoverdeprecatedIndexRoute: typeof LearningDiscoverdeprecatedIndexRoute
}

const LearningDiscoverRouteRouteChildren: LearningDiscoverRouteRouteChildren = {
  LearningDiscoverChannelsRoute: LearningDiscoverChannelsRouteWithChildren,
  LearningDiscoverCourseGenericRoute:
    LearningDiscoverCourseGenericRouteWithChildren,
  LearningDiscoverdeprecatedChannelSlugRoute:
    LearningDiscoverdeprecatedChannelSlugRoute,
  LearningDiscoverdeprecatedGrundlagenkursDigitalisierungRoute:
    LearningDiscoverdeprecatedGrundlagenkursDigitalisierungRoute,
  LearningDiscoverSearchQueryRoute:
    LearningDiscoverSearchQueryRouteWithChildren,
  LearningDiscoverdeprecatedIndexRoute: LearningDiscoverdeprecatedIndexRoute,
}

const LearningDiscoverRouteRouteWithChildren =
  LearningDiscoverRouteRoute._addFileChildren(
    LearningDiscoverRouteRouteChildren,
  )

interface LearningGrowthMapRouteRouteChildren {
  LearningGrowthMapSkillSlugRoute: typeof LearningGrowthMapSkillSlugRoute
  LearningGrowthMapIndexRoute: typeof LearningGrowthMapIndexRoute
}

const LearningGrowthMapRouteRouteChildren: LearningGrowthMapRouteRouteChildren =
  {
    LearningGrowthMapSkillSlugRoute: LearningGrowthMapSkillSlugRoute,
    LearningGrowthMapIndexRoute: LearningGrowthMapIndexRoute,
  }

const LearningGrowthMapRouteRouteWithChildren =
  LearningGrowthMapRouteRoute._addFileChildren(
    LearningGrowthMapRouteRouteChildren,
  )

interface LearningHomeOverviewRouteChildren {
  LearningHomeOverviewIndexRoute: typeof LearningHomeOverviewIndexRoute
  LearningHomeOverviewViewChannelTopicRoute: typeof LearningHomeOverviewViewChannelTopicRoute
}

const LearningHomeOverviewRouteChildren: LearningHomeOverviewRouteChildren = {
  LearningHomeOverviewIndexRoute: LearningHomeOverviewIndexRoute,
  LearningHomeOverviewViewChannelTopicRoute:
    LearningHomeOverviewViewChannelTopicRoute,
}

const LearningHomeOverviewRouteWithChildren =
  LearningHomeOverviewRoute._addFileChildren(LearningHomeOverviewRouteChildren)

interface LearningRouteRouteChildren {
  LearningCompanyRouteRoute: typeof LearningCompanyRouteRouteWithChildren
  LearningMyLearningRouteRoute: typeof LearningMyLearningRouteRouteWithChildren
  LearningDiscoverRouteRoute: typeof LearningDiscoverRouteRouteWithChildren
  LearningGrowthMapRouteRoute: typeof LearningGrowthMapRouteRouteWithChildren
  LearningCoursesTopicRoute: typeof LearningCoursesTopicRoute
  LearningGlossaryChar123LetterChar125Route: typeof LearningGlossaryChar123LetterChar125Route
  LearningHomeOverviewRoute: typeof LearningHomeOverviewRouteWithChildren
  LearningHomeActivitiesRoute: typeof LearningHomeActivitiesRoute
  LearningdeprecatedDashboardCertificateRoute: typeof LearningdeprecatedDashboardCertificateRoute
  LearningdeprecatedDashboardCertificatesRoute: typeof LearningdeprecatedDashboardCertificatesRoute
  LearningLearnpathsLearnpathIdChar123ElementIdChar125Route: typeof LearningLearnpathsLearnpathIdChar123ElementIdChar125Route
  LearningLearnpathsLearnpathIdElementIdSuffixRoute: typeof LearningLearnpathsLearnpathIdElementIdSuffixRoute
  LearningPollPollIdSourceSourceIdRoute: typeof LearningPollPollIdSourceSourceIdRoute
  LearningChannelChannelTopicIndexRoute: typeof LearningChannelChannelTopicIndexRoute
  LearningCourseGenericCourseTopicIndexRoute: typeof LearningCourseGenericCourseTopicIndexRoute
  LearningSkillSkillTopicIndexRoute: typeof LearningSkillSkillTopicIndexRoute
  LearningLecturesTopicChar123LectureChar125Char123SuffixChar125Char123IdChar125Route: typeof LearningLecturesTopicChar123LectureChar125Char123SuffixChar125Char123IdChar125Route
  LearningChannelChannelTopicLectureChar123SuffixChar125Char123IdChar125Route: typeof LearningChannelChannelTopicLectureChar123SuffixChar125Char123IdChar125Route
  LearningCourseGenericCourseTopicLectureChar123SuffixChar125Char123IdChar125Route: typeof LearningCourseGenericCourseTopicLectureChar123SuffixChar125Char123IdChar125Route
  LearningCourseCourseThemeTopicLectureChar123SuffixChar125Route: typeof LearningCourseCourseThemeTopicLectureChar123SuffixChar125Route
  LearningLearnpathsLearnpathIdElementIdTopicLectureChar123SuffixChar125Route: typeof LearningLearnpathsLearnpathIdElementIdTopicLectureChar123SuffixChar125Route
  LearningSkillSkillTopicLectureChar123SuffixChar125Char123IdChar125Route: typeof LearningSkillSkillTopicLectureChar123SuffixChar125Char123IdChar125Route
}

const LearningRouteRouteChildren: LearningRouteRouteChildren = {
  LearningCompanyRouteRoute: LearningCompanyRouteRouteWithChildren,
  LearningMyLearningRouteRoute: LearningMyLearningRouteRouteWithChildren,
  LearningDiscoverRouteRoute: LearningDiscoverRouteRouteWithChildren,
  LearningGrowthMapRouteRoute: LearningGrowthMapRouteRouteWithChildren,
  LearningCoursesTopicRoute: LearningCoursesTopicRoute,
  LearningGlossaryChar123LetterChar125Route:
    LearningGlossaryChar123LetterChar125Route,
  LearningHomeOverviewRoute: LearningHomeOverviewRouteWithChildren,
  LearningHomeActivitiesRoute: LearningHomeActivitiesRoute,
  LearningdeprecatedDashboardCertificateRoute:
    LearningdeprecatedDashboardCertificateRoute,
  LearningdeprecatedDashboardCertificatesRoute:
    LearningdeprecatedDashboardCertificatesRoute,
  LearningLearnpathsLearnpathIdChar123ElementIdChar125Route:
    LearningLearnpathsLearnpathIdChar123ElementIdChar125Route,
  LearningLearnpathsLearnpathIdElementIdSuffixRoute:
    LearningLearnpathsLearnpathIdElementIdSuffixRoute,
  LearningPollPollIdSourceSourceIdRoute: LearningPollPollIdSourceSourceIdRoute,
  LearningChannelChannelTopicIndexRoute: LearningChannelChannelTopicIndexRoute,
  LearningCourseGenericCourseTopicIndexRoute:
    LearningCourseGenericCourseTopicIndexRoute,
  LearningSkillSkillTopicIndexRoute: LearningSkillSkillTopicIndexRoute,
  LearningLecturesTopicChar123LectureChar125Char123SuffixChar125Char123IdChar125Route:
    LearningLecturesTopicChar123LectureChar125Char123SuffixChar125Char123IdChar125Route,
  LearningChannelChannelTopicLectureChar123SuffixChar125Char123IdChar125Route:
    LearningChannelChannelTopicLectureChar123SuffixChar125Char123IdChar125Route,
  LearningCourseGenericCourseTopicLectureChar123SuffixChar125Char123IdChar125Route:
    LearningCourseGenericCourseTopicLectureChar123SuffixChar125Char123IdChar125Route,
  LearningCourseCourseThemeTopicLectureChar123SuffixChar125Route:
    LearningCourseCourseThemeTopicLectureChar123SuffixChar125Route,
  LearningLearnpathsLearnpathIdElementIdTopicLectureChar123SuffixChar125Route:
    LearningLearnpathsLearnpathIdElementIdTopicLectureChar123SuffixChar125Route,
  LearningSkillSkillTopicLectureChar123SuffixChar125Char123IdChar125Route:
    LearningSkillSkillTopicLectureChar123SuffixChar125Char123IdChar125Route,
}

const LearningRouteRouteWithChildren = LearningRouteRoute._addFileChildren(
  LearningRouteRouteChildren,
)

interface CompanyManagementAnalyticsRouteRouteChildren {
  CompanyManagementAnalyticsCompanyOverviewRoute: typeof CompanyManagementAnalyticsCompanyOverviewRoute
  CompanyManagementAnalyticsContentRoute: typeof CompanyManagementAnalyticsContentRoute
  CompanyManagementAnalyticsLearningPathsRoute: typeof CompanyManagementAnalyticsLearningPathsRoute
  CompanyManagementAnalyticsPerformanceRoute: typeof CompanyManagementAnalyticsPerformanceRoute
  CompanyManagementAnalyticsPowerSkillsRoute: typeof CompanyManagementAnalyticsPowerSkillsRoute
  CompanyManagementAnalyticsIndexRoute: typeof CompanyManagementAnalyticsIndexRoute
}

const CompanyManagementAnalyticsRouteRouteChildren: CompanyManagementAnalyticsRouteRouteChildren =
  {
    CompanyManagementAnalyticsCompanyOverviewRoute:
      CompanyManagementAnalyticsCompanyOverviewRoute,
    CompanyManagementAnalyticsContentRoute:
      CompanyManagementAnalyticsContentRoute,
    CompanyManagementAnalyticsLearningPathsRoute:
      CompanyManagementAnalyticsLearningPathsRoute,
    CompanyManagementAnalyticsPerformanceRoute:
      CompanyManagementAnalyticsPerformanceRoute,
    CompanyManagementAnalyticsPowerSkillsRoute:
      CompanyManagementAnalyticsPowerSkillsRoute,
    CompanyManagementAnalyticsIndexRoute: CompanyManagementAnalyticsIndexRoute,
  }

const CompanyManagementAnalyticsRouteRouteWithChildren =
  CompanyManagementAnalyticsRouteRoute._addFileChildren(
    CompanyManagementAnalyticsRouteRouteChildren,
  )

interface CompanyManagementBatchOperationsRouteRouteChildren {
  CompanyManagementBatchOperationsUploadRouteRoute: typeof CompanyManagementBatchOperationsUploadRouteRoute
}

const CompanyManagementBatchOperationsRouteRouteChildren: CompanyManagementBatchOperationsRouteRouteChildren =
  {
    CompanyManagementBatchOperationsUploadRouteRoute:
      CompanyManagementBatchOperationsUploadRouteRoute,
  }

const CompanyManagementBatchOperationsRouteRouteWithChildren =
  CompanyManagementBatchOperationsRouteRoute._addFileChildren(
    CompanyManagementBatchOperationsRouteRouteChildren,
  )

interface CompanyManagementEventsAddRouteChildren {
  CompanyManagementEventsAddMediaIdRoute: typeof CompanyManagementEventsAddMediaIdRoute
  CompanyManagementEventsAddIndexRoute: typeof CompanyManagementEventsAddIndexRoute
}

const CompanyManagementEventsAddRouteChildren: CompanyManagementEventsAddRouteChildren =
  {
    CompanyManagementEventsAddMediaIdRoute:
      CompanyManagementEventsAddMediaIdRoute,
    CompanyManagementEventsAddIndexRoute: CompanyManagementEventsAddIndexRoute,
  }

const CompanyManagementEventsAddRouteWithChildren =
  CompanyManagementEventsAddRoute._addFileChildren(
    CompanyManagementEventsAddRouteChildren,
  )

interface CompanyManagementEventsOverviewRouteChildren {
  CompanyManagementEventsOverviewMediaIdTabRoute: typeof CompanyManagementEventsOverviewMediaIdTabRoute
}

const CompanyManagementEventsOverviewRouteChildren: CompanyManagementEventsOverviewRouteChildren =
  {
    CompanyManagementEventsOverviewMediaIdTabRoute:
      CompanyManagementEventsOverviewMediaIdTabRoute,
  }

const CompanyManagementEventsOverviewRouteWithChildren =
  CompanyManagementEventsOverviewRoute._addFileChildren(
    CompanyManagementEventsOverviewRouteChildren,
  )

interface CompanyManagementEventsRouteRouteChildren {
  CompanyManagementEventsAddRoute: typeof CompanyManagementEventsAddRouteWithChildren
  CompanyManagementEventsOverviewRoute: typeof CompanyManagementEventsOverviewRouteWithChildren
}

const CompanyManagementEventsRouteRouteChildren: CompanyManagementEventsRouteRouteChildren =
  {
    CompanyManagementEventsAddRoute:
      CompanyManagementEventsAddRouteWithChildren,
    CompanyManagementEventsOverviewRoute:
      CompanyManagementEventsOverviewRouteWithChildren,
  }

const CompanyManagementEventsRouteRouteWithChildren =
  CompanyManagementEventsRouteRoute._addFileChildren(
    CompanyManagementEventsRouteRouteChildren,
  )

interface CompanyManagementGroupsGroupIdMembersRouteRouteChildren {
  CompanyManagementGroupsGroupIdMembersAddRoute: typeof CompanyManagementGroupsGroupIdMembersAddRoute
}

const CompanyManagementGroupsGroupIdMembersRouteRouteChildren: CompanyManagementGroupsGroupIdMembersRouteRouteChildren =
  {
    CompanyManagementGroupsGroupIdMembersAddRoute:
      CompanyManagementGroupsGroupIdMembersAddRoute,
  }

const CompanyManagementGroupsGroupIdMembersRouteRouteWithChildren =
  CompanyManagementGroupsGroupIdMembersRouteRoute._addFileChildren(
    CompanyManagementGroupsGroupIdMembersRouteRouteChildren,
  )

interface CompanyManagementGroupsGroupIdRouteRouteChildren {
  CompanyManagementGroupsGroupIdDetailsRouteRoute: typeof CompanyManagementGroupsGroupIdDetailsRouteRoute
  CompanyManagementGroupsGroupIdLearnpathsRouteRoute: typeof CompanyManagementGroupsGroupIdLearnpathsRouteRoute
  CompanyManagementGroupsGroupIdMembersRouteRoute: typeof CompanyManagementGroupsGroupIdMembersRouteRouteWithChildren
}

const CompanyManagementGroupsGroupIdRouteRouteChildren: CompanyManagementGroupsGroupIdRouteRouteChildren =
  {
    CompanyManagementGroupsGroupIdDetailsRouteRoute:
      CompanyManagementGroupsGroupIdDetailsRouteRoute,
    CompanyManagementGroupsGroupIdLearnpathsRouteRoute:
      CompanyManagementGroupsGroupIdLearnpathsRouteRoute,
    CompanyManagementGroupsGroupIdMembersRouteRoute:
      CompanyManagementGroupsGroupIdMembersRouteRouteWithChildren,
  }

const CompanyManagementGroupsGroupIdRouteRouteWithChildren =
  CompanyManagementGroupsGroupIdRouteRoute._addFileChildren(
    CompanyManagementGroupsGroupIdRouteRouteChildren,
  )

interface CompanyManagementGroupsRouteRouteChildren {
  CompanyManagementGroupsGroupIdRouteRoute: typeof CompanyManagementGroupsGroupIdRouteRouteWithChildren
  CompanyManagementGroupsAddRoute: typeof CompanyManagementGroupsAddRoute
}

const CompanyManagementGroupsRouteRouteChildren: CompanyManagementGroupsRouteRouteChildren =
  {
    CompanyManagementGroupsGroupIdRouteRoute:
      CompanyManagementGroupsGroupIdRouteRouteWithChildren,
    CompanyManagementGroupsAddRoute: CompanyManagementGroupsAddRoute,
  }

const CompanyManagementGroupsRouteRouteWithChildren =
  CompanyManagementGroupsRouteRoute._addFileChildren(
    CompanyManagementGroupsRouteRouteChildren,
  )

interface CompanyManagementLicensesStructureNodeIdPanelRouteChildren {
  CompanyManagementLicensesStructureNodeIdPanelLearnersRoute: typeof CompanyManagementLicensesStructureNodeIdPanelLearnersRoute
  CompanyManagementLicensesStructureNodeIdPanelIndexRoute: typeof CompanyManagementLicensesStructureNodeIdPanelIndexRoute
}

const CompanyManagementLicensesStructureNodeIdPanelRouteChildren: CompanyManagementLicensesStructureNodeIdPanelRouteChildren =
  {
    CompanyManagementLicensesStructureNodeIdPanelLearnersRoute:
      CompanyManagementLicensesStructureNodeIdPanelLearnersRoute,
    CompanyManagementLicensesStructureNodeIdPanelIndexRoute:
      CompanyManagementLicensesStructureNodeIdPanelIndexRoute,
  }

const CompanyManagementLicensesStructureNodeIdPanelRouteWithChildren =
  CompanyManagementLicensesStructureNodeIdPanelRoute._addFileChildren(
    CompanyManagementLicensesStructureNodeIdPanelRouteChildren,
  )

interface CompanyManagementLicensesStructureNodeIdRouteChildren {
  CompanyManagementLicensesStructureNodeIdPanelRoute: typeof CompanyManagementLicensesStructureNodeIdPanelRouteWithChildren
  CompanyManagementLicensesStructureNodeIdLearnerLearnerIdRoute: typeof CompanyManagementLicensesStructureNodeIdLearnerLearnerIdRoute
}

const CompanyManagementLicensesStructureNodeIdRouteChildren: CompanyManagementLicensesStructureNodeIdRouteChildren =
  {
    CompanyManagementLicensesStructureNodeIdPanelRoute:
      CompanyManagementLicensesStructureNodeIdPanelRouteWithChildren,
    CompanyManagementLicensesStructureNodeIdLearnerLearnerIdRoute:
      CompanyManagementLicensesStructureNodeIdLearnerLearnerIdRoute,
  }

const CompanyManagementLicensesStructureNodeIdRouteWithChildren =
  CompanyManagementLicensesStructureNodeIdRoute._addFileChildren(
    CompanyManagementLicensesStructureNodeIdRouteChildren,
  )

interface CompanyManagementLicensesStructureRouteRouteChildren {
  CompanyManagementLicensesStructureNodeIdRoute: typeof CompanyManagementLicensesStructureNodeIdRouteWithChildren
}

const CompanyManagementLicensesStructureRouteRouteChildren: CompanyManagementLicensesStructureRouteRouteChildren =
  {
    CompanyManagementLicensesStructureNodeIdRoute:
      CompanyManagementLicensesStructureNodeIdRouteWithChildren,
  }

const CompanyManagementLicensesStructureRouteRouteWithChildren =
  CompanyManagementLicensesStructureRouteRoute._addFileChildren(
    CompanyManagementLicensesStructureRouteRouteChildren,
  )

interface CompanyManagementSettingsRouteRouteChildren {
  CompanyManagementSettingsRolesRoute: typeof CompanyManagementSettingsRolesRoute
  CompanyManagementSettingsIndexRoute: typeof CompanyManagementSettingsIndexRoute
}

const CompanyManagementSettingsRouteRouteChildren: CompanyManagementSettingsRouteRouteChildren =
  {
    CompanyManagementSettingsRolesRoute: CompanyManagementSettingsRolesRoute,
    CompanyManagementSettingsIndexRoute: CompanyManagementSettingsIndexRoute,
  }

const CompanyManagementSettingsRouteRouteWithChildren =
  CompanyManagementSettingsRouteRoute._addFileChildren(
    CompanyManagementSettingsRouteRouteChildren,
  )

interface CompanyManagementUsersUserIdRouteChildren {
  CompanyManagementUsersUserIdLearningPathsRoute: typeof CompanyManagementUsersUserIdLearningPathsRoute
  CompanyManagementUsersUserIdLicensesRoute: typeof CompanyManagementUsersUserIdLicensesRoute
  CompanyManagementUsersUserIdUserGroupsRoute: typeof CompanyManagementUsersUserIdUserGroupsRoute
  CompanyManagementUsersUserIdIndexRoute: typeof CompanyManagementUsersUserIdIndexRoute
}

const CompanyManagementUsersUserIdRouteChildren: CompanyManagementUsersUserIdRouteChildren =
  {
    CompanyManagementUsersUserIdLearningPathsRoute:
      CompanyManagementUsersUserIdLearningPathsRoute,
    CompanyManagementUsersUserIdLicensesRoute:
      CompanyManagementUsersUserIdLicensesRoute,
    CompanyManagementUsersUserIdUserGroupsRoute:
      CompanyManagementUsersUserIdUserGroupsRoute,
    CompanyManagementUsersUserIdIndexRoute:
      CompanyManagementUsersUserIdIndexRoute,
  }

const CompanyManagementUsersUserIdRouteWithChildren =
  CompanyManagementUsersUserIdRoute._addFileChildren(
    CompanyManagementUsersUserIdRouteChildren,
  )

interface CompanyManagementUsersRouteRouteChildren {
  CompanyManagementUsersUserIdRoute: typeof CompanyManagementUsersUserIdRouteWithChildren
}

const CompanyManagementUsersRouteRouteChildren: CompanyManagementUsersRouteRouteChildren =
  {
    CompanyManagementUsersUserIdRoute:
      CompanyManagementUsersUserIdRouteWithChildren,
  }

const CompanyManagementUsersRouteRouteWithChildren =
  CompanyManagementUsersRouteRoute._addFileChildren(
    CompanyManagementUsersRouteRouteChildren,
  )

interface CompanyManagementCoursesOverviewRouteChildren {
  CompanyManagementCoursesOverviewMediaIdTabRoute: typeof CompanyManagementCoursesOverviewMediaIdTabRoute
}

const CompanyManagementCoursesOverviewRouteChildren: CompanyManagementCoursesOverviewRouteChildren =
  {
    CompanyManagementCoursesOverviewMediaIdTabRoute:
      CompanyManagementCoursesOverviewMediaIdTabRoute,
  }

const CompanyManagementCoursesOverviewRouteWithChildren =
  CompanyManagementCoursesOverviewRoute._addFileChildren(
    CompanyManagementCoursesOverviewRouteChildren,
  )

interface CompanyManagementLearnpathsOverviewLearnpathIdRouteChildren {
  CompanyManagementLearnpathsOverviewLearnpathIdDetailsRoute: typeof CompanyManagementLearnpathsOverviewLearnpathIdDetailsRoute
  CompanyManagementLearnpathsOverviewLearnpathIdProgressRoute: typeof CompanyManagementLearnpathsOverviewLearnpathIdProgressRoute
  CompanyManagementLearnpathsOverviewLearnpathIdProgressUserGroupsRoute: typeof CompanyManagementLearnpathsOverviewLearnpathIdProgressUserGroupsRoute
  CompanyManagementLearnpathsOverviewLearnpathIdReleasesRoute: typeof CompanyManagementLearnpathsOverviewLearnpathIdReleasesRoute
  CompanyManagementLearnpathsOverviewLearnpathIdReportsRoute: typeof CompanyManagementLearnpathsOverviewLearnpathIdReportsRoute
  CompanyManagementLearnpathsOverviewLearnpathIdTranslationsRoute: typeof CompanyManagementLearnpathsOverviewLearnpathIdTranslationsRoute
  CompanyManagementLearnpathsOverviewLearnpathIdIndexRoute: typeof CompanyManagementLearnpathsOverviewLearnpathIdIndexRoute
}

const CompanyManagementLearnpathsOverviewLearnpathIdRouteChildren: CompanyManagementLearnpathsOverviewLearnpathIdRouteChildren =
  {
    CompanyManagementLearnpathsOverviewLearnpathIdDetailsRoute:
      CompanyManagementLearnpathsOverviewLearnpathIdDetailsRoute,
    CompanyManagementLearnpathsOverviewLearnpathIdProgressRoute:
      CompanyManagementLearnpathsOverviewLearnpathIdProgressRoute,
    CompanyManagementLearnpathsOverviewLearnpathIdProgressUserGroupsRoute:
      CompanyManagementLearnpathsOverviewLearnpathIdProgressUserGroupsRoute,
    CompanyManagementLearnpathsOverviewLearnpathIdReleasesRoute:
      CompanyManagementLearnpathsOverviewLearnpathIdReleasesRoute,
    CompanyManagementLearnpathsOverviewLearnpathIdReportsRoute:
      CompanyManagementLearnpathsOverviewLearnpathIdReportsRoute,
    CompanyManagementLearnpathsOverviewLearnpathIdTranslationsRoute:
      CompanyManagementLearnpathsOverviewLearnpathIdTranslationsRoute,
    CompanyManagementLearnpathsOverviewLearnpathIdIndexRoute:
      CompanyManagementLearnpathsOverviewLearnpathIdIndexRoute,
  }

const CompanyManagementLearnpathsOverviewLearnpathIdRouteWithChildren =
  CompanyManagementLearnpathsOverviewLearnpathIdRoute._addFileChildren(
    CompanyManagementLearnpathsOverviewLearnpathIdRouteChildren,
  )

interface CompanyManagementLearnpathsOverviewRouteChildren {
  CompanyManagementLearnpathsOverviewLearnpathIdRoute: typeof CompanyManagementLearnpathsOverviewLearnpathIdRouteWithChildren
}

const CompanyManagementLearnpathsOverviewRouteChildren: CompanyManagementLearnpathsOverviewRouteChildren =
  {
    CompanyManagementLearnpathsOverviewLearnpathIdRoute:
      CompanyManagementLearnpathsOverviewLearnpathIdRouteWithChildren,
  }

const CompanyManagementLearnpathsOverviewRouteWithChildren =
  CompanyManagementLearnpathsOverviewRoute._addFileChildren(
    CompanyManagementLearnpathsOverviewRouteChildren,
  )

interface CompanyManagementRouteRouteChildren {
  CompanyManagementIndexRouteRoute: typeof CompanyManagementIndexRouteRoute
  CompanyManagementActivitiesRouteRoute: typeof CompanyManagementActivitiesRouteRoute
  CompanyManagementAiAssistantRouteRoute: typeof CompanyManagementAiAssistantRouteRoute
  CompanyManagementAiAssistantDebugRouteRoute: typeof CompanyManagementAiAssistantDebugRouteRoute
  CompanyManagementAnalyticsRouteRoute: typeof CompanyManagementAnalyticsRouteRouteWithChildren
  CompanyManagementAuditLogRouteRoute: typeof CompanyManagementAuditLogRouteRoute
  CompanyManagementBatchOperationsRouteRoute: typeof CompanyManagementBatchOperationsRouteRouteWithChildren
  CompanyManagementEventsRouteRoute: typeof CompanyManagementEventsRouteRouteWithChildren
  CompanyManagementGroupsRouteRoute: typeof CompanyManagementGroupsRouteRouteWithChildren
  CompanyManagementLicensesStructureRouteRoute: typeof CompanyManagementLicensesStructureRouteRouteWithChildren
  CompanyManagementSettingsRouteRoute: typeof CompanyManagementSettingsRouteRouteWithChildren
  CompanyManagementUsersRouteRoute: typeof CompanyManagementUsersRouteRouteWithChildren
  CompanyManagementCoursesOverviewRoute: typeof CompanyManagementCoursesOverviewRouteWithChildren
  CompanyManagementInviteRoleRoute: typeof CompanyManagementInviteRoleRoute
  CompanyManagementLearnpathsOverviewRoute: typeof CompanyManagementLearnpathsOverviewRouteWithChildren
}

const CompanyManagementRouteRouteChildren: CompanyManagementRouteRouteChildren =
  {
    CompanyManagementIndexRouteRoute: CompanyManagementIndexRouteRoute,
    CompanyManagementActivitiesRouteRoute:
      CompanyManagementActivitiesRouteRoute,
    CompanyManagementAiAssistantRouteRoute:
      CompanyManagementAiAssistantRouteRoute,
    CompanyManagementAiAssistantDebugRouteRoute:
      CompanyManagementAiAssistantDebugRouteRoute,
    CompanyManagementAnalyticsRouteRoute:
      CompanyManagementAnalyticsRouteRouteWithChildren,
    CompanyManagementAuditLogRouteRoute: CompanyManagementAuditLogRouteRoute,
    CompanyManagementBatchOperationsRouteRoute:
      CompanyManagementBatchOperationsRouteRouteWithChildren,
    CompanyManagementEventsRouteRoute:
      CompanyManagementEventsRouteRouteWithChildren,
    CompanyManagementGroupsRouteRoute:
      CompanyManagementGroupsRouteRouteWithChildren,
    CompanyManagementLicensesStructureRouteRoute:
      CompanyManagementLicensesStructureRouteRouteWithChildren,
    CompanyManagementSettingsRouteRoute:
      CompanyManagementSettingsRouteRouteWithChildren,
    CompanyManagementUsersRouteRoute:
      CompanyManagementUsersRouteRouteWithChildren,
    CompanyManagementCoursesOverviewRoute:
      CompanyManagementCoursesOverviewRouteWithChildren,
    CompanyManagementInviteRoleRoute: CompanyManagementInviteRoleRoute,
    CompanyManagementLearnpathsOverviewRoute:
      CompanyManagementLearnpathsOverviewRouteWithChildren,
  }

const CompanyManagementRouteRouteWithChildren =
  CompanyManagementRouteRoute._addFileChildren(
    CompanyManagementRouteRouteChildren,
  )

interface CompanyMembersGroupsRouteRouteChildren {
  CompanyMembersGroupsAddGroupRoute: typeof CompanyMembersGroupsAddGroupRoute
}

const CompanyMembersGroupsRouteRouteChildren: CompanyMembersGroupsRouteRouteChildren =
  {
    CompanyMembersGroupsAddGroupRoute: CompanyMembersGroupsAddGroupRoute,
  }

const CompanyMembersGroupsRouteRouteWithChildren =
  CompanyMembersGroupsRouteRoute._addFileChildren(
    CompanyMembersGroupsRouteRouteChildren,
  )

interface CompanyLearnpathsAddElementsLearnpathIdfileCreateFileRouteChildren {
  CompanyLearnpathsAddElementsLearnpathIdfileCreateFileElementIdAssetIdRoute: typeof CompanyLearnpathsAddElementsLearnpathIdfileCreateFileElementIdAssetIdRoute
}

const CompanyLearnpathsAddElementsLearnpathIdfileCreateFileRouteChildren: CompanyLearnpathsAddElementsLearnpathIdfileCreateFileRouteChildren =
  {
    CompanyLearnpathsAddElementsLearnpathIdfileCreateFileElementIdAssetIdRoute:
      CompanyLearnpathsAddElementsLearnpathIdfileCreateFileElementIdAssetIdRoute,
  }

const CompanyLearnpathsAddElementsLearnpathIdfileCreateFileRouteWithChildren =
  CompanyLearnpathsAddElementsLearnpathIdfileCreateFileRoute._addFileChildren(
    CompanyLearnpathsAddElementsLearnpathIdfileCreateFileRouteChildren,
  )

interface CompanyLearnpathsAddElementsLearnpathIdplatformTopicCreatePlatformTopicRouteChildren {
  CompanyLearnpathsAddElementsLearnpathIdplatformTopicCreatePlatformTopicElementIdPreviewTopicIdLectureIdRoute: typeof CompanyLearnpathsAddElementsLearnpathIdplatformTopicCreatePlatformTopicElementIdPreviewTopicIdLectureIdRoute
}

const CompanyLearnpathsAddElementsLearnpathIdplatformTopicCreatePlatformTopicRouteChildren: CompanyLearnpathsAddElementsLearnpathIdplatformTopicCreatePlatformTopicRouteChildren =
  {
    CompanyLearnpathsAddElementsLearnpathIdplatformTopicCreatePlatformTopicElementIdPreviewTopicIdLectureIdRoute:
      CompanyLearnpathsAddElementsLearnpathIdplatformTopicCreatePlatformTopicElementIdPreviewTopicIdLectureIdRoute,
  }

const CompanyLearnpathsAddElementsLearnpathIdplatformTopicCreatePlatformTopicRouteWithChildren =
  CompanyLearnpathsAddElementsLearnpathIdplatformTopicCreatePlatformTopicRoute._addFileChildren(
    CompanyLearnpathsAddElementsLearnpathIdplatformTopicCreatePlatformTopicRouteChildren,
  )

interface CompanyLearnpathsAddElementsLearnpathIdvideoCreateVideoRouteChildren {
  CompanyLearnpathsAddElementsLearnpathIdvideoCreateVideoElementIdAssetIdRoute: typeof CompanyLearnpathsAddElementsLearnpathIdvideoCreateVideoElementIdAssetIdRoute
}

const CompanyLearnpathsAddElementsLearnpathIdvideoCreateVideoRouteChildren: CompanyLearnpathsAddElementsLearnpathIdvideoCreateVideoRouteChildren =
  {
    CompanyLearnpathsAddElementsLearnpathIdvideoCreateVideoElementIdAssetIdRoute:
      CompanyLearnpathsAddElementsLearnpathIdvideoCreateVideoElementIdAssetIdRoute,
  }

const CompanyLearnpathsAddElementsLearnpathIdvideoCreateVideoRouteWithChildren =
  CompanyLearnpathsAddElementsLearnpathIdvideoCreateVideoRoute._addFileChildren(
    CompanyLearnpathsAddElementsLearnpathIdvideoCreateVideoRouteChildren,
  )

interface CompanyLearnpathsAddElementsLearnpathIdfileUpdateFileElementIdRouteChildren {
  CompanyLearnpathsAddElementsLearnpathIdfileUpdateFileElementIdAssetIdRoute: typeof CompanyLearnpathsAddElementsLearnpathIdfileUpdateFileElementIdAssetIdRoute
}

const CompanyLearnpathsAddElementsLearnpathIdfileUpdateFileElementIdRouteChildren: CompanyLearnpathsAddElementsLearnpathIdfileUpdateFileElementIdRouteChildren =
  {
    CompanyLearnpathsAddElementsLearnpathIdfileUpdateFileElementIdAssetIdRoute:
      CompanyLearnpathsAddElementsLearnpathIdfileUpdateFileElementIdAssetIdRoute,
  }

const CompanyLearnpathsAddElementsLearnpathIdfileUpdateFileElementIdRouteWithChildren =
  CompanyLearnpathsAddElementsLearnpathIdfileUpdateFileElementIdRoute._addFileChildren(
    CompanyLearnpathsAddElementsLearnpathIdfileUpdateFileElementIdRouteChildren,
  )

interface CompanyLearnpathsAddElementsLearnpathIdplatformTopicUpdatePlatformTopicElementIdRouteChildren {
  CompanyLearnpathsAddElementsLearnpathIdplatformTopicUpdatePlatformTopicElementIdPreviewTopicIdLectureIdRoute: typeof CompanyLearnpathsAddElementsLearnpathIdplatformTopicUpdatePlatformTopicElementIdPreviewTopicIdLectureIdRoute
}

const CompanyLearnpathsAddElementsLearnpathIdplatformTopicUpdatePlatformTopicElementIdRouteChildren: CompanyLearnpathsAddElementsLearnpathIdplatformTopicUpdatePlatformTopicElementIdRouteChildren =
  {
    CompanyLearnpathsAddElementsLearnpathIdplatformTopicUpdatePlatformTopicElementIdPreviewTopicIdLectureIdRoute:
      CompanyLearnpathsAddElementsLearnpathIdplatformTopicUpdatePlatformTopicElementIdPreviewTopicIdLectureIdRoute,
  }

const CompanyLearnpathsAddElementsLearnpathIdplatformTopicUpdatePlatformTopicElementIdRouteWithChildren =
  CompanyLearnpathsAddElementsLearnpathIdplatformTopicUpdatePlatformTopicElementIdRoute._addFileChildren(
    CompanyLearnpathsAddElementsLearnpathIdplatformTopicUpdatePlatformTopicElementIdRouteChildren,
  )

interface CompanyLearnpathsAddElementsLearnpathIdvideoUpdateVideoElementIdRouteChildren {
  CompanyLearnpathsAddElementsLearnpathIdvideoUpdateVideoElementIdAssetIdRoute: typeof CompanyLearnpathsAddElementsLearnpathIdvideoUpdateVideoElementIdAssetIdRoute
}

const CompanyLearnpathsAddElementsLearnpathIdvideoUpdateVideoElementIdRouteChildren: CompanyLearnpathsAddElementsLearnpathIdvideoUpdateVideoElementIdRouteChildren =
  {
    CompanyLearnpathsAddElementsLearnpathIdvideoUpdateVideoElementIdAssetIdRoute:
      CompanyLearnpathsAddElementsLearnpathIdvideoUpdateVideoElementIdAssetIdRoute,
  }

const CompanyLearnpathsAddElementsLearnpathIdvideoUpdateVideoElementIdRouteWithChildren =
  CompanyLearnpathsAddElementsLearnpathIdvideoUpdateVideoElementIdRoute._addFileChildren(
    CompanyLearnpathsAddElementsLearnpathIdvideoUpdateVideoElementIdRouteChildren,
  )

interface CompanyLearnpathsAddElementsLearnpathIdRouteRouteChildren {
  CompanyLearnpathsAddElementsLearnpathIdembeddedVideoCreateEmbeddedVideoRoute: typeof CompanyLearnpathsAddElementsLearnpathIdembeddedVideoCreateEmbeddedVideoRoute
  CompanyLearnpathsAddElementsLearnpathIdeventCreateEventRoute: typeof CompanyLearnpathsAddElementsLearnpathIdeventCreateEventRoute
  CompanyLearnpathsAddElementsLearnpathIdfileCreateFileRoute: typeof CompanyLearnpathsAddElementsLearnpathIdfileCreateFileRouteWithChildren
  CompanyLearnpathsAddElementsLearnpathIdlinkCreateLinkRoute: typeof CompanyLearnpathsAddElementsLearnpathIdlinkCreateLinkRoute
  CompanyLearnpathsAddElementsLearnpathIdplatformTopicCreatePlatformTopicRoute: typeof CompanyLearnpathsAddElementsLearnpathIdplatformTopicCreatePlatformTopicRouteWithChildren
  CompanyLearnpathsAddElementsLearnpathIdquizCreateQuizRoute: typeof CompanyLearnpathsAddElementsLearnpathIdquizCreateQuizRoute
  CompanyLearnpathsAddElementsLearnpathIdscormCreateScormRoute: typeof CompanyLearnpathsAddElementsLearnpathIdscormCreateScormRoute
  CompanyLearnpathsAddElementsLearnpathIdtextCreateTextRoute: typeof CompanyLearnpathsAddElementsLearnpathIdtextCreateTextRoute
  CompanyLearnpathsAddElementsLearnpathIdvideoCreateVideoRoute: typeof CompanyLearnpathsAddElementsLearnpathIdvideoCreateVideoRouteWithChildren
  CompanyLearnpathsAddElementsLearnpathIdembeddedVideoDeleteEmbeddedVideoElementIdRoute: typeof CompanyLearnpathsAddElementsLearnpathIdembeddedVideoDeleteEmbeddedVideoElementIdRoute
  CompanyLearnpathsAddElementsLearnpathIdembeddedVideoUpdateEmbeddedVideoElementIdRoute: typeof CompanyLearnpathsAddElementsLearnpathIdembeddedVideoUpdateEmbeddedVideoElementIdRoute
  CompanyLearnpathsAddElementsLearnpathIdeventDeleteEventElementIdRoute: typeof CompanyLearnpathsAddElementsLearnpathIdeventDeleteEventElementIdRoute
  CompanyLearnpathsAddElementsLearnpathIdeventUpdateEventElementIdRoute: typeof CompanyLearnpathsAddElementsLearnpathIdeventUpdateEventElementIdRoute
  CompanyLearnpathsAddElementsLearnpathIdfileDeleteFileElementIdRoute: typeof CompanyLearnpathsAddElementsLearnpathIdfileDeleteFileElementIdRoute
  CompanyLearnpathsAddElementsLearnpathIdfileUpdateFileElementIdRoute: typeof CompanyLearnpathsAddElementsLearnpathIdfileUpdateFileElementIdRouteWithChildren
  CompanyLearnpathsAddElementsLearnpathIdlinkDeleteLinkElementIdRoute: typeof CompanyLearnpathsAddElementsLearnpathIdlinkDeleteLinkElementIdRoute
  CompanyLearnpathsAddElementsLearnpathIdlinkUpdateLinkElementIdRoute: typeof CompanyLearnpathsAddElementsLearnpathIdlinkUpdateLinkElementIdRoute
  CompanyLearnpathsAddElementsLearnpathIdplatformTopicDeletePlatformTopicElementIdRoute: typeof CompanyLearnpathsAddElementsLearnpathIdplatformTopicDeletePlatformTopicElementIdRoute
  CompanyLearnpathsAddElementsLearnpathIdplatformTopicUpdatePlatformTopicElementIdRoute: typeof CompanyLearnpathsAddElementsLearnpathIdplatformTopicUpdatePlatformTopicElementIdRouteWithChildren
  CompanyLearnpathsAddElementsLearnpathIdquizDeleteQuizElementIdRoute: typeof CompanyLearnpathsAddElementsLearnpathIdquizDeleteQuizElementIdRoute
  CompanyLearnpathsAddElementsLearnpathIdquizUpdateQuizElementIdRoute: typeof CompanyLearnpathsAddElementsLearnpathIdquizUpdateQuizElementIdRoute
  CompanyLearnpathsAddElementsLearnpathIdscormDeleteScormElementIdRoute: typeof CompanyLearnpathsAddElementsLearnpathIdscormDeleteScormElementIdRoute
  CompanyLearnpathsAddElementsLearnpathIdscormUpdateScormElementIdRoute: typeof CompanyLearnpathsAddElementsLearnpathIdscormUpdateScormElementIdRoute
  CompanyLearnpathsAddElementsLearnpathIdtextDeleteTextElementIdRoute: typeof CompanyLearnpathsAddElementsLearnpathIdtextDeleteTextElementIdRoute
  CompanyLearnpathsAddElementsLearnpathIdtextUpdateTextElementIdRoute: typeof CompanyLearnpathsAddElementsLearnpathIdtextUpdateTextElementIdRoute
  CompanyLearnpathsAddElementsLearnpathIdvideoDeleteVideoElementIdRoute: typeof CompanyLearnpathsAddElementsLearnpathIdvideoDeleteVideoElementIdRoute
  CompanyLearnpathsAddElementsLearnpathIdvideoUpdateVideoElementIdRoute: typeof CompanyLearnpathsAddElementsLearnpathIdvideoUpdateVideoElementIdRouteWithChildren
}

const CompanyLearnpathsAddElementsLearnpathIdRouteRouteChildren: CompanyLearnpathsAddElementsLearnpathIdRouteRouteChildren =
  {
    CompanyLearnpathsAddElementsLearnpathIdembeddedVideoCreateEmbeddedVideoRoute:
      CompanyLearnpathsAddElementsLearnpathIdembeddedVideoCreateEmbeddedVideoRoute,
    CompanyLearnpathsAddElementsLearnpathIdeventCreateEventRoute:
      CompanyLearnpathsAddElementsLearnpathIdeventCreateEventRoute,
    CompanyLearnpathsAddElementsLearnpathIdfileCreateFileRoute:
      CompanyLearnpathsAddElementsLearnpathIdfileCreateFileRouteWithChildren,
    CompanyLearnpathsAddElementsLearnpathIdlinkCreateLinkRoute:
      CompanyLearnpathsAddElementsLearnpathIdlinkCreateLinkRoute,
    CompanyLearnpathsAddElementsLearnpathIdplatformTopicCreatePlatformTopicRoute:
      CompanyLearnpathsAddElementsLearnpathIdplatformTopicCreatePlatformTopicRouteWithChildren,
    CompanyLearnpathsAddElementsLearnpathIdquizCreateQuizRoute:
      CompanyLearnpathsAddElementsLearnpathIdquizCreateQuizRoute,
    CompanyLearnpathsAddElementsLearnpathIdscormCreateScormRoute:
      CompanyLearnpathsAddElementsLearnpathIdscormCreateScormRoute,
    CompanyLearnpathsAddElementsLearnpathIdtextCreateTextRoute:
      CompanyLearnpathsAddElementsLearnpathIdtextCreateTextRoute,
    CompanyLearnpathsAddElementsLearnpathIdvideoCreateVideoRoute:
      CompanyLearnpathsAddElementsLearnpathIdvideoCreateVideoRouteWithChildren,
    CompanyLearnpathsAddElementsLearnpathIdembeddedVideoDeleteEmbeddedVideoElementIdRoute:
      CompanyLearnpathsAddElementsLearnpathIdembeddedVideoDeleteEmbeddedVideoElementIdRoute,
    CompanyLearnpathsAddElementsLearnpathIdembeddedVideoUpdateEmbeddedVideoElementIdRoute:
      CompanyLearnpathsAddElementsLearnpathIdembeddedVideoUpdateEmbeddedVideoElementIdRoute,
    CompanyLearnpathsAddElementsLearnpathIdeventDeleteEventElementIdRoute:
      CompanyLearnpathsAddElementsLearnpathIdeventDeleteEventElementIdRoute,
    CompanyLearnpathsAddElementsLearnpathIdeventUpdateEventElementIdRoute:
      CompanyLearnpathsAddElementsLearnpathIdeventUpdateEventElementIdRoute,
    CompanyLearnpathsAddElementsLearnpathIdfileDeleteFileElementIdRoute:
      CompanyLearnpathsAddElementsLearnpathIdfileDeleteFileElementIdRoute,
    CompanyLearnpathsAddElementsLearnpathIdfileUpdateFileElementIdRoute:
      CompanyLearnpathsAddElementsLearnpathIdfileUpdateFileElementIdRouteWithChildren,
    CompanyLearnpathsAddElementsLearnpathIdlinkDeleteLinkElementIdRoute:
      CompanyLearnpathsAddElementsLearnpathIdlinkDeleteLinkElementIdRoute,
    CompanyLearnpathsAddElementsLearnpathIdlinkUpdateLinkElementIdRoute:
      CompanyLearnpathsAddElementsLearnpathIdlinkUpdateLinkElementIdRoute,
    CompanyLearnpathsAddElementsLearnpathIdplatformTopicDeletePlatformTopicElementIdRoute:
      CompanyLearnpathsAddElementsLearnpathIdplatformTopicDeletePlatformTopicElementIdRoute,
    CompanyLearnpathsAddElementsLearnpathIdplatformTopicUpdatePlatformTopicElementIdRoute:
      CompanyLearnpathsAddElementsLearnpathIdplatformTopicUpdatePlatformTopicElementIdRouteWithChildren,
    CompanyLearnpathsAddElementsLearnpathIdquizDeleteQuizElementIdRoute:
      CompanyLearnpathsAddElementsLearnpathIdquizDeleteQuizElementIdRoute,
    CompanyLearnpathsAddElementsLearnpathIdquizUpdateQuizElementIdRoute:
      CompanyLearnpathsAddElementsLearnpathIdquizUpdateQuizElementIdRoute,
    CompanyLearnpathsAddElementsLearnpathIdscormDeleteScormElementIdRoute:
      CompanyLearnpathsAddElementsLearnpathIdscormDeleteScormElementIdRoute,
    CompanyLearnpathsAddElementsLearnpathIdscormUpdateScormElementIdRoute:
      CompanyLearnpathsAddElementsLearnpathIdscormUpdateScormElementIdRoute,
    CompanyLearnpathsAddElementsLearnpathIdtextDeleteTextElementIdRoute:
      CompanyLearnpathsAddElementsLearnpathIdtextDeleteTextElementIdRoute,
    CompanyLearnpathsAddElementsLearnpathIdtextUpdateTextElementIdRoute:
      CompanyLearnpathsAddElementsLearnpathIdtextUpdateTextElementIdRoute,
    CompanyLearnpathsAddElementsLearnpathIdvideoDeleteVideoElementIdRoute:
      CompanyLearnpathsAddElementsLearnpathIdvideoDeleteVideoElementIdRoute,
    CompanyLearnpathsAddElementsLearnpathIdvideoUpdateVideoElementIdRoute:
      CompanyLearnpathsAddElementsLearnpathIdvideoUpdateVideoElementIdRouteWithChildren,
  }

const CompanyLearnpathsAddElementsLearnpathIdRouteRouteWithChildren =
  CompanyLearnpathsAddElementsLearnpathIdRouteRoute._addFileChildren(
    CompanyLearnpathsAddElementsLearnpathIdRouteRouteChildren,
  )

interface CompanyLearnpathsAddRouteChildren {
  CompanyLearnpathsAddGeneralInformationCourseRoute: typeof CompanyLearnpathsAddGeneralInformationCourseRoute
  CompanyLearnpathsAddElementsLearnpathIdRouteRoute: typeof CompanyLearnpathsAddElementsLearnpathIdRouteRouteWithChildren
  CompanyLearnpathsAddCompletionTimeLearnpathIdRoute: typeof CompanyLearnpathsAddCompletionTimeLearnpathIdRoute
  CompanyLearnpathsAddGeneralInformationLearnpathIdRoute: typeof CompanyLearnpathsAddGeneralInformationLearnpathIdRoute
  CompanyLearnpathsAddLearnersLearnpathIdRoute: typeof CompanyLearnpathsAddLearnersLearnpathIdRoute
  CompanyLearnpathsAddGeneralInformationIndexRoute: typeof CompanyLearnpathsAddGeneralInformationIndexRoute
}

const CompanyLearnpathsAddRouteChildren: CompanyLearnpathsAddRouteChildren = {
  CompanyLearnpathsAddGeneralInformationCourseRoute:
    CompanyLearnpathsAddGeneralInformationCourseRoute,
  CompanyLearnpathsAddElementsLearnpathIdRouteRoute:
    CompanyLearnpathsAddElementsLearnpathIdRouteRouteWithChildren,
  CompanyLearnpathsAddCompletionTimeLearnpathIdRoute:
    CompanyLearnpathsAddCompletionTimeLearnpathIdRoute,
  CompanyLearnpathsAddGeneralInformationLearnpathIdRoute:
    CompanyLearnpathsAddGeneralInformationLearnpathIdRoute,
  CompanyLearnpathsAddLearnersLearnpathIdRoute:
    CompanyLearnpathsAddLearnersLearnpathIdRoute,
  CompanyLearnpathsAddGeneralInformationIndexRoute:
    CompanyLearnpathsAddGeneralInformationIndexRoute,
}

const CompanyLearnpathsAddRouteWithChildren =
  CompanyLearnpathsAddRoute._addFileChildren(CompanyLearnpathsAddRouteChildren)

interface CompanyRouteRouteChildren {
  CompanyManagementRouteRoute: typeof CompanyManagementRouteRouteWithChildren
  CompanyMembersGroupsRouteRoute: typeof CompanyMembersGroupsRouteRouteWithChildren
  CompanyLearnpathsAddRoute: typeof CompanyLearnpathsAddRouteWithChildren
}

const CompanyRouteRouteChildren: CompanyRouteRouteChildren = {
  CompanyManagementRouteRoute: CompanyManagementRouteRouteWithChildren,
  CompanyMembersGroupsRouteRoute: CompanyMembersGroupsRouteRouteWithChildren,
  CompanyLearnpathsAddRoute: CompanyLearnpathsAddRouteWithChildren,
}

const CompanyRouteRouteWithChildren = CompanyRouteRoute._addFileChildren(
  CompanyRouteRouteChildren,
)

interface SignupRouteRouteChildren {
  SignupSlugRoute: typeof SignupSlugRoute
  SignupEmailRoute: typeof SignupEmailRoute
  SignupPollRoute: typeof SignupPollRoute
  SignupProfileRoute: typeof SignupProfileRoute
  SignupCredentialsChar123UuidChar125Route: typeof SignupCredentialsChar123UuidChar125Route
  SignupWelcomeChar123UuidChar125Route: typeof SignupWelcomeChar123UuidChar125Route
}

const SignupRouteRouteChildren: SignupRouteRouteChildren = {
  SignupSlugRoute: SignupSlugRoute,
  SignupEmailRoute: SignupEmailRoute,
  SignupPollRoute: SignupPollRoute,
  SignupProfileRoute: SignupProfileRoute,
  SignupCredentialsChar123UuidChar125Route:
    SignupCredentialsChar123UuidChar125Route,
  SignupWelcomeChar123UuidChar125Route: SignupWelcomeChar123UuidChar125Route,
}

const SignupRouteRouteWithChildren = SignupRouteRoute._addFileChildren(
  SignupRouteRouteChildren,
)

interface SkillsAssessmentRouteRouteChildren {
  SkillsAssessmentPollDynamicRoute: typeof SkillsAssessmentPollDynamicRoute
  SkillsAssessmentPollStaticRoute: typeof SkillsAssessmentPollStaticRoute
  SkillsAssessmentResultsFinalRoute: typeof SkillsAssessmentResultsFinalRoute
  SkillsAssessmentResultsInitialRoute: typeof SkillsAssessmentResultsInitialRoute
  SkillsAssessmentWelcomeRoute: typeof SkillsAssessmentWelcomeRoute
  SkillsAssessmentIndexRoute: typeof SkillsAssessmentIndexRoute
}

const SkillsAssessmentRouteRouteChildren: SkillsAssessmentRouteRouteChildren = {
  SkillsAssessmentPollDynamicRoute: SkillsAssessmentPollDynamicRoute,
  SkillsAssessmentPollStaticRoute: SkillsAssessmentPollStaticRoute,
  SkillsAssessmentResultsFinalRoute: SkillsAssessmentResultsFinalRoute,
  SkillsAssessmentResultsInitialRoute: SkillsAssessmentResultsInitialRoute,
  SkillsAssessmentWelcomeRoute: SkillsAssessmentWelcomeRoute,
  SkillsAssessmentIndexRoute: SkillsAssessmentIndexRoute,
}

const SkillsAssessmentRouteRouteWithChildren =
  SkillsAssessmentRouteRoute._addFileChildren(
    SkillsAssessmentRouteRouteChildren,
  )

interface UserSettingsRouteRouteChildren {
  UserSettingsGeneralSettingsRoute: typeof UserSettingsGeneralSettingsRoute
  UserSettingsPersonalDataRoute: typeof UserSettingsPersonalDataRoute
  UserSettingsSecurityRoute: typeof UserSettingsSecurityRoute
}

const UserSettingsRouteRouteChildren: UserSettingsRouteRouteChildren = {
  UserSettingsGeneralSettingsRoute: UserSettingsGeneralSettingsRoute,
  UserSettingsPersonalDataRoute: UserSettingsPersonalDataRoute,
  UserSettingsSecurityRoute: UserSettingsSecurityRoute,
}

const UserSettingsRouteRouteWithChildren =
  UserSettingsRouteRoute._addFileChildren(UserSettingsRouteRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  LearningRouteRoute: LearningRouteRouteWithChildren,
  CompanyRouteRoute: CompanyRouteRouteWithChildren,
  CoreSkillsAssessmentRouteRoute: CoreSkillsAssessmentRouteRoute,
  SignupRouteRoute: SignupRouteRouteWithChildren,
  SkillsAssessmentRouteRoute: SkillsAssessmentRouteRouteWithChildren,
  UserSettingsRouteRoute: UserSettingsRouteRouteWithChildren,
  ConsentsConsentKeyRoute: ConsentsConsentKeyRoute,
  LoginSsoSourceIdRoute: LoginSsoSourceIdRoute,
  RegistrationSsoSourceIdRoute: RegistrationSsoSourceIdRoute,
  LoginIndexRoute: LoginIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
